import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Represented by ISO 8601 formatted strings */
  Date: string;
  URL: string;
  /** Emoji custom scalar type */
  Emoji: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: string;
};

export type AcceptInvitationResult =
  | CircleInviteResult
  | OrgInviteResult
  | AdminInviteResult
  | InviteDoesNotExist
  | InvitationAlreadyAccepted
  | InviteRequiresAccountCustomAuthentication;

export type Account = {
  __typename: 'Account';
  id: Scalars['String'];
  name: Scalars['String'];
  type: AccountType;
  /** Empty string means caller doesn't have access to this value */
  owner: Scalars['String'];
  status: AccountStatus;
  deletionDate?: Maybe<Scalars['String']>;
  allowInvitesWithoutEmail?: Maybe<Scalars['Boolean']>;
  trialActive?: Maybe<Scalars['Boolean']>;
  trialStartDate?: Maybe<Scalars['Boolean']>;
  trialEndDate?: Maybe<Scalars['Boolean']>;
  trialStartedBy?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  products: Array<Products>;
  features?: Maybe<Array<Maybe<Features>>>;
  logo?: Maybe<Scalars['String']>;
  patientMappings: Array<PatientMapping>;
  skillSpringCoachingConfigs: Array<SkillSpringCoachingConfig>;
  primaryCircleId?: Maybe<Scalars['ID']>;
  primaryCircle?: Maybe<Circle>;
  accountSettings?: Maybe<AccountSettings>;
};

export type AccountServiceUserPrivacyPreferences = {
  __typename: 'AccountServiceUserPrivacyPreferences';
  ORGANIZATIONS?: Maybe<PrivacyPreferenceSetting>;
};

export type AccountServiceUserPrivacyPreferencesIn = {
  ORGANIZATIONS?: Maybe<PrivacyPreferenceSetting>;
};

export type AccountSettings = {
  __typename: 'AccountSettings';
  subsidies?: Maybe<Array<Subsidy>>;
};

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED',
}

export enum AccountType {
  FREE = 'FREE',
  PAID = 'PAID',
  ENTERPRISE = 'ENTERPRISE',
}

export type AccountUsersConnection = {
  __typename: 'AccountUsersConnection';
  edges: Array<AccountUsersEdge>;
  pageInfo: PageInfo;
};

export type AccountUsersEdge = {
  __typename: 'AccountUsersEdge';
  node: User;
};

export type ActivePost = Post & {
  __typename: 'ActivePost';
  id: Scalars['ID'];
  authorId?: Maybe<Scalars['String']>;
  replies: PostConnection;
  message?: Maybe<Scalars['String']>;
  attachments: Array<Scalars['String']>;
  attachmentsV2: AttachmentConnection;
  parentId: Scalars['ID'];
  parentPost?: Maybe<Post>;
  rootParentId: Scalars['ID'];
  originalPostId: Scalars['ID'];
  originalPost: Post;
  createdAt: Scalars['Date'];
  lastModifiedAt?: Maybe<Scalars['Date']>;
  reactionTotals: Array<ReactionTotal>;
  popularity: Scalars['Int'];
  replyCount: Scalars['Int'];
  systemGenerated: Scalars['Boolean'];
  metadata?: Maybe<Scalars['String']>;
  priority?: Maybe<Priority>;
  status: PostStatus;
  /**  Optional. When true this post is hidden in Life apps. Null or false is ignored.  */
  blockedContent?: Maybe<Scalars['Boolean']>;
  content?: Maybe<PostContent>;
  author?: Maybe<User>;
  circle?: Maybe<Circle>;
};

export type ActivePostrepliesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  order?: Maybe<PostOrder>;
  deletedStatus?: Maybe<DeletedStatus>;
};

export type ActivePostattachmentsV2Args = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type ActivePostreactionTotalsArgs = {
  includeCustomReactions?: Maybe<Scalars['Boolean']>;
};

export type ActiveVideo = Video & {
  __typename: 'ActiveVideo';
  id: Scalars['ID'];
  owner: Scalars['String'];
  manifests?: Maybe<Manifests>;
  thumbnails: Array<Thumbnail>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionShort?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  tags: Tags;
};

export type Address = {
  __typename: 'Address';
  use?: Maybe<AddressUse>;
  type?: Maybe<AddressType>;
  text?: Maybe<Scalars['String']>;
  line?: Maybe<Array<Scalars['String']>>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  period?: Maybe<Period>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type AddressIn = {
  use?: Maybe<AddressUse>;
  type?: Maybe<AddressType>;
  text?: Maybe<Scalars['String']>;
  line?: Maybe<Array<Scalars['String']>>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  period?: Maybe<PeriodIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum AddressType {
  postal = 'postal',
  physical = 'physical',
  both = 'both',
}

export enum AddressUse {
  home = 'home',
  work = 'work',
  temp = 'temp',
  old = 'old',
}

export type AdminDeleteCircleInput = {
  id: Scalars['ID'];
  owningUserId: Scalars['ID'];
  owningAccountId?: Maybe<Scalars['ID']>;
};

export type AdminInviteResult = {
  __typename: 'AdminInviteResult';
  circle: Circle;
};

export type Age = {
  __typename: 'Age';
  minimum?: Maybe<Scalars['Int']>;
  maximum?: Maybe<Scalars['Int']>;
};

export enum AgeComparator {
  LT = 'LT',
  LTE = 'LTE',
  GTE = 'GTE',
  GT = 'GT',
}

export type AgeIn = {
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<AgeComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type AgeRestriction = {
  __typename: 'AgeRestriction';
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
};

export type AgeRestrictionInput = {
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
};

export type Annotation = {
  __typename: 'Annotation';
  authorReference?: Maybe<Reference>;
  authorString?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type AnnotationIn = {
  authorReference?: Maybe<ReferenceIn>;
  authorString?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum AppEnum {
  LIFE = 'LIFE',
  LX = 'LX',
  LR = 'LR',
}

export type AppLocale = {
  langCode: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export enum Apps {
  Fasting = 'Fasting',
  Extend = 'Extend',
  Research = 'Research',
}

export type AppStoreApplication = {
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['URL']>;
  product: AppStoreProduct;
  authorId: Scalars['String'];
  abacResource?: Maybe<Scalars['String']>;
  /** Optional display string - used to display the author if not LifeOmic */
  authorDisplay?: Maybe<Scalars['String']>;
  author: User;
};

export type AppStoreApplicationConnection = {
  __typename: 'AppStoreApplicationConnection';
  edges: Array<AppStoreApplicationEdge>;
  pageInfo: PageInfo;
};

export type AppStoreApplicationEdge = {
  __typename: 'AppStoreApplicationEdge';
  node: AppStoreApplication;
};

export enum AppStoreProduct {
  LX = 'LX',
}

/** a basic app meant to simply be loaded in a browser */
export type AppStoreWebApplication = AppStoreApplication & {
  __typename: 'AppStoreWebApplication';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['URL']>;
  product: AppStoreProduct;
  authorId: Scalars['String'];
  abacResource?: Maybe<Scalars['String']>;
  /** Optional display string - used to display the author if not LifeOmic */
  authorDisplay?: Maybe<Scalars['String']>;
  url: Scalars['URL'];
  author: User;
};

export type Attachment = {
  __typename: 'Attachment';
  id: Scalars['ID'];
  externalId: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  originalUrl?: Maybe<Scalars['String']>;
  type: AttachmentType;
  subType: Scalars['String'];
  thumbnails: Array<Scalars['String']>;
  parentId: Scalars['ID'];
  parentType: ParentType;
  rootParentId: Scalars['ID'];
  authorId: Scalars['ID'];
  account: Scalars['ID'];
  status: AttachmentStatus;
  fileName?: Maybe<Scalars['String']>;
};

export type AttachmentConnection = {
  __typename: 'AttachmentConnection';
  edges: Array<AttachmentEdge>;
  pageInfo: PageInfo;
};

export type AttachmentEdge = {
  __typename: 'AttachmentEdge';
  node: Attachment;
};

export type AttachmentFilter = {
  parentId: Scalars['ID'];
  parentType: ParentType;
};

export type AttachmentIn = {
  contentType?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  hash?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  creation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum AttachmentStatus {
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  ERROR = 'ERROR',
}

export enum AttachmentType {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  EVENT = 'EVENT',
  PDF = 'PDF',
}

export type BackboneElement = {
  __typename: 'BackboneElement';
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type BackboneElementIn = {
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum BiologicalSex {
  male = 'male',
  female = 'female',
  other = 'other',
}

export type BiologicalSexRestriction = {
  __typename: 'BiologicalSexRestriction';
  allowed: Array<BiologicalSex>;
};

export type BiologicalSexRestrictionInput = {
  allowed?: Maybe<Array<BiologicalSex>>;
};

export type BlockedUser = {
  __typename: 'BlockedUser';
  userId: Scalars['String'];
};

export type BlockedUserConnection = {
  __typename: 'BlockedUserConnection';
  edges: Array<BlockedUserEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type BlockedUserEdge = {
  __typename: 'BlockedUserEdge';
  node: BlockedUser;
};

export type BlockInappropriatePostInput = {
  postId: Scalars['ID'];
};

export type BlockPostPayload = {
  __typename: 'BlockPostPayload';
  post: ActivePost;
};

export enum CacheControlScope {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export enum CalendarInterval {
  minute = 'minute',
  hour = 'hour',
  day = 'day',
  week = 'week',
  month = 'month',
  quarter = 'quarter',
  yearly = 'yearly',
}

export type ChallengeRaffleWinnersPostNotification = Notification & {
  __typename: 'ChallengeRaffleWinnersPostNotification';
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  circleId: Scalars['ID'];
  postId: Scalars['ID'];
};

export type ChallengeStartedPostNotification = Notification & {
  __typename: 'ChallengeStartedPostNotification';
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  circleId: Scalars['ID'];
  postId: Scalars['ID'];
};

export type ChallengeWinnersPostNotification = Notification & {
  __typename: 'ChallengeWinnersPostNotification';
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  circleId: Scalars['ID'];
  postId: Scalars['ID'];
};

export type Circle = {
  __typename: 'Circle';
  id: Scalars['ID'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  owner: User;
  /**
   * Returns connection of users who have elevated privileges in the Circle. This will include owner.
   * Though a connection, does not actually paginate.
   */
  managingGroups: CircleManagingGroupsConnection;
  owningAccountId?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['URL']>;
  type: CircleType;
  isMember: Scalars['Boolean'];
  disabledUpdateTypes?: Maybe<Array<Scalars['String']>>;
  restrictions?: Maybe<CircleRestrictions>;
  purpose?: Maybe<CirclePurpose>;
  /** Preferred language is the circle creators expected, primary language for the circle */
  preferredLanguage?: Maybe<Scalars['String']>;
  /** List of topics of what are the main priorities/interests of the group, will help with search */
  topicFocus: Array<CircleTopicFocus>;
  /**
   * General area that the Circle owner would hope/expect members to be located in.
   * Used is for general info, does not restrict membership.
   * Specified at the level of region (e.g., country, state/providence, city, or postal code level etc.).
   */
  geographicalArea?: Maybe<Scalars['String']>;
  updatesConnection: UpdatesForSingleCircleConnection;
  membersConnection: CircleMembersConnection;
  account: Account;
  owningAccount?: Maybe<Account>;
  posts: PostConnection;
  postsV2: PostConnection;
  forumSettings?: Maybe<ForumSettings>;
  subscription?: Maybe<CircleSubscription>;
  skillSpringConfig?: Maybe<SkillSpringCircleConfig>;
};

export type CircleupdatesConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type CirclemembersConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  activeUsersOnly?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['String']>;
};

export type CirclepostsArgs = {
  order?: Maybe<PostOrder>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type CirclepostsV2Args = {
  order?: Maybe<PostOrder>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type CircleAdminPostNotification = Notification & {
  __typename: 'CircleAdminPostNotification';
  post: Post;
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  authorId: Scalars['ID'];
  circleId: Scalars['ID'];
  postId: Scalars['ID'];
};

export type CircleAnnouncementNotification = Notification & {
  __typename: 'CircleAnnouncementNotification';
  id: Scalars['ID'];
  update: Update;
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  circleId: Scalars['ID'];
  fullText: Scalars['String'];
  circle?: Maybe<Circle>;
};

export type CircleCreationInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<CircleType>;
  restrictions?: Maybe<CircleRestrictionsInput>;
  /** Preferred language is the circle creators expected, primary language for the circle */
  preferredLanguage?: Maybe<Scalars['String']>;
  /** List of topics of what are the main priorities/interests of the group, will help with search */
  topicFocus?: Maybe<Array<CircleTopicFocus>>;
  /** General area that the Circle owner would hope/expect members to be located in as any text. */
  geographicalArea?: Maybe<Scalars['String']>;
  forumSettings?: Maybe<CircleForumSettingsInput>;
  subscription?: Maybe<CircleSubscriptionInput>;
};

export type CircleEditInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type CircleForumSettingsInput = {
  userSettings?: Maybe<UserSettingsInput>;
  notificationSettings?: Maybe<NotificationSettingsInput>;
};

export type CircleInviteResult = {
  __typename: 'CircleInviteResult';
  circle: Circle;
};

export type CircleManagingGroupsConnection = {
  __typename: 'CircleManagingGroupsConnection';
  edges: Array<CircleManagingGroupsEdge>;
  pageInfo: PageInfo;
};

export type CircleManagingGroupsEdge = {
  __typename: 'CircleManagingGroupsEdge';
  role: CircleManagingGroupsUserRole;
  node: User;
};

export enum CircleManagingGroupsUserRole {
  admin = 'admin',
}

export type CircleMembersConnection = {
  __typename: 'CircleMembersConnection';
  edges: Array<CircleMembersEdge>;
  pageInfo: PageInfo;
};

export type CircleMembersEdge = {
  __typename: 'CircleMembersEdge';
  fastId?: Maybe<Scalars['ID']>;
  node: User;
  userId: Scalars['ID'];
};

export type CircleOperations = {
  __typename: 'CircleOperations';
  circle: Circle;
  /** @deprecated use removeFromCircle */
  removeUser: Scalars['Boolean'];
  /** @deprecated use editCircle for editing, use deleteCircle for deleting */
  edit?: Maybe<Circle>;
  circleImageUploadUrl: Scalars['URL'];
  changeOwner: Scalars['Boolean'];
  /** @deprecated use top level createInvitation instead */
  createInvitation: Invitation;
};

export type CircleOperationsremoveUserArgs = {
  userId: Scalars['ID'];
};

export type CircleOperationseditArgs = {
  input?: Maybe<CircleEditInput>;
};

export type CircleOperationscircleImageUploadUrlArgs = {
  imageType: ImageType;
};

export type CircleOperationschangeOwnerArgs = {
  newOwner: Scalars['ID'];
};

export type CircleOwnerStripeAccountLink = {
  __typename: 'CircleOwnerStripeAccountLink';
  /**
   * Stripe onboarding account link to allow a user to get setup
   * to receive payout for their Subscription Circles or to update
   * info.
   */
  url: Scalars['String'];
};

export enum CirclePurpose {
  CHALLENGE = 'CHALLENGE',
  CHALLENGE_TEAM = 'CHALLENGE_TEAM',
}

export type CircleRestrictions = {
  __typename: 'CircleRestrictions';
  hasSubscription?: Maybe<Scalars['Boolean']>;
  biologicalSex?: Maybe<BiologicalSexRestriction>;
  age?: Maybe<AgeRestriction>;
  race?: Maybe<RaceRestriction>;
  weight?: Maybe<WeightRestriction>;
  exercisePattern?: Maybe<ExercisePatternRestriction>;
  dietaryPattern?: Maybe<DietaryPatternRestriction>;
  occupation?: Maybe<OccupationRestriction>;
  education?: Maybe<EducationRestriction>;
  familyConditions?: Maybe<FamilyConditionsRestriction>;
  diagnosedConditions?: Maybe<DiagnosedConditionsRestriction>;
  primaryHealthConcerns?: Maybe<PrimaryHealthConcernsRestriction>;
};

export type CircleRestrictionsInput = {
  hasSubscription?: Maybe<Scalars['Boolean']>;
  biologicalSex?: Maybe<BiologicalSexRestrictionInput>;
  age?: Maybe<AgeRestrictionInput>;
  weight?: Maybe<WeightRestrictionInput>;
  race?: Maybe<RaceRestrictionInput>;
  exercisePattern?: Maybe<ExercisePatternRestrictionInput>;
  dietaryPattern?: Maybe<DietaryPatternRestrictionInput>;
  occupation?: Maybe<OccupationRestrictionInput>;
  education?: Maybe<EducationRestrictionInput>;
  familyConditions?: Maybe<FamilyConditionsRestrictionInput>;
  diagnosedConditions?: Maybe<DiagnosedConditionsRestrictionInput>;
  primaryHealthConcerns?: Maybe<PrimaryHealthConcernsRestrictionInput>;
};

export type CirclesByOwningAccountConnection = {
  __typename: 'CirclesByOwningAccountConnection';
  edges: Array<CirclesByOwningAccountEdge>;
  pageInfo: PageInfo;
};

export type CirclesByOwningAccountEdge = {
  __typename: 'CirclesByOwningAccountEdge';
  node: Circle;
};

export type CircleSubscription = {
  __typename: 'CircleSubscription';
  /** Circle owner Stripe Connect account id */
  stripeConnectAccountId: Scalars['ID'];
  /** Monthly fee charged for membership in this Circle (in cents) */
  fee: Scalars['Int'];
  /** Currency of subscription fee */
  currency: Currency;
  /** Circle id */
  circleId: Scalars['ID'];
  /** Stripe Product id */
  productId: Scalars['ID'];
  /** Stripe Price id */
  priceId: Scalars['ID'];
};

export type CircleSubscriptionInput = {
  /** Circle owner Stripe Connect account id */
  stripeConnectAccountId: Scalars['ID'];
  /** Monthly fee charged for membership in this Circle (in cents) */
  fee: Scalars['Int'];
  /** Currency of subscription fee */
  currency: Currency;
};

export enum CircleTopicFocus {
  GENERAL_FASTING = 'GENERAL_FASTING',
  BEGINNER_FASTING = 'BEGINNER_FASTING',
  /** One meal a day fasting style */
  OMAD = 'OMAD',
  /** 5:2 fasting style */
  FIVE_TWO = 'FIVE_TWO',
  WEIGHT_LOSS = 'WEIGHT_LOSS',
  NUTRITION = 'NUTRITION',
  EXERCISE = 'EXERCISE',
  SLEEP = 'SLEEP',
  MINDFULNESS = 'MINDFULNESS',
  REVERSING_DIABETES = 'REVERSING_DIABETES',
  HEALTHY_AGING = 'HEALTHY_AGING',
  KETO = 'KETO',
  FAITH_BASED_FASTING = 'FAITH_BASED_FASTING',
  QUANTIFIED_SELF = 'QUANTIFIED_SELF',
  CANCER = 'CANCER',
  SCIENTIFIC_RESEARCH = 'SCIENTIFIC_RESEARCH',
}

export enum CircleType {
  public = 'public',
  private = 'private',
}

export enum ClientApp {
  /** NOTE: The mobile values should match life-extend/src/common/helpers/App.ts:3 */
  Fasting = 'Fasting',
  Extend = 'Extend',
  Research = 'Research',
}

/**
 * These values are not user-selected settings, but only a cache of the
 * most recent values from the client. They should be used with caution
 * only when it is impossible to rely on the client to handle localization
 */
export type ClientValueCache = {
  __typename: 'ClientValueCache';
  app: ClientApp;
  /** UTC Date formatted as ISO string */
  lastUpdated: Scalars['String'];
  /** comma-delimited list of language codes, e.g. pt-BR,es,en */
  languageCodes?: Maybe<Scalars['String']>;
  measurementPreferences?: Maybe<MeasurementPreferences>;
  /** IANA timezone name, e.g. America/Sao_Paulo */
  timezone?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type ClientValueCacheIn = {
  /** comma-delimited list of language codes, e.g. pt-BR,es,en */
  languageCodes?: Maybe<Scalars['String']>;
  measurementPreferences?: Maybe<MeasurementPreferencesIn>;
  /** IANA timezone name, e.g. America/Sao_Paulo */
  timezone?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type CodeableConcept = {
  __typename: 'CodeableConcept';
  coding?: Maybe<Array<Coding>>;
  text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type CodeableConceptIn = {
  coding?: Maybe<Array<Maybe<CodingIn>>>;
  text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type Coding = {
  __typename: 'Coding';
  system?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  userSelected?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
  relationshipConnection?: Maybe<RelationshipEntriesConnection>;
  educationContent?: Maybe<EducationContent>;
};

export type CodingrelationshipConnectionArgs = {
  relationship: RelationshipType;
  sort?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type CodingIn = {
  system?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  userSelected?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type Comment = {
  __typename: 'Comment';
  id: Scalars['ID'];
  /** The associated update */
  update: Update;
  /** The time when the comment was created */
  created: Scalars['Date'];
  /** The time when the comment was last edited */
  lastEdited?: Maybe<Scalars['Date']>;
  /** The text body of the comment */
  body: Scalars['String'];
  /** User that posted the comment */
  user: User;
  /**
   * Users that have been tagged in the comment
   * @deprecated use taggedFullUsers
   */
  taggedUsers: Array<Scalars['String']>;
  /** Users who were tagged in this comment */
  taggedFullUsers: Array<User>;
  /** Urls associated with this comment */
  imageUrls: Array<Scalars['URL']>;
};

export type CommentEditsInput = {
  /** The text body of the comment - only editable field for now */
  body: Scalars['String'];
};

export type Condition = {
  __typename: 'Condition';
  name: Scalars['String'];
};

export type ConditionFilter = {
  name?: Maybe<StringFilter>;
};

export type ConfirmEmailChangeResponse = ConfirmEmailChangeSuccess;

export type ConfirmEmailChangeSuccess = {
  __typename: 'ConfirmEmailChangeSuccess';
  success: Scalars['Boolean'];
};

export type ContactDetail = {
  __typename: 'ContactDetail';
  name?: Maybe<Scalars['String']>;
  telecom?: Maybe<Array<ContactPoint>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ContactDetailIn = {
  name?: Maybe<Scalars['String']>;
  telecom?: Maybe<Array<Maybe<ContactPointIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type ContactPoint = {
  __typename: 'ContactPoint';
  system?: Maybe<ContactPointSystem>;
  value?: Maybe<Scalars['String']>;
  use?: Maybe<ContactPointUse>;
  rank?: Maybe<Scalars['Float']>;
  period?: Maybe<Period>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ContactPointIn = {
  system?: Maybe<ContactPointSystem>;
  value?: Maybe<Scalars['String']>;
  use?: Maybe<ContactPointUse>;
  rank?: Maybe<Scalars['Float']>;
  period?: Maybe<PeriodIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ContactPointSystem {
  phone = 'phone',
  fax = 'fax',
  email = 'email',
  pager = 'pager',
  url = 'url',
  sms = 'sms',
  other = 'other',
}

export enum ContactPointUse {
  home = 'home',
  work = 'work',
  temp = 'temp',
  old = 'old',
  mobile = 'mobile',
}

export type Contributor = {
  __typename: 'Contributor';
  type?: Maybe<ContributorType>;
  name?: Maybe<Scalars['String']>;
  contact?: Maybe<Array<ContactDetail>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ContributorIn = {
  type?: Maybe<ContributorType>;
  name?: Maybe<Scalars['String']>;
  contact?: Maybe<Array<Maybe<ContactDetailIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ContributorType {
  author = 'author',
  editor = 'editor',
  reviewer = 'reviewer',
  endorser = 'endorser',
}

export type Conversation = {
  __typename: 'Conversation';
  conversationId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
  latestMessageTime: Scalars['Date'];
  latestMessageText: Scalars['String'];
  latestMessageUserId: Scalars['ID'];
  hasUnread: Scalars['Boolean'];
};

export type ConversationEdge = {
  __typename: 'ConversationEdge';
  node: Conversation;
};

export type ConversationPayload = {
  __typename: 'ConversationPayload';
  conversation: Conversation;
};

export type ConversationsConnection = {
  __typename: 'ConversationsConnection';
  edges: Array<ConversationEdge>;
  pageInfo: PageInfo;
};

export type Count = {
  __typename: 'Count';
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<CountComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export enum CountComparator {
  LT = 'LT',
  LTE = 'LTE',
  GTE = 'GTE',
  GT = 'GT',
}

export type CountIn = {
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<CountComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type CreateConversationInput = {
  userIds: Array<Scalars['ID']>;
  latestMessageText: Scalars['String'];
  latestMessageTime: Scalars['Date'];
  latestMessageUserId: Scalars['ID'];
};

export type CreateForumSettingsInput = {
  entityId: Scalars['ID'];
  entityType?: Maybe<EntityType>;
  userSettings: UserSettingsInput;
  notificationSettings: NotificationSettingsInput;
};

export type CreateManagingGroupInvitationInput = {
  circleId: Scalars['ID'];
  email: Scalars['String'];
  roleName: CircleManagingGroupsUserRole;
  app: AppEnum;
};

export type CreatePostInput = {
  post: NewPost;
  createConversation?: Maybe<Scalars['Boolean']>;
};

export type CreatePostPayload = {
  __typename: 'CreatePostPayload';
  post: ActivePost;
  conversationId?: Maybe<Scalars['ID']>;
};

export type CreatePrivatePostInput = {
  userIds: Array<Scalars['ID']>;
  post: NewPrivatePost;
  createConversation?: Maybe<Scalars['Boolean']>;
};

export type CreateReactionInput = {
  postId: Scalars['ID'];
  type: Scalars['Emoji'];
  comment?: Maybe<Scalars['String']>;
};

export type CreateReactionPayload = {
  __typename: 'CreateReactionPayload';
  reaction: Reaction;
};

export type CreateStripeConnectAccountInput = {
  /** Stripe Connect account name */
  name: Scalars['String'];
};

export type CreateSubscriptionCircleSessionInput = {
  /** Id of the Circle for which we want to join */
  id: Scalars['ID'];
};

export type CreateSystemGeneratedPostInput = {
  post: NewSystemGeneratedPost;
  userId?: Maybe<Scalars['ID']>;
};

export type CreateSystemGeneratedPostPayload = {
  __typename: 'CreateSystemGeneratedPostPayload';
  post: ActivePost;
};

export type CreateWebAppInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['URL']>;
  product: AppStoreProduct;
  url: Scalars['URL'];
  abacResource?: Maybe<Scalars['String']>;
  authorDisplay?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locales?: Maybe<Array<AppLocale>>;
};

export enum Currency {
  usd = 'usd',
}

export type CurrentMoodInput = {
  userId: Scalars['ID'];
  newerThan?: Maybe<Scalars['Date']>;
};

export type CustomMood = MoodV2 & {
  __typename: 'CustomMood';
  id: Scalars['ID'];
  emoji: Scalars['Emoji'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
};

export type CustomMoodInput = {
  emoji: Scalars['Emoji'];
  content?: Maybe<Scalars['String']>;
};

export type CustomMoodOptions = {
  mood: CustomMoodInput;
  publish: Scalars['Boolean'];
};

export type DataRequirement = {
  __typename: 'DataRequirement';
  type?: Maybe<Scalars['String']>;
  profile?: Maybe<Array<Scalars['String']>>;
  mustSupport?: Maybe<Array<Scalars['String']>>;
  codeFilter?: Maybe<Array<DataRequirementCodeFilter>>;
  dateFilter?: Maybe<Array<DataRequirementDateFilter>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type DataRequirementCodeFilter = {
  __typename: 'DataRequirementCodeFilter';
  path?: Maybe<Scalars['String']>;
  valueSetString?: Maybe<Scalars['String']>;
  valueSetReference?: Maybe<Reference>;
  valueCode?: Maybe<Array<Scalars['String']>>;
  valueCoding?: Maybe<Array<Coding>>;
  valueCodeableConcept?: Maybe<Array<CodeableConcept>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type DataRequirementCodeFilterIn = {
  path?: Maybe<Scalars['String']>;
  valueSetString?: Maybe<Scalars['String']>;
  valueSetReference?: Maybe<ReferenceIn>;
  valueCode?: Maybe<Array<Scalars['String']>>;
  valueCoding?: Maybe<Array<Maybe<CodingIn>>>;
  valueCodeableConcept?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type DataRequirementDateFilter = {
  __typename: 'DataRequirementDateFilter';
  path?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valuePeriod?: Maybe<Period>;
  valueDuration?: Maybe<Duration>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type DataRequirementDateFilterIn = {
  path?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valuePeriod?: Maybe<PeriodIn>;
  valueDuration?: Maybe<DurationIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type DataRequirementIn = {
  type?: Maybe<Scalars['String']>;
  profile?: Maybe<Array<Scalars['String']>>;
  mustSupport?: Maybe<Array<Scalars['String']>>;
  codeFilter?: Maybe<Array<Maybe<DataRequirementCodeFilterIn>>>;
  dateFilter?: Maybe<Array<Maybe<DataRequirementDateFilterIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type DateGraphData = {
  __typename: 'DateGraphData';
  values: Array<MeasurementData>;
  aggregationDate: Scalars['Date'];
};

export type DeleteCircleInput = {
  id?: Maybe<Scalars['ID']>;
};

export type DeleteCirclePayload = {
  __typename: 'DeleteCirclePayload';
  circle?: Maybe<Circle>;
};

export type DeletedPost = Post & {
  __typename: 'DeletedPost';
  id: Scalars['ID'];
  replies: PostConnection;
  parentId: Scalars['ID'];
  parentPost?: Maybe<Post>;
  rootParentId: Scalars['ID'];
  originalPostId: Scalars['ID'];
  originalPost: Post;
  createdAt: Scalars['Date'];
  deletedAt: Scalars['Date'];
  popularity: Scalars['Int'];
  replyCount: Scalars['Int'];
  systemGenerated: Scalars['Boolean'];
  metadata?: Maybe<Scalars['String']>;
  priority?: Maybe<Priority>;
  status: PostStatus;
  circle?: Maybe<Circle>;
};

export type DeletedPostrepliesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  order?: Maybe<PostOrder>;
  deletedStatus?: Maybe<DeletedStatus>;
};

export enum DeletedStatus {
  DELETED = 'DELETED',
  NOT_DELETED = 'NOT_DELETED',
}

export type DeleteManagingGroupInvitationInput = {
  circleId: Scalars['ID'];
  email: Scalars['String'];
  roleName: CircleManagingGroupsUserRole;
};

export type DeletePostInput = {
  id: Scalars['ID'];
};

export type DeletePostPayload = {
  __typename: 'DeletePostPayload';
  post?: Maybe<DeletedPost>;
};

export enum DiagnosedConditions {
  type_2_diabetes = 'type_2_diabetes',
  hypertension = 'hypertension',
  heart_disease = 'heart_disease',
  cancer = 'cancer',
  copd = 'copd',
  asthma = 'asthma',
  alzheimers = 'alzheimers',
  parkinsons = 'parkinsons',
  autoimmune = 'autoimmune',
  multiple_sclerosis = 'multiple_sclerosis',
  none = 'none',
}

export type DiagnosedConditionsRestriction = {
  __typename: 'DiagnosedConditionsRestriction';
  allowed: Array<DiagnosedConditions>;
};

export type DiagnosedConditionsRestrictionInput = {
  allowed?: Maybe<Array<DiagnosedConditions>>;
};

export type DiagnosticReport = {
  __typename: 'DiagnosticReport';
  resourceType: DiagnosticReportResourceType;
  identifier?: Maybe<Array<Identifier>>;
  basedOn?: Maybe<Array<Reference>>;
  status: DiagnosticReportStatus;
  category?: Maybe<CodeableConcept>;
  code: CodeableConcept;
  subject?: Maybe<Reference>;
  context?: Maybe<Reference>;
  effectiveDateTime?: Maybe<Scalars['String']>;
  effectivePeriod?: Maybe<Period>;
  issued?: Maybe<Scalars['String']>;
  performer?: Maybe<Array<DiagnosticReportPerformer>>;
  specimen?: Maybe<Array<Reference>>;
  result?: Maybe<Array<Reference>>;
  imagingStudy?: Maybe<Array<Reference>>;
  image?: Maybe<Array<DiagnosticReportImage>>;
  conclusion?: Maybe<Scalars['String']>;
  codedDiagnosis?: Maybe<Array<CodeableConcept>>;
  presentedForm?: Maybe<Array<Attachment>>;
  text?: Maybe<Narrative>;
  contained?: Maybe<Array<ResourceList>>;
  extension?: Maybe<Array<Extension>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Meta>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type DiagnosticReportEdge = {
  __typename: 'DiagnosticReportEdge';
  node: DiagnosticReport;
};

export type DiagnosticReportImage = {
  __typename: 'DiagnosticReportImage';
  comment?: Maybe<Scalars['String']>;
  link: Reference;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type DiagnosticReportImageIn = {
  comment?: Maybe<Scalars['String']>;
  link: ReferenceIn;
  modifierExtension?: Maybe<Array<ExtensionIn>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ExtensionIn>>;
};

export type DiagnosticReportIn = {
  resourceType: DiagnosticReportResourceType;
  identifier?: Maybe<Array<IdentifierIn>>;
  basedOn?: Maybe<Array<ReferenceIn>>;
  status?: Maybe<DiagnosticReportStatus>;
  category?: Maybe<CodeableConceptIn>;
  code: CodeableConceptIn;
  subject?: Maybe<ReferenceIn>;
  context?: Maybe<ReferenceIn>;
  effectiveDateTime?: Maybe<Scalars['String']>;
  effectivePeriod?: Maybe<PeriodIn>;
  issued?: Maybe<Scalars['String']>;
  performer?: Maybe<Array<DiagnosticReportPerformerIn>>;
  specimen?: Maybe<Array<ReferenceIn>>;
  result?: Maybe<Array<ReferenceIn>>;
  imagingStudy?: Maybe<Array<ReferenceIn>>;
  image?: Maybe<Array<DiagnosticReportImageIn>>;
  conclusion?: Maybe<Scalars['String']>;
  codedDiagnosis?: Maybe<Array<CodeableConceptIn>>;
  presentedForm?: Maybe<Array<AttachmentIn>>;
  text?: Maybe<NarrativeIn>;
  extension?: Maybe<Array<ExtensionIn>>;
  modifierExtension?: Maybe<Array<ExtensionIn>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<MetaIn>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type DiagnosticReportPerformer = {
  __typename: 'DiagnosticReportPerformer';
  role?: Maybe<CodeableConcept>;
  actor: Reference;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type DiagnosticReportPerformerIn = {
  role?: Maybe<CodeableConceptIn>;
  actor: ReferenceIn;
  modifierExtension?: Maybe<Array<ExtensionIn>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ExtensionIn>>;
};

export enum DiagnosticReportResourceType {
  DiagnosticReport = 'DiagnosticReport',
}

export type DiagnosticReportsConnection = {
  __typename: 'DiagnosticReportsConnection';
  edges: Array<DiagnosticReportEdge>;
  pageInfo: PageInfo;
};

export enum DiagnosticReportStatus {
  registered = 'registered',
  partial = 'partial',
  preliminary = 'preliminary',
  final = 'final',
  amended = 'amended',
  corrected = 'corrected',
  appended = 'appended',
  cancelled = 'cancelled',
  entered_in_error = 'entered_in_error',
  unknown = 'unknown',
}

export enum DietaryPattern {
  vegan = 'vegan',
  vegetarian = 'vegetarian',
  mostly_plants = 'mostly_plants',
  western = 'western',
  paleo = 'paleo',
  keto = 'keto',
  other = 'other',
}

export type DietaryPatternRestriction = {
  __typename: 'DietaryPatternRestriction';
  allowed: Array<DietaryPattern>;
};

export type DietaryPatternRestrictionInput = {
  allowed?: Maybe<Array<DietaryPattern>>;
};

export type Distance = {
  __typename: 'Distance';
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<DistanceComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export enum DistanceComparator {
  LT = 'LT',
  LTE = 'LTE',
  GTE = 'GTE',
  GT = 'GT',
}

export type DistanceIn = {
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<DistanceComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum DistanceUnit {
  km = 'km',
  mi = 'mi',
}

export type Dosage = {
  __typename: 'Dosage';
  sequence?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  additionalInstruction?: Maybe<Array<CodeableConcept>>;
  patientInstruction?: Maybe<Scalars['String']>;
  timing?: Maybe<Timing>;
  asNeededBoolean?: Maybe<Scalars['Boolean']>;
  asNeededCodeableConcept?: Maybe<CodeableConcept>;
  site?: Maybe<CodeableConcept>;
  route?: Maybe<CodeableConcept>;
  method?: Maybe<CodeableConcept>;
  doseRange?: Maybe<Range>;
  doseQuantity?: Maybe<Quantity>;
  maxDosePerPeriod?: Maybe<Ratio>;
  maxDosePerAdministration?: Maybe<Quantity>;
  maxDosePerLifetime?: Maybe<Quantity>;
  rateRatio?: Maybe<Ratio>;
  rateRange?: Maybe<Range>;
  rateQuantity?: Maybe<Quantity>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type DosageIn = {
  sequence?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  additionalInstruction?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  patientInstruction?: Maybe<Scalars['String']>;
  timing?: Maybe<TimingIn>;
  asNeededBoolean?: Maybe<Scalars['Boolean']>;
  asNeededCodeableConcept?: Maybe<CodeableConceptIn>;
  site?: Maybe<CodeableConceptIn>;
  route?: Maybe<CodeableConceptIn>;
  method?: Maybe<CodeableConceptIn>;
  doseRange?: Maybe<RangeIn>;
  doseQuantity?: Maybe<QuantityIn>;
  maxDosePerPeriod?: Maybe<RatioIn>;
  maxDosePerAdministration?: Maybe<QuantityIn>;
  maxDosePerLifetime?: Maybe<QuantityIn>;
  rateRatio?: Maybe<RatioIn>;
  rateRange?: Maybe<RangeIn>;
  rateQuantity?: Maybe<QuantityIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type Drug = {
  __typename: 'Drug';
  drugId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  classes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Duration = {
  __typename: 'Duration';
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<DurationComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export enum DurationComparator {
  LT = 'LT',
  LTE = 'LTE',
  GTE = 'GTE',
  GT = 'GT',
}

export type DurationIn = {
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<DurationComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type EditCircleInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Preferred language is the circle creators expected, primary language for the circle. Explicit null indicates removal */
  preferredLanguage?: Maybe<Scalars['String']>;
  /**
   * List of topics of what are the main priorities/interests of the group, will
   * help with search. Explicit null indicates removal
   */
  topicFocus?: Maybe<Array<CircleTopicFocus>>;
  /** General area that the Circle owner would hope/expect members to be located in as any text. */
  geographicalArea?: Maybe<Scalars['String']>;
  forumSettings?: Maybe<EditForumSettingsInput>;
};

export type EditCirclePayload = {
  __typename: 'EditCirclePayload';
  circle?: Maybe<Circle>;
};

export type EditForumSettingsInput = {
  userSettings?: Maybe<UserSettingsUpdateInput>;
  notificationSettings?: Maybe<NotificationSettingsUpdateInput>;
};

export type EditWebAppInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['URL']>;
  url?: Maybe<Scalars['URL']>;
  abacResource?: Maybe<Scalars['String']>;
  authorDisplay?: Maybe<Scalars['String']>;
  locales?: Maybe<Array<AppLocale>>;
};

export enum Education {
  elementary_school = 'elementary_school',
  high_school = 'high_school',
  associate_or_technical_degree = 'associate_or_technical_degree',
  baccalaureate_degree = 'baccalaureate_degree',
  graduate_degree = 'graduate_degree',
  post_graduate_degree = 'post_graduate_degree',
}

export type EducationContent = {
  __typename: 'EducationContent';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  publishedDate: Scalars['Date'];
  /** A URL to a thumbnail image for the content */
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: EducationContentType;
  /** The URL of the content */
  url: Scalars['String'];
  /** The approval status of the content */
  status: EducationContentStatus;
  /**
   * Set this value if you want to link this value to a value from terminology-service
   * graphql-proxy-service will stitch EducationContent to corresponding Coding
   */
  code?: Maybe<EducationContentCode>;
  /** Two-digit language code */
  language?: Maybe<Scalars['String']>;
  /** Translation id */
  trid?: Maybe<Scalars['String']>;
  /** We allow original and translation */
  materialType?: Maybe<Scalars['String']>;
};

export type EducationContentCode = {
  __typename: 'EducationContentCode';
  code?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
};

export type EducationContentCodeInput = {
  code: Scalars['String'];
  system: Scalars['String'];
};

export type EducationContentConnection = {
  __typename: 'EducationContentConnection';
  edges: Array<EducationContentEdge>;
  pageInfo: PageInfo;
};

export type EducationContentCreateInput = {
  description?: Maybe<Scalars['String']>;
  publishedDate: Scalars['Date'];
  /** A URL to a thumbnail image for the content */
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: EducationContentType;
  /** The URL of the content */
  url: Scalars['String'];
  /** We only allow one EducationContent per code */
  code?: Maybe<EducationContentCodeInput>;
  /** Two-digit language code */
  language?: Maybe<Scalars['String']>;
  /** Translation id */
  trid?: Maybe<Scalars['String']>;
  /** We allow original and translation */
  materialType?: Maybe<Scalars['String']>;
};

export type EducationContentEdge = {
  __typename: 'EducationContentEdge';
  node: EducationContent;
};

export enum EducationContentFilterTypes {
  video = 'video',
  article = 'article',
  all = 'all',
}

export enum EducationContentStatus {
  active = 'active',
  pending = 'pending',
}

export enum EducationContentType {
  video = 'video',
  article = 'article',
}

export type EducationContentUpdateInput = {
  description?: Maybe<Scalars['String']>;
  publishedDate?: Maybe<Scalars['Date']>;
  /** A URL to a thumbnail image for the content */
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<EducationContentType>;
  /** The URL of the content */
  url?: Maybe<Scalars['String']>;
  /** The approval status of the content */
  status?: Maybe<EducationContentStatus>;
  /** We only allow one EducationContent per code, and one code per EducationContent */
  code?: Maybe<EducationContentCodeInput>;
  /** Two-digit language code */
  language?: Maybe<Scalars['String']>;
  /** Translation id */
  trid?: Maybe<Scalars['String']>;
  /** We allow original and translation */
  materialType?: Maybe<Scalars['String']>;
};

export type EducationRestriction = {
  __typename: 'EducationRestriction';
  allowed: Array<Education>;
};

export type EducationRestrictionInput = {
  allowed?: Maybe<Array<Education>>;
};

export type Element = {
  __typename: 'Element';
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ElementDefinition = {
  __typename: 'ElementDefinition';
  path?: Maybe<Scalars['String']>;
  representation?: Maybe<Array<ElementDefinitionRepresentation>>;
  sliceName?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  code?: Maybe<Array<Coding>>;
  slicing?: Maybe<ElementDefinitionSlicing>;
  short?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  alias?: Maybe<Array<Scalars['String']>>;
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['String']>;
  base?: Maybe<ElementDefinitionBase>;
  contentReference?: Maybe<Scalars['String']>;
  type?: Maybe<Array<ElementDefinitionType>>;
  defaultValueBoolean?: Maybe<Scalars['Boolean']>;
  defaultValueInteger?: Maybe<Scalars['Float']>;
  defaultValueDecimal?: Maybe<Scalars['Float']>;
  defaultValueBase64Binary?: Maybe<Scalars['String']>;
  defaultValueInstant?: Maybe<Scalars['String']>;
  defaultValueString?: Maybe<Scalars['String']>;
  defaultValueUri?: Maybe<Scalars['String']>;
  defaultValueDate?: Maybe<Scalars['String']>;
  defaultValueDateTime?: Maybe<Scalars['String']>;
  defaultValueTime?: Maybe<Scalars['String']>;
  defaultValueCode?: Maybe<Scalars['String']>;
  defaultValueOid?: Maybe<Scalars['String']>;
  defaultValueUuid?: Maybe<Scalars['String']>;
  defaultValueId?: Maybe<Scalars['String']>;
  defaultValueUnsignedInt?: Maybe<Scalars['Float']>;
  defaultValuePositiveInt?: Maybe<Scalars['Float']>;
  defaultValueMarkdown?: Maybe<Scalars['String']>;
  defaultValueElement?: Maybe<Element>;
  defaultValueExtension?: Maybe<Extension>;
  defaultValueBackboneElement?: Maybe<BackboneElement>;
  defaultValueNarrative?: Maybe<Narrative>;
  defaultValueAnnotation?: Maybe<Annotation>;
  defaultValueAttachment?: Maybe<Attachment>;
  defaultValueIdentifier?: Maybe<Identifier>;
  defaultValueCodeableConcept?: Maybe<CodeableConcept>;
  defaultValueCoding?: Maybe<Coding>;
  defaultValueQuantity?: Maybe<Quantity>;
  defaultValueDuration?: Maybe<Duration>;
  defaultValueSimpleQuantity?: Maybe<Quantity>;
  defaultValueDistance?: Maybe<Distance>;
  defaultValueCount?: Maybe<Count>;
  defaultValueMoney?: Maybe<Money>;
  defaultValueAge?: Maybe<Age>;
  defaultValueRange?: Maybe<Range>;
  defaultValuePeriod?: Maybe<Period>;
  defaultValueRatio?: Maybe<Ratio>;
  defaultValueReference?: Maybe<Reference>;
  defaultValueSampledData?: Maybe<SampledData>;
  defaultValueSignature?: Maybe<Signature>;
  defaultValueHumanName?: Maybe<HumanName>;
  defaultValueAddress?: Maybe<Address>;
  defaultValueContactPoint?: Maybe<ContactPoint>;
  defaultValueTiming?: Maybe<Timing>;
  defaultValueMeta?: Maybe<Meta>;
  defaultValueElementDefinition?: Maybe<ElementDefinition>;
  defaultValueContactDetail?: Maybe<ContactDetail>;
  defaultValueContributor?: Maybe<Contributor>;
  defaultValueDosage?: Maybe<Dosage>;
  defaultValueRelatedArtifact?: Maybe<RelatedArtifact>;
  defaultValueUsageContext?: Maybe<UsageContext>;
  defaultValueDataRequirement?: Maybe<DataRequirement>;
  defaultValueParameterDefinition?: Maybe<ParameterDefinition>;
  defaultValueTriggerDefinition?: Maybe<TriggerDefinition>;
  meaningWhenMissing?: Maybe<Scalars['String']>;
  orderMeaning?: Maybe<Scalars['String']>;
  fixedBoolean?: Maybe<Scalars['Boolean']>;
  fixedInteger?: Maybe<Scalars['Float']>;
  fixedDecimal?: Maybe<Scalars['Float']>;
  fixedBase64Binary?: Maybe<Scalars['String']>;
  fixedInstant?: Maybe<Scalars['String']>;
  fixedString?: Maybe<Scalars['String']>;
  fixedUri?: Maybe<Scalars['String']>;
  fixedDate?: Maybe<Scalars['String']>;
  fixedDateTime?: Maybe<Scalars['String']>;
  fixedTime?: Maybe<Scalars['String']>;
  fixedCode?: Maybe<Scalars['String']>;
  fixedOid?: Maybe<Scalars['String']>;
  fixedUuid?: Maybe<Scalars['String']>;
  fixedId?: Maybe<Scalars['String']>;
  fixedUnsignedInt?: Maybe<Scalars['Float']>;
  fixedPositiveInt?: Maybe<Scalars['Float']>;
  fixedMarkdown?: Maybe<Scalars['String']>;
  fixedElement?: Maybe<Element>;
  fixedExtension?: Maybe<Extension>;
  fixedBackboneElement?: Maybe<BackboneElement>;
  fixedNarrative?: Maybe<Narrative>;
  fixedAnnotation?: Maybe<Annotation>;
  fixedAttachment?: Maybe<Attachment>;
  fixedIdentifier?: Maybe<Identifier>;
  fixedCodeableConcept?: Maybe<CodeableConcept>;
  fixedCoding?: Maybe<Coding>;
  fixedQuantity?: Maybe<Quantity>;
  fixedDuration?: Maybe<Duration>;
  fixedSimpleQuantity?: Maybe<Quantity>;
  fixedDistance?: Maybe<Distance>;
  fixedCount?: Maybe<Count>;
  fixedMoney?: Maybe<Money>;
  fixedAge?: Maybe<Age>;
  fixedRange?: Maybe<Range>;
  fixedPeriod?: Maybe<Period>;
  fixedRatio?: Maybe<Ratio>;
  fixedReference?: Maybe<Reference>;
  fixedSampledData?: Maybe<SampledData>;
  fixedSignature?: Maybe<Signature>;
  fixedHumanName?: Maybe<HumanName>;
  fixedAddress?: Maybe<Address>;
  fixedContactPoint?: Maybe<ContactPoint>;
  fixedTiming?: Maybe<Timing>;
  fixedMeta?: Maybe<Meta>;
  fixedElementDefinition?: Maybe<ElementDefinition>;
  fixedContactDetail?: Maybe<ContactDetail>;
  fixedContributor?: Maybe<Contributor>;
  fixedDosage?: Maybe<Dosage>;
  fixedRelatedArtifact?: Maybe<RelatedArtifact>;
  fixedUsageContext?: Maybe<UsageContext>;
  fixedDataRequirement?: Maybe<DataRequirement>;
  fixedParameterDefinition?: Maybe<ParameterDefinition>;
  fixedTriggerDefinition?: Maybe<TriggerDefinition>;
  patternBoolean?: Maybe<Scalars['Boolean']>;
  patternInteger?: Maybe<Scalars['Float']>;
  patternDecimal?: Maybe<Scalars['Float']>;
  patternBase64Binary?: Maybe<Scalars['String']>;
  patternInstant?: Maybe<Scalars['String']>;
  patternString?: Maybe<Scalars['String']>;
  patternUri?: Maybe<Scalars['String']>;
  patternDate?: Maybe<Scalars['String']>;
  patternDateTime?: Maybe<Scalars['String']>;
  patternTime?: Maybe<Scalars['String']>;
  patternCode?: Maybe<Scalars['String']>;
  patternOid?: Maybe<Scalars['String']>;
  patternUuid?: Maybe<Scalars['String']>;
  patternId?: Maybe<Scalars['String']>;
  patternUnsignedInt?: Maybe<Scalars['Float']>;
  patternPositiveInt?: Maybe<Scalars['Float']>;
  patternMarkdown?: Maybe<Scalars['String']>;
  patternElement?: Maybe<Element>;
  patternExtension?: Maybe<Extension>;
  patternBackboneElement?: Maybe<BackboneElement>;
  patternNarrative?: Maybe<Narrative>;
  patternAnnotation?: Maybe<Annotation>;
  patternAttachment?: Maybe<Attachment>;
  patternIdentifier?: Maybe<Identifier>;
  patternCodeableConcept?: Maybe<CodeableConcept>;
  patternCoding?: Maybe<Coding>;
  patternQuantity?: Maybe<Quantity>;
  patternDuration?: Maybe<Duration>;
  patternSimpleQuantity?: Maybe<Quantity>;
  patternDistance?: Maybe<Distance>;
  patternCount?: Maybe<Count>;
  patternMoney?: Maybe<Money>;
  patternAge?: Maybe<Age>;
  patternRange?: Maybe<Range>;
  patternPeriod?: Maybe<Period>;
  patternRatio?: Maybe<Ratio>;
  patternReference?: Maybe<Reference>;
  patternSampledData?: Maybe<SampledData>;
  patternSignature?: Maybe<Signature>;
  patternHumanName?: Maybe<HumanName>;
  patternAddress?: Maybe<Address>;
  patternContactPoint?: Maybe<ContactPoint>;
  patternTiming?: Maybe<Timing>;
  patternMeta?: Maybe<Meta>;
  patternElementDefinition?: Maybe<ElementDefinition>;
  patternContactDetail?: Maybe<ContactDetail>;
  patternContributor?: Maybe<Contributor>;
  patternDosage?: Maybe<Dosage>;
  patternRelatedArtifact?: Maybe<RelatedArtifact>;
  patternUsageContext?: Maybe<UsageContext>;
  patternDataRequirement?: Maybe<DataRequirement>;
  patternParameterDefinition?: Maybe<ParameterDefinition>;
  patternTriggerDefinition?: Maybe<TriggerDefinition>;
  example?: Maybe<Array<ElementDefinitionExample>>;
  minValueDate?: Maybe<Scalars['String']>;
  minValueDateTime?: Maybe<Scalars['String']>;
  minValueInstant?: Maybe<Scalars['String']>;
  minValueTime?: Maybe<Scalars['String']>;
  minValueDecimal?: Maybe<Scalars['Float']>;
  minValueInteger?: Maybe<Scalars['Float']>;
  minValuePositiveInt?: Maybe<Scalars['Float']>;
  minValueUnsignedInt?: Maybe<Scalars['Float']>;
  minValueQuantity?: Maybe<Quantity>;
  maxValueDate?: Maybe<Scalars['String']>;
  maxValueDateTime?: Maybe<Scalars['String']>;
  maxValueInstant?: Maybe<Scalars['String']>;
  maxValueTime?: Maybe<Scalars['String']>;
  maxValueDecimal?: Maybe<Scalars['Float']>;
  maxValueInteger?: Maybe<Scalars['Float']>;
  maxValuePositiveInt?: Maybe<Scalars['Float']>;
  maxValueUnsignedInt?: Maybe<Scalars['Float']>;
  maxValueQuantity?: Maybe<Quantity>;
  maxLength?: Maybe<Scalars['Float']>;
  condition?: Maybe<Array<Scalars['String']>>;
  constraint?: Maybe<Array<ElementDefinitionConstraint>>;
  mustSupport?: Maybe<Scalars['Boolean']>;
  isModifier?: Maybe<Scalars['Boolean']>;
  isSummary?: Maybe<Scalars['Boolean']>;
  binding?: Maybe<ElementDefinitionBinding>;
  mapping?: Maybe<Array<ElementDefinitionMapping>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ElementDefinitionBase = {
  __typename: 'ElementDefinitionBase';
  path?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ElementDefinitionBaseIn = {
  path?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type ElementDefinitionBinding = {
  __typename: 'ElementDefinitionBinding';
  strength?: Maybe<ElementDefinitionBindingStrength>;
  description?: Maybe<Scalars['String']>;
  valueSetUri?: Maybe<Scalars['String']>;
  valueSetReference?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ElementDefinitionBindingIn = {
  strength?: Maybe<ElementDefinitionBindingStrength>;
  description?: Maybe<Scalars['String']>;
  valueSetUri?: Maybe<Scalars['String']>;
  valueSetReference?: Maybe<ReferenceIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ElementDefinitionBindingStrength {
  required = 'required',
  extensible = 'extensible',
  preferred = 'preferred',
  example = 'example',
}

export type ElementDefinitionConstraint = {
  __typename: 'ElementDefinitionConstraint';
  key?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  severity?: Maybe<ElementDefinitionConstraintSeverity>;
  human?: Maybe<Scalars['String']>;
  expression?: Maybe<Scalars['String']>;
  xpath?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ElementDefinitionConstraintIn = {
  key?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  severity?: Maybe<ElementDefinitionConstraintSeverity>;
  human?: Maybe<Scalars['String']>;
  expression?: Maybe<Scalars['String']>;
  xpath?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ElementDefinitionConstraintSeverity {
  error = 'error',
  warning = 'warning',
}

export type ElementDefinitionDiscriminator = {
  __typename: 'ElementDefinitionDiscriminator';
  type?: Maybe<ElementDefinitionDiscriminatorType>;
  path?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ElementDefinitionDiscriminatorIn = {
  type?: Maybe<ElementDefinitionDiscriminatorType>;
  path?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ElementDefinitionDiscriminatorType {
  value = 'value',
  exists = 'exists',
  pattern = 'pattern',
  type = 'type',
  profile = 'profile',
}

export type ElementDefinitionExample = {
  __typename: 'ElementDefinitionExample';
  label?: Maybe<Scalars['String']>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueBase64Binary?: Maybe<Scalars['String']>;
  valueInstant?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueCode?: Maybe<Scalars['String']>;
  valueOid?: Maybe<Scalars['String']>;
  valueUuid?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['String']>;
  valueUnsignedInt?: Maybe<Scalars['Float']>;
  valuePositiveInt?: Maybe<Scalars['Float']>;
  valueMarkdown?: Maybe<Scalars['String']>;
  valueElement?: Maybe<Element>;
  valueExtension?: Maybe<Extension>;
  valueBackboneElement?: Maybe<BackboneElement>;
  valueNarrative?: Maybe<Narrative>;
  valueAnnotation?: Maybe<Annotation>;
  valueAttachment?: Maybe<Attachment>;
  valueIdentifier?: Maybe<Identifier>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueCoding?: Maybe<Coding>;
  valueQuantity?: Maybe<Quantity>;
  valueDuration?: Maybe<Duration>;
  valueSimpleQuantity?: Maybe<Quantity>;
  valueDistance?: Maybe<Distance>;
  valueCount?: Maybe<Count>;
  valueMoney?: Maybe<Money>;
  valueAge?: Maybe<Age>;
  valueRange?: Maybe<Range>;
  valuePeriod?: Maybe<Period>;
  valueRatio?: Maybe<Ratio>;
  valueReference?: Maybe<Reference>;
  valueSampledData?: Maybe<SampledData>;
  valueSignature?: Maybe<Signature>;
  valueHumanName?: Maybe<HumanName>;
  valueAddress?: Maybe<Address>;
  valueContactPoint?: Maybe<ContactPoint>;
  valueTiming?: Maybe<Timing>;
  valueMeta?: Maybe<Meta>;
  valueElementDefinition?: Maybe<ElementDefinition>;
  valueContactDetail?: Maybe<ContactDetail>;
  valueContributor?: Maybe<Contributor>;
  valueDosage?: Maybe<Dosage>;
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  valueUsageContext?: Maybe<UsageContext>;
  valueDataRequirement?: Maybe<DataRequirement>;
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ElementDefinitionExampleIn = {
  label?: Maybe<Scalars['String']>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueBase64Binary?: Maybe<Scalars['String']>;
  valueInstant?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueCode?: Maybe<Scalars['String']>;
  valueOid?: Maybe<Scalars['String']>;
  valueUuid?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['String']>;
  valueUnsignedInt?: Maybe<Scalars['Float']>;
  valuePositiveInt?: Maybe<Scalars['Float']>;
  valueMarkdown?: Maybe<Scalars['String']>;
  valueElement?: Maybe<ElementIn>;
  valueExtension?: Maybe<ExtensionIn>;
  valueBackboneElement?: Maybe<BackboneElementIn>;
  valueNarrative?: Maybe<NarrativeIn>;
  valueAnnotation?: Maybe<AnnotationIn>;
  valueAttachment?: Maybe<AttachmentIn>;
  valueIdentifier?: Maybe<IdentifierIn>;
  valueCodeableConcept?: Maybe<CodeableConceptIn>;
  valueCoding?: Maybe<CodingIn>;
  valueQuantity?: Maybe<QuantityIn>;
  valueDuration?: Maybe<DurationIn>;
  valueSimpleQuantity?: Maybe<QuantityIn>;
  valueDistance?: Maybe<DistanceIn>;
  valueCount?: Maybe<CountIn>;
  valueMoney?: Maybe<MoneyIn>;
  valueAge?: Maybe<AgeIn>;
  valueRange?: Maybe<RangeIn>;
  valuePeriod?: Maybe<PeriodIn>;
  valueRatio?: Maybe<RatioIn>;
  valueReference?: Maybe<ReferenceIn>;
  valueSampledData?: Maybe<SampledDataIn>;
  valueSignature?: Maybe<SignatureIn>;
  valueHumanName?: Maybe<HumanNameIn>;
  valueAddress?: Maybe<AddressIn>;
  valueContactPoint?: Maybe<ContactPointIn>;
  valueTiming?: Maybe<TimingIn>;
  valueMeta?: Maybe<MetaIn>;
  valueElementDefinition?: Maybe<ElementDefinitionIn>;
  valueContactDetail?: Maybe<ContactDetailIn>;
  valueContributor?: Maybe<ContributorIn>;
  valueDosage?: Maybe<DosageIn>;
  valueRelatedArtifact?: Maybe<RelatedArtifactIn>;
  valueUsageContext?: Maybe<UsageContextIn>;
  valueDataRequirement?: Maybe<DataRequirementIn>;
  valueParameterDefinition?: Maybe<ParameterDefinitionIn>;
  valueTriggerDefinition?: Maybe<TriggerDefinitionIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type ElementDefinitionIn = {
  path?: Maybe<Scalars['String']>;
  representation?: Maybe<Array<ElementDefinitionRepresentation>>;
  sliceName?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  code?: Maybe<Array<Maybe<CodingIn>>>;
  slicing?: Maybe<ElementDefinitionSlicingIn>;
  short?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  alias?: Maybe<Array<Scalars['String']>>;
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['String']>;
  base?: Maybe<ElementDefinitionBaseIn>;
  contentReference?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<ElementDefinitionTypeIn>>>;
  defaultValueBoolean?: Maybe<Scalars['Boolean']>;
  defaultValueInteger?: Maybe<Scalars['Float']>;
  defaultValueDecimal?: Maybe<Scalars['Float']>;
  defaultValueBase64Binary?: Maybe<Scalars['String']>;
  defaultValueInstant?: Maybe<Scalars['String']>;
  defaultValueString?: Maybe<Scalars['String']>;
  defaultValueUri?: Maybe<Scalars['String']>;
  defaultValueDate?: Maybe<Scalars['String']>;
  defaultValueDateTime?: Maybe<Scalars['String']>;
  defaultValueTime?: Maybe<Scalars['String']>;
  defaultValueCode?: Maybe<Scalars['String']>;
  defaultValueOid?: Maybe<Scalars['String']>;
  defaultValueUuid?: Maybe<Scalars['String']>;
  defaultValueId?: Maybe<Scalars['String']>;
  defaultValueUnsignedInt?: Maybe<Scalars['Float']>;
  defaultValuePositiveInt?: Maybe<Scalars['Float']>;
  defaultValueMarkdown?: Maybe<Scalars['String']>;
  defaultValueElement?: Maybe<ElementIn>;
  defaultValueExtension?: Maybe<ExtensionIn>;
  defaultValueBackboneElement?: Maybe<BackboneElementIn>;
  defaultValueNarrative?: Maybe<NarrativeIn>;
  defaultValueAnnotation?: Maybe<AnnotationIn>;
  defaultValueAttachment?: Maybe<AttachmentIn>;
  defaultValueIdentifier?: Maybe<IdentifierIn>;
  defaultValueCodeableConcept?: Maybe<CodeableConceptIn>;
  defaultValueCoding?: Maybe<CodingIn>;
  defaultValueQuantity?: Maybe<QuantityIn>;
  defaultValueDuration?: Maybe<DurationIn>;
  defaultValueSimpleQuantity?: Maybe<QuantityIn>;
  defaultValueDistance?: Maybe<DistanceIn>;
  defaultValueCount?: Maybe<CountIn>;
  defaultValueMoney?: Maybe<MoneyIn>;
  defaultValueAge?: Maybe<AgeIn>;
  defaultValueRange?: Maybe<RangeIn>;
  defaultValuePeriod?: Maybe<PeriodIn>;
  defaultValueRatio?: Maybe<RatioIn>;
  defaultValueReference?: Maybe<ReferenceIn>;
  defaultValueSampledData?: Maybe<SampledDataIn>;
  defaultValueSignature?: Maybe<SignatureIn>;
  defaultValueHumanName?: Maybe<HumanNameIn>;
  defaultValueAddress?: Maybe<AddressIn>;
  defaultValueContactPoint?: Maybe<ContactPointIn>;
  defaultValueTiming?: Maybe<TimingIn>;
  defaultValueMeta?: Maybe<MetaIn>;
  defaultValueElementDefinition?: Maybe<ElementDefinitionIn>;
  defaultValueContactDetail?: Maybe<ContactDetailIn>;
  defaultValueContributor?: Maybe<ContributorIn>;
  defaultValueDosage?: Maybe<DosageIn>;
  defaultValueRelatedArtifact?: Maybe<RelatedArtifactIn>;
  defaultValueUsageContext?: Maybe<UsageContextIn>;
  defaultValueDataRequirement?: Maybe<DataRequirementIn>;
  defaultValueParameterDefinition?: Maybe<ParameterDefinitionIn>;
  defaultValueTriggerDefinition?: Maybe<TriggerDefinitionIn>;
  meaningWhenMissing?: Maybe<Scalars['String']>;
  orderMeaning?: Maybe<Scalars['String']>;
  fixedBoolean?: Maybe<Scalars['Boolean']>;
  fixedInteger?: Maybe<Scalars['Float']>;
  fixedDecimal?: Maybe<Scalars['Float']>;
  fixedBase64Binary?: Maybe<Scalars['String']>;
  fixedInstant?: Maybe<Scalars['String']>;
  fixedString?: Maybe<Scalars['String']>;
  fixedUri?: Maybe<Scalars['String']>;
  fixedDate?: Maybe<Scalars['String']>;
  fixedDateTime?: Maybe<Scalars['String']>;
  fixedTime?: Maybe<Scalars['String']>;
  fixedCode?: Maybe<Scalars['String']>;
  fixedOid?: Maybe<Scalars['String']>;
  fixedUuid?: Maybe<Scalars['String']>;
  fixedId?: Maybe<Scalars['String']>;
  fixedUnsignedInt?: Maybe<Scalars['Float']>;
  fixedPositiveInt?: Maybe<Scalars['Float']>;
  fixedMarkdown?: Maybe<Scalars['String']>;
  fixedElement?: Maybe<ElementIn>;
  fixedExtension?: Maybe<ExtensionIn>;
  fixedBackboneElement?: Maybe<BackboneElementIn>;
  fixedNarrative?: Maybe<NarrativeIn>;
  fixedAnnotation?: Maybe<AnnotationIn>;
  fixedAttachment?: Maybe<AttachmentIn>;
  fixedIdentifier?: Maybe<IdentifierIn>;
  fixedCodeableConcept?: Maybe<CodeableConceptIn>;
  fixedCoding?: Maybe<CodingIn>;
  fixedQuantity?: Maybe<QuantityIn>;
  fixedDuration?: Maybe<DurationIn>;
  fixedSimpleQuantity?: Maybe<QuantityIn>;
  fixedDistance?: Maybe<DistanceIn>;
  fixedCount?: Maybe<CountIn>;
  fixedMoney?: Maybe<MoneyIn>;
  fixedAge?: Maybe<AgeIn>;
  fixedRange?: Maybe<RangeIn>;
  fixedPeriod?: Maybe<PeriodIn>;
  fixedRatio?: Maybe<RatioIn>;
  fixedReference?: Maybe<ReferenceIn>;
  fixedSampledData?: Maybe<SampledDataIn>;
  fixedSignature?: Maybe<SignatureIn>;
  fixedHumanName?: Maybe<HumanNameIn>;
  fixedAddress?: Maybe<AddressIn>;
  fixedContactPoint?: Maybe<ContactPointIn>;
  fixedTiming?: Maybe<TimingIn>;
  fixedMeta?: Maybe<MetaIn>;
  fixedElementDefinition?: Maybe<ElementDefinitionIn>;
  fixedContactDetail?: Maybe<ContactDetailIn>;
  fixedContributor?: Maybe<ContributorIn>;
  fixedDosage?: Maybe<DosageIn>;
  fixedRelatedArtifact?: Maybe<RelatedArtifactIn>;
  fixedUsageContext?: Maybe<UsageContextIn>;
  fixedDataRequirement?: Maybe<DataRequirementIn>;
  fixedParameterDefinition?: Maybe<ParameterDefinitionIn>;
  fixedTriggerDefinition?: Maybe<TriggerDefinitionIn>;
  patternBoolean?: Maybe<Scalars['Boolean']>;
  patternInteger?: Maybe<Scalars['Float']>;
  patternDecimal?: Maybe<Scalars['Float']>;
  patternBase64Binary?: Maybe<Scalars['String']>;
  patternInstant?: Maybe<Scalars['String']>;
  patternString?: Maybe<Scalars['String']>;
  patternUri?: Maybe<Scalars['String']>;
  patternDate?: Maybe<Scalars['String']>;
  patternDateTime?: Maybe<Scalars['String']>;
  patternTime?: Maybe<Scalars['String']>;
  patternCode?: Maybe<Scalars['String']>;
  patternOid?: Maybe<Scalars['String']>;
  patternUuid?: Maybe<Scalars['String']>;
  patternId?: Maybe<Scalars['String']>;
  patternUnsignedInt?: Maybe<Scalars['Float']>;
  patternPositiveInt?: Maybe<Scalars['Float']>;
  patternMarkdown?: Maybe<Scalars['String']>;
  patternElement?: Maybe<ElementIn>;
  patternExtension?: Maybe<ExtensionIn>;
  patternBackboneElement?: Maybe<BackboneElementIn>;
  patternNarrative?: Maybe<NarrativeIn>;
  patternAnnotation?: Maybe<AnnotationIn>;
  patternAttachment?: Maybe<AttachmentIn>;
  patternIdentifier?: Maybe<IdentifierIn>;
  patternCodeableConcept?: Maybe<CodeableConceptIn>;
  patternCoding?: Maybe<CodingIn>;
  patternQuantity?: Maybe<QuantityIn>;
  patternDuration?: Maybe<DurationIn>;
  patternSimpleQuantity?: Maybe<QuantityIn>;
  patternDistance?: Maybe<DistanceIn>;
  patternCount?: Maybe<CountIn>;
  patternMoney?: Maybe<MoneyIn>;
  patternAge?: Maybe<AgeIn>;
  patternRange?: Maybe<RangeIn>;
  patternPeriod?: Maybe<PeriodIn>;
  patternRatio?: Maybe<RatioIn>;
  patternReference?: Maybe<ReferenceIn>;
  patternSampledData?: Maybe<SampledDataIn>;
  patternSignature?: Maybe<SignatureIn>;
  patternHumanName?: Maybe<HumanNameIn>;
  patternAddress?: Maybe<AddressIn>;
  patternContactPoint?: Maybe<ContactPointIn>;
  patternTiming?: Maybe<TimingIn>;
  patternMeta?: Maybe<MetaIn>;
  patternElementDefinition?: Maybe<ElementDefinitionIn>;
  patternContactDetail?: Maybe<ContactDetailIn>;
  patternContributor?: Maybe<ContributorIn>;
  patternDosage?: Maybe<DosageIn>;
  patternRelatedArtifact?: Maybe<RelatedArtifactIn>;
  patternUsageContext?: Maybe<UsageContextIn>;
  patternDataRequirement?: Maybe<DataRequirementIn>;
  patternParameterDefinition?: Maybe<ParameterDefinitionIn>;
  patternTriggerDefinition?: Maybe<TriggerDefinitionIn>;
  example?: Maybe<Array<Maybe<ElementDefinitionExampleIn>>>;
  minValueDate?: Maybe<Scalars['String']>;
  minValueDateTime?: Maybe<Scalars['String']>;
  minValueInstant?: Maybe<Scalars['String']>;
  minValueTime?: Maybe<Scalars['String']>;
  minValueDecimal?: Maybe<Scalars['Float']>;
  minValueInteger?: Maybe<Scalars['Float']>;
  minValuePositiveInt?: Maybe<Scalars['Float']>;
  minValueUnsignedInt?: Maybe<Scalars['Float']>;
  minValueQuantity?: Maybe<QuantityIn>;
  maxValueDate?: Maybe<Scalars['String']>;
  maxValueDateTime?: Maybe<Scalars['String']>;
  maxValueInstant?: Maybe<Scalars['String']>;
  maxValueTime?: Maybe<Scalars['String']>;
  maxValueDecimal?: Maybe<Scalars['Float']>;
  maxValueInteger?: Maybe<Scalars['Float']>;
  maxValuePositiveInt?: Maybe<Scalars['Float']>;
  maxValueUnsignedInt?: Maybe<Scalars['Float']>;
  maxValueQuantity?: Maybe<QuantityIn>;
  maxLength?: Maybe<Scalars['Float']>;
  condition?: Maybe<Array<Scalars['String']>>;
  constraint?: Maybe<Array<Maybe<ElementDefinitionConstraintIn>>>;
  mustSupport?: Maybe<Scalars['Boolean']>;
  isModifier?: Maybe<Scalars['Boolean']>;
  isSummary?: Maybe<Scalars['Boolean']>;
  binding?: Maybe<ElementDefinitionBindingIn>;
  mapping?: Maybe<Array<Maybe<ElementDefinitionMappingIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type ElementDefinitionMapping = {
  __typename: 'ElementDefinitionMapping';
  identity?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  map?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ElementDefinitionMappingIn = {
  identity?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  map?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ElementDefinitionRepresentation {
  xmlAttr = 'xmlAttr',
  xmlText = 'xmlText',
  typeAttr = 'typeAttr',
  cdaText = 'cdaText',
  xhtml = 'xhtml',
}

export type ElementDefinitionSlicing = {
  __typename: 'ElementDefinitionSlicing';
  discriminator?: Maybe<Array<ElementDefinitionDiscriminator>>;
  description?: Maybe<Scalars['String']>;
  ordered?: Maybe<Scalars['Boolean']>;
  rules?: Maybe<ElementDefinitionSlicingRules>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ElementDefinitionSlicingIn = {
  discriminator?: Maybe<Array<Maybe<ElementDefinitionDiscriminatorIn>>>;
  description?: Maybe<Scalars['String']>;
  ordered?: Maybe<Scalars['Boolean']>;
  rules?: Maybe<ElementDefinitionSlicingRules>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ElementDefinitionSlicingRules {
  closed = 'closed',
  open = 'open',
  openAtEnd = 'openAtEnd',
}

export type ElementDefinitionType = {
  __typename: 'ElementDefinitionType';
  code?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
  targetProfile?: Maybe<Scalars['String']>;
  aggregation?: Maybe<Array<ElementDefinitionTypeAggregation>>;
  versioning?: Maybe<ElementDefinitionTypeVersioning>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export enum ElementDefinitionTypeAggregation {
  contained = 'contained',
  referenced = 'referenced',
  bundled = 'bundled',
}

export type ElementDefinitionTypeIn = {
  code?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
  targetProfile?: Maybe<Scalars['String']>;
  aggregation?: Maybe<Array<ElementDefinitionTypeAggregation>>;
  versioning?: Maybe<ElementDefinitionTypeVersioning>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ElementDefinitionTypeVersioning {
  either = 'either',
  independent = 'independent',
  specific = 'specific',
}

export type ElementIn = {
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type Eligibility = {
  __typename: 'Eligibility';
  inclusion?: Maybe<Scalars['String']>;
  exclusion?: Maybe<Scalars['String']>;
  gender: Gender;
  age: Age;
};

export type EligibilityFilter = {
  inclusion?: Maybe<StringFilter>;
  exclusion?: Maybe<StringFilter>;
  gender?: Maybe<Gender>;
  age?: Maybe<IntegerFilter>;
};

export type EligibilityFilterSummary = {
  __typename: 'EligibilityFilterSummary';
  inclusion?: Maybe<StringFilterSummary>;
  exclusion?: Maybe<StringFilterSummary>;
  gender?: Maybe<Gender>;
  age?: Maybe<IntegerFilterSummary>;
};

export type EmailAlreadySetError = {
  __typename: 'EmailAlreadySetError';
  message: Scalars['String'];
};

export type EngagementNotification = Notification & {
  __typename: 'EngagementNotification';
  id: Scalars['ID'];
  time: Scalars['Date'];
  proofOfAccess: Scalars['String'];
  text: Scalars['String'];
  fullText: Scalars['String'];
  /** Identifier for sending tracking events */
  messageId?: Maybe<Scalars['ID']>;
  /** A string used for the push notification title */
  title?: Maybe<Scalars['String']>;
  /** A string that is mapped to a local resource (with fallback to default icon) */
  icon?: Maybe<Scalars['String']>;
  /** An optional link to an internal screen or external resource for more information */
  notificationLink?: Maybe<NotificationLink>;
  /**
   * Legacy functionality specific to LifeOmic apps.
   * It IS NOT necessary to specify a pre-defined app when requesting a notification.
   * Making this a hard requirement was dropped to support Branded Mobile Apps.
   */
  showInApps?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Entitlement {
  lifeAscent = 'lifeAscent',
  lifeAscentLegacy = 'lifeAscentLegacy',
  lifePlus = 'lifePlus',
}

export type EntitlementInfo = {
  __typename: 'EntitlementInfo';
  name: Entitlement;
  firstSubscriptionEpoch: Scalars['Int'];
  expirationEpoch?: Maybe<Scalars['Int']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
};

export type EntityConnection = {
  __typename: 'EntityConnection';
  edges: Array<EntityEdge>;
  pageInfo: PageInfo;
};

export type EntityEdge = {
  __typename: 'EntityEdge';
  entityId: Scalars['ID'];
};

export enum EntityType {
  CIRCLE = 'CIRCLE',
}

export type ExcludeFHIRResources = {
  observations: Array<Scalars['String']>;
  procedures: Array<Scalars['String']>;
  fasts: Array<Scalars['String']>;
};

export enum ExercisePattern {
  never = 'never',
  occasionally = 'occasionally',
  weekly = 'weekly',
  multiple_times_per_week = 'multiple_times_per_week',
  every_day = 'every_day',
}

export type ExercisePatternRestriction = {
  __typename: 'ExercisePatternRestriction';
  allowed: Array<ExercisePattern>;
};

export type ExercisePatternRestrictionInput = {
  allowed?: Maybe<Array<ExercisePattern>>;
};

export type ExpertiseSource = {
  __typename: 'ExpertiseSource';
  id: Scalars['ID'];
  available: Scalars['Boolean'];
  online: Scalars['Boolean'];
  name: Scalars['String'];
  image?: Maybe<SkillSpringImage>;
};

export type Extension = {
  __typename: 'Extension';
  url?: Maybe<Scalars['String']>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueBase64Binary?: Maybe<Scalars['String']>;
  valueInstant?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueCode?: Maybe<Scalars['String']>;
  valueOid?: Maybe<Scalars['String']>;
  valueUuid?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['String']>;
  valueUnsignedInt?: Maybe<Scalars['Float']>;
  valuePositiveInt?: Maybe<Scalars['Float']>;
  valueMarkdown?: Maybe<Scalars['String']>;
  valueElement?: Maybe<Element>;
  valueExtension?: Maybe<Extension>;
  valueBackboneElement?: Maybe<BackboneElement>;
  valueNarrative?: Maybe<Narrative>;
  valueAnnotation?: Maybe<Annotation>;
  valueAttachment?: Maybe<Attachment>;
  valueIdentifier?: Maybe<Identifier>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueCoding?: Maybe<Coding>;
  valueQuantity?: Maybe<Quantity>;
  valueDuration?: Maybe<Duration>;
  valueSimpleQuantity?: Maybe<Quantity>;
  valueDistance?: Maybe<Distance>;
  valueCount?: Maybe<Count>;
  valueMoney?: Maybe<Money>;
  valueAge?: Maybe<Age>;
  valueRange?: Maybe<Range>;
  valuePeriod?: Maybe<Period>;
  valueRatio?: Maybe<Ratio>;
  valueReference?: Maybe<Reference>;
  valueSampledData?: Maybe<SampledData>;
  valueSignature?: Maybe<Signature>;
  valueHumanName?: Maybe<HumanName>;
  valueAddress?: Maybe<Address>;
  valueContactPoint?: Maybe<ContactPoint>;
  valueTiming?: Maybe<Timing>;
  valueMeta?: Maybe<Meta>;
  valueElementDefinition?: Maybe<ElementDefinition>;
  valueContactDetail?: Maybe<ContactDetail>;
  valueContributor?: Maybe<Contributor>;
  valueDosage?: Maybe<Dosage>;
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  valueUsageContext?: Maybe<UsageContext>;
  valueDataRequirement?: Maybe<DataRequirement>;
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ExtensionIn = {
  url?: Maybe<Scalars['String']>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueBase64Binary?: Maybe<Scalars['String']>;
  valueInstant?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueCode?: Maybe<Scalars['String']>;
  valueOid?: Maybe<Scalars['String']>;
  valueUuid?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['String']>;
  valueUnsignedInt?: Maybe<Scalars['Float']>;
  valuePositiveInt?: Maybe<Scalars['Float']>;
  valueMarkdown?: Maybe<Scalars['String']>;
  valueElement?: Maybe<ElementIn>;
  valueExtension?: Maybe<ExtensionIn>;
  valueBackboneElement?: Maybe<BackboneElementIn>;
  valueNarrative?: Maybe<NarrativeIn>;
  valueAnnotation?: Maybe<AnnotationIn>;
  valueAttachment?: Maybe<AttachmentIn>;
  valueIdentifier?: Maybe<IdentifierIn>;
  valueCodeableConcept?: Maybe<CodeableConceptIn>;
  valueCoding?: Maybe<CodingIn>;
  valueQuantity?: Maybe<QuantityIn>;
  valueDuration?: Maybe<DurationIn>;
  valueSimpleQuantity?: Maybe<QuantityIn>;
  valueDistance?: Maybe<DistanceIn>;
  valueCount?: Maybe<CountIn>;
  valueMoney?: Maybe<MoneyIn>;
  valueAge?: Maybe<AgeIn>;
  valueRange?: Maybe<RangeIn>;
  valuePeriod?: Maybe<PeriodIn>;
  valueRatio?: Maybe<RatioIn>;
  valueReference?: Maybe<ReferenceIn>;
  valueSampledData?: Maybe<SampledDataIn>;
  valueSignature?: Maybe<SignatureIn>;
  valueHumanName?: Maybe<HumanNameIn>;
  valueAddress?: Maybe<AddressIn>;
  valueContactPoint?: Maybe<ContactPointIn>;
  valueTiming?: Maybe<TimingIn>;
  valueMeta?: Maybe<MetaIn>;
  valueElementDefinition?: Maybe<ElementDefinitionIn>;
  valueContactDetail?: Maybe<ContactDetailIn>;
  valueContributor?: Maybe<ContributorIn>;
  valueDosage?: Maybe<DosageIn>;
  valueRelatedArtifact?: Maybe<RelatedArtifactIn>;
  valueUsageContext?: Maybe<UsageContextIn>;
  valueDataRequirement?: Maybe<DataRequirementIn>;
  valueParameterDefinition?: Maybe<ParameterDefinitionIn>;
  valueTriggerDefinition?: Maybe<TriggerDefinitionIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum FamilyConditions {
  type_2_diabetes = 'type_2_diabetes',
  hypertension = 'hypertension',
  heart_disease = 'heart_disease',
  cancer = 'cancer',
  copd = 'copd',
  asthma = 'asthma',
  alzheimers = 'alzheimers',
  parkinsons = 'parkinsons',
  autoimmune = 'autoimmune',
  multiple_sclerosis = 'multiple_sclerosis',
  none = 'none',
}

export type FamilyConditionsRestriction = {
  __typename: 'FamilyConditionsRestriction';
  allowed: Array<FamilyConditions>;
};

export type FamilyConditionsRestrictionInput = {
  allowed?: Maybe<Array<FamilyConditions>>;
};

export type Fast = {
  __typename: 'Fast';
  /** The time when the fast ended. Ongoing fasts have no end time. */
  end?: Maybe<Scalars['Date']>;
  /** The intended length of the fast in seconds. */
  goalDuration: Scalars['Float'];
  id: Scalars['ID'];
  /**
   * A flag indicating if the fast data should be considered stale or not.
   * Stale data may not accurately reflect a user's real behavior.
   */
  isStale: Scalars['Boolean'];
  /** The time when the fast began. */
  start: Scalars['Date'];
  /** The cannonical ID of the user performing the fast. */
  user: Scalars['String'];
  /** Whether or not the fast has been deleted. */
  deleted: Scalars['Boolean'];
  /** The most recent mood update during this fast */
  moodUpdate?: Maybe<MoodUpdate>;
};

export type FastCreationInput = {
  id?: Maybe<Scalars['ID']>;
  /** The intended length of the fast in seconds. */
  goalDuration: Scalars['Float'];
  /**
   * The time the fast was completed. If this is not provided the fast will
   * be considered ongoing.
   */
  end?: Maybe<Scalars['Date']>;
  /** The time that the fast started. */
  start: Scalars['Date'];
};

export type FastDurationRange = {
  __typename: 'FastDurationRange';
  /** If fast duration posts are given, there must be at least a minimum */
  minimum: Scalars['Int'];
  maximum?: Maybe<Scalars['Int']>;
};

export type FastDurationRangeInput = {
  minimum: Scalars['Int'];
  maximum?: Maybe<Scalars['Int']>;
};

export type FastGoalReachedUpdate = Update & {
  __typename: 'FastGoalReachedUpdate';
  id: Scalars['ID'];
  /** The time of the update. */
  time: Scalars['Date'];
  /**
   * The cannonical ID of the user who posted the update.
   * @deprecated use author
   */
  user: Scalars['String'];
  /** The user who completed the fast. */
  author: User;
  /** Human readable text that can be used as a fallback */
  text: Scalars['String'];
  /** Fast data associated with the update */
  fast?: Maybe<Fast>;
  /** Urls to images associated with this update */
  imageUrls: Array<Scalars['URL']>;
  /**
   * Username of users who were tagged in this update
   * @deprecated use taggedFullUsers
   */
  taggedUsers: Array<Scalars['String']>;
  /** Users who were tagged in this update */
  taggedFullUsers: Array<User>;
  /**
   * An "access token" of sorts that can be used to re-fetch the update by
   * ID using the update(id: ID!) query.
   */
  proofOfAccess?: Maybe<Scalars['String']>;
  /** Connection for retrieving comments */
  commentsConnection: UpdateCommentsConnection;
  /** Connection for retrieving likes */
  likesConnection: UpdateLikesConnection;
  liked: Scalars['Boolean'];
};

export type FastGoalReachedUpdatecommentsConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type FastGoalReachedUpdatelikesConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/**
 * A fasting circle is the same as a circle from the social circle service
 * except that it is augmented with each member's fasting data.
 */
export type FastingCircle = {
  __typename: 'FastingCircle';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  owner: User;
  image?: Maybe<Scalars['URL']>;
  members: Array<User>;
};

export type FastUpdateInput = {
  /**
   * The intended length of the fast in seconds. The goal duration can only
   * be modified and cannot be removed.
   */
  goalDuration?: Maybe<Scalars['Float']>;
  /**
   * The time that the fast was completed. Once a fast has been completed the
   * end time may only be modified and cannot be removed.
   */
  end?: Maybe<Scalars['Date']>;
  /**
   * The time that the fast started. The start date can only be modified and
   * cannot be removed.
   */
  start?: Maybe<Scalars['Date']>;
  /**
   * Urls to images associated with the update associated with this fast.
   * This is only used when ending a fast.
   */
  imageUrls?: Maybe<Array<Scalars['URL']>>;
  /**
   * Username of users who were tagged in this update
   * This is only used when ending a fast.
   */
  taggedUsers?: Maybe<Array<Scalars['String']>>;
};

/**
 * A FastWindow represents a collection of fasts within a time range that
 * can be used to generate statistics.
 */
export type FastWindow = {
  __typename: 'FastWindow';
  /** The number of completed fasts included in the window. */
  count: Scalars['Int'];
  /** The (inclusive) end of the fasting window. */
  end: Scalars['Date'];
  /**
   * The fast payloads (including ongoing) that are included in the time
   * range.
   */
  fasts: Array<Fast>;
  /**
   * The length of the longest fast completed within the time range in
   * seconds.
   */
  maximumDurationCompleted: Scalars['Float'];
  /** The (exclusive) beginning of the fasting window. */
  start: Scalars['Date'];
  /**
   * The total amount of time in ketosis in seconds within the time range.
   * This value does not include ongoing fasts.
   */
  totalKetosisTime: Scalars['Float'];
  /**
   * The total time spent fasting in seconds within the time range.
   * This value does not include ongoing fasts.
   */
  totalFastingTime: Scalars['Float'];
};

export type FeatureForUserResponse = {
  __typename: 'FeatureForUserResponse';
  status: FeatureStatus;
  feature: LifeAppsFeature;
};

/**
 * The lifepoints feature is available because the lifepoints concept has largely
 * been removed from the Life Extend app as part of the effort to reduce costs -
 * but is reimplemented as an account opt in feature
 */
export enum Features {
  surveys = 'surveys',
  consent = 'consent',
  engagement = 'engagement',
  precisionOCR = 'precisionOCR',
  genomics = 'genomics',
  ontologies = 'ontologies',
  automation = 'automation',
  circles = 'circles',
  cohorts = 'cohorts',
  programs = 'programs',
  trialMatching = 'trialMatching',
  marketplace = 'marketplace',
  customApps = 'customApps',
  notebooks = 'notebooks',
  insights = 'insights',
  files = 'files',
  participantProgress = 'participantProgress',
  hiddenOrgTile = 'hiddenOrgTile',
  userDefinedEmails = 'userDefinedEmails',
  allowUnverifiedEmails = 'allowUnverifiedEmails',
  allowUnverifiedSms = 'allowUnverifiedSms',
  minimizeFastingFeatures = 'minimizeFastingFeatures',
  minimizeCoachingFeatures = 'minimizeCoachingFeatures',
  contentGlobalScope = 'contentGlobalScope',
  medicalDevices = 'medicalDevices',
  lifepoints = 'lifepoints',
}

export enum FeatureStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type FeedEntriesConnection = {
  __typename: 'FeedEntriesConnection';
  edges: Array<FeedEntryEdge>;
  pageInfo: PageInfo;
};

export type FeedEntry = {
  __typename: 'FeedEntry';
  updateId: Scalars['ID'];
  /**
   * If you are only interested in the id attribute from the update,
   * consider using the updateId attribute instead because it is much
   * faster to compute
   */
  update: Update;
  time: Scalars['Date'];
  /**
   * An "access token" of sorts that can be used to fetch the update by ID
   * using the update(id: ID!) query.
   */
  proofOfAccess: Scalars['String'];
};

export type FeedEntryEdge = {
  __typename: 'FeedEntryEdge';
  node: FeedEntry;
};

export type Field = {
  __typename: 'Field';
  name: Scalars['String'];
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FileLocation = {
  __typename: 'FileLocation';
  permanentUrl: Scalars['String'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  uploadUrl: Scalars['String'];
};

export enum FileType {
  PNG = 'PNG',
  JPG = 'JPG',
  JPEG = 'JPEG',
  GIF = 'GIF',
  PDF = 'PDF',
  MP4 = 'MP4',
  MOV = 'MOV',
}

export type FileUploadUrlInput = {
  fileType: FileType;
  parentId: Scalars['ID'];
  parentType: ParentType;
  filename?: Maybe<Scalars['String']>;
};

export type FileUploadUrlPayload = {
  __typename: 'FileUploadUrlPayload';
  id: Scalars['ID'];
  fileLocation: FileLocation;
};

export type FollowerNotification = Notification & {
  __typename: 'FollowerNotification';
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  notificationUserId: Scalars['ID'];
  parentPostId: Scalars['ID'];
  replyPostId: Scalars['ID'];
  batchId: Scalars['ID'];
  lastNotificationSent: Scalars['Date'];
};

export type ForumSettings = {
  __typename: 'ForumSettings';
  userSettings: UserSettings;
  notificationSettings: NotificationSettings;
};

export type ForumSettingsPayload = {
  __typename: 'ForumSettingsPayload';
  entityId: Scalars['ID'];
  entityType: EntityType;
  forumSettings: ForumSettings;
};

export enum Gender {
  all = 'all',
  male = 'male',
  female = 'female',
}

export type GenerateWebAppFromManifestInput = {
  url: Scalars['String'];
  manifestPath?: Maybe<Scalars['String']>;
};

export type Goal = {
  __typename: 'Goal';
  resourceType: GoalResourceType;
  identifier?: Maybe<Array<Identifier>>;
  status?: Maybe<GoalStatus>;
  category?: Maybe<Array<CodeableConcept>>;
  priority?: Maybe<CodeableConcept>;
  description?: Maybe<CodeableConcept>;
  subject?: Maybe<Reference>;
  startDate?: Maybe<Scalars['String']>;
  startCodeableConcept?: Maybe<CodeableConcept>;
  target?: Maybe<GoalTarget>;
  statusDate?: Maybe<Scalars['String']>;
  statusReason?: Maybe<Scalars['String']>;
  expressedBy?: Maybe<Reference>;
  addresses?: Maybe<Array<Reference>>;
  note?: Maybe<Array<Annotation>>;
  outcomeCode?: Maybe<Array<CodeableConcept>>;
  outcomeReference?: Maybe<Array<Reference>>;
  text?: Maybe<Narrative>;
  contained?: Maybe<Array<ResourceList>>;
  extension?: Maybe<Array<Extension>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Meta>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type GoalEdge = {
  __typename: 'GoalEdge';
  node: Goal;
};

export type GoalIn = {
  resourceType: GoalResourceType;
  identifier?: Maybe<Array<Maybe<IdentifierIn>>>;
  status?: Maybe<GoalStatus>;
  category?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  priority?: Maybe<CodeableConceptIn>;
  description?: Maybe<CodeableConceptIn>;
  subject?: Maybe<ReferenceIn>;
  startDate?: Maybe<Scalars['String']>;
  startCodeableConcept?: Maybe<CodeableConceptIn>;
  target?: Maybe<GoalTargetIn>;
  statusDate?: Maybe<Scalars['String']>;
  statusReason?: Maybe<Scalars['String']>;
  expressedBy?: Maybe<ReferenceIn>;
  addresses?: Maybe<Array<Maybe<ReferenceIn>>>;
  note?: Maybe<Array<Maybe<AnnotationIn>>>;
  outcomeCode?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  outcomeReference?: Maybe<Array<Maybe<ReferenceIn>>>;
  text?: Maybe<NarrativeIn>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<MetaIn>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export enum GoalResourceType {
  Goal = 'Goal',
}

export type GoalsConnection = {
  __typename: 'GoalsConnection';
  edges: Array<GoalEdge>;
  pageInfo: PageInfo;
};

export enum GoalStatus {
  proposed = 'proposed',
  accepted = 'accepted',
  planned = 'planned',
  in_progress = 'in_progress',
  on_target = 'on_target',
  ahead_of_target = 'ahead_of_target',
  behind_target = 'behind_target',
  sustaining = 'sustaining',
  achieved = 'achieved',
  on_hold = 'on_hold',
  cancelled = 'cancelled',
  entered_in_error = 'entered_in_error',
  rejected = 'rejected',
}

export type GoalTarget = {
  __typename: 'GoalTarget';
  measure?: Maybe<CodeableConcept>;
  detailQuantity?: Maybe<Quantity>;
  detailRange?: Maybe<Range>;
  detailCodeableConcept?: Maybe<CodeableConcept>;
  dueDate?: Maybe<Scalars['String']>;
  dueDuration?: Maybe<Duration>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type GoalTargetIn = {
  measure?: Maybe<CodeableConceptIn>;
  detailQuantity?: Maybe<QuantityIn>;
  detailRange?: Maybe<RangeIn>;
  detailCodeableConcept?: Maybe<CodeableConceptIn>;
  dueDate?: Maybe<Scalars['String']>;
  dueDuration?: Maybe<DurationIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type Group = {
  __typename: 'Group';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: GroupType;
  account: Scalars['ID'];
  deleteProtected: Scalars['Boolean'];
  membersConnection: GroupMembersConnection;
};

export type GroupmembersConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  skipDeletedPruning?: Maybe<Scalars['Boolean']>;
};

export type GroupMembersConnection = {
  __typename: 'GroupMembersConnection';
  edges: Array<GroupMembersEdge>;
  pageInfo: PageInfo;
};

export type GroupMembersEdge = {
  __typename: 'GroupMembersEdge';
  node: User;
};

export enum GroupType {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export type HomeScreenNotification = Notification & {
  __typename: 'HomeScreenNotification';
  id: Scalars['ID'];
  notificationBody: Scalars['String'];
  messageId?: Maybe<Scalars['ID']>;
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  answerType?: Maybe<NotificationFeedbackAnswerType>;
  /** An array of answer options to display with the notification. */
  answerOptions?: Maybe<Array<NotificationFeedbackAnswerOption>>;
  /** An optional link to an external resource for more information (learning library) */
  notificationLink?: Maybe<NotificationLink>;
  /** The code to add to a FHIR Meta tag when recording the answer as Observation */
  metaTagCode: Scalars['String'];
  /**
   * Legacy functionality specific to LifeOmic apps.
   * It IS NOT necessary to specify a pre-defined app when requesting a notification.
   * Making this a hard requirement was dropped to support Branded Mobile Apps.
   */
  showInApps?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Set to a pillar type to get specific iconography and colors. Null implies "general" notification */
  pillarType?: Maybe<PillarType>;
  /** The title/heading to show for the notification */
  title: Scalars['String'];
  /** Indicates that the notification should auto-expand in the UI */
  autoExpand: Scalars['Boolean'];
};

export type HumanName = {
  __typename: 'HumanName';
  use?: Maybe<HumanNameUse>;
  text?: Maybe<Scalars['String']>;
  family?: Maybe<Scalars['String']>;
  given?: Maybe<Array<Scalars['String']>>;
  prefix?: Maybe<Array<Scalars['String']>>;
  suffix?: Maybe<Array<Scalars['String']>>;
  period?: Maybe<Period>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type HumanNameIn = {
  use?: Maybe<HumanNameUse>;
  text?: Maybe<Scalars['String']>;
  family?: Maybe<Scalars['String']>;
  given?: Maybe<Array<Scalars['String']>>;
  prefix?: Maybe<Array<Scalars['String']>>;
  suffix?: Maybe<Array<Scalars['String']>>;
  period?: Maybe<PeriodIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum HumanNameUse {
  usual = 'usual',
  official = 'official',
  temp = 'temp',
  nickname = 'nickname',
  anonymous = 'anonymous',
  old = 'old',
  maiden = 'maiden',
}

export type Identifier = {
  __typename: 'Identifier';
  use?: Maybe<IdentifierUse>;
  type?: Maybe<CodeableConcept>;
  system?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  period?: Maybe<Period>;
  assigner?: Maybe<Reference>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type IdentifierIn = {
  use?: Maybe<IdentifierUse>;
  type?: Maybe<CodeableConceptIn>;
  system?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  period?: Maybe<PeriodIn>;
  assigner?: Maybe<ReferenceIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum IdentifierUse {
  usual = 'usual',
  official = 'official',
  temp = 'temp',
  secondary = 'secondary',
}

export type Identity = {
  __typename: 'Identity';
  providerName: Scalars['String'];
};

export enum ImageType {
  PNG = 'PNG',
  JPG = 'JPG',
  JPEG = 'JPEG',
  GIF = 'GIF',
}

export type ImageUploadUrlResponse = {
  __typename: 'ImageUploadUrlResponse';
  permanentUrl: Scalars['URL'];
  uploadUrl: Scalars['URL'];
};

export type InappropriatePostNotification = Notification & {
  __typename: 'InappropriatePostNotification';
  post: Post;
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  notificationUserId: Scalars['ID'];
  parentId: Scalars['ID'];
  rootParentId: Scalars['ID'];
  originalPostId: Scalars['ID'];
  inappropriatePostId: Scalars['ID'];
};

export enum InfoCodeType {
  TooManyWinnersPlace1 = 'TooManyWinnersPlace1',
  TooManyWinnersPlace2 = 'TooManyWinnersPlace2',
  TooManyWinnersPlace3 = 'TooManyWinnersPlace3',
  Unknown = 'Unknown',
}

export type InstallGroupWebAppInput = {
  appId: Scalars['ID'];
  groupId: Scalars['String'];
};

export type InstallWebAppInput = {
  appId: Scalars['ID'];
  userId: Scalars['String'];
};

export type IntegerFilter = {
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
};

export type IntegerFilterSummary = {
  __typename: 'IntegerFilterSummary';
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
};

export type Intervention = {
  __typename: 'Intervention';
  drugs?: Maybe<Array<Maybe<Drug>>>;
};

export type InterventionFilter = {
  drug?: Maybe<StringFilter>;
  drugClass?: Maybe<StringFilter>;
};

export type InterventionFilterSummary = {
  __typename: 'InterventionFilterSummary';
  drug?: Maybe<StringFilterSummary>;
  drugClass?: Maybe<StringFilterSummary>;
};

export type Invitation = {
  __typename: 'Invitation';
  id: Scalars['ID'];
  signupOrLoginLink?: Maybe<Scalars['String']>;
};

export type InvitationAlreadyAccepted = {
  __typename: 'InvitationAlreadyAccepted';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type InvitationOperations = {
  __typename: 'InvitationOperations';
  invitation: Invitation;
  /** @deprecated use top level acceptInvitation instead */
  accept: InvitationOperationsAcceptResult;
  /** @deprecated use top level rejectInvitation instead */
  reject: Scalars['Boolean'];
};

export type InvitationOperationsAcceptResult = Circle | NoOp;

export type InviteDoesNotExist = {
  __typename: 'InviteDoesNotExist';
  message?: Maybe<Scalars['String']>;
};

export type InviteRequiresAccountCustomAuthentication = {
  __typename: 'InviteRequiresAccountCustomAuthentication';
  accountId: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  accountName: Scalars['String'];
  allowLinkedIdentities: Scalars['Boolean'];
};

export enum LaunchUrlBrowserMode {
  External = 'External',
  InApp = 'InApp',
}

export type LaunchUrlTileBehavior = {
  __typename: 'LaunchUrlTileBehavior';
  url: Scalars['URL'];
  /**
   * The custom web app client ID that is used by the linked tile.
   * Providing this value allows for clients (e.g. LX) to automatically
   * provide authentication credentials for the current user when launching
   * the app.
   */
  appClientId?: Maybe<Scalars['String']>;
  browserMode: LaunchUrlBrowserMode;
};

export type LeaveConversationInput = {
  conversationId: Scalars['ID'];
};

export type LifeAggregatesFHIRResources = {
  observations: Array<ObservationIn>;
  procedures: Array<ProcedureIn>;
  fasts: Array<LifeAggregatesUpsertFast>;
};

export type LifeAggregatesUpsertFast = {
  id: Scalars['ID'];
  goalDuration?: Maybe<Scalars['Float']>;
  end?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
};

export enum LifeAppsFeature {
  PrivateMessages = 'PrivateMessages',
}

export enum LifeAppsSubscriptionTier {
  FREE = 'FREE',
  PLUS = 'PLUS',
}

export type LifeNotificationSettingInput = {
  /**
   * The field `systemGeneratedNotificationLevel` is deprecated,
   * this input will no longer be required. Do not implement further
   * use when updating Circle or forum settings for future removal.
   */
  systemGeneratedNotificationLevel?: Maybe<NotificationLevel>;
  moodUpdates?: Scalars['Boolean'];
  /** Expecting values in seconds. If null, fast duration notifications are turned off */
  fastDuration?: Maybe<FastDurationRangeInput>;
  /** Default is false, because this could be a noisy in larger circles */
  joinCircle?: Scalars['Boolean'];
  /** Default is false, because will only apply to LX, otherwise these posts will be hidden on LIFE clients */
  weeklyTopLifePointUsers?: Scalars['Boolean'];
};

export type LifeNotificationSettings = {
  __typename: 'LifeNotificationSettings';
  /** Controls whether automatic posts will be generated in a Circle notifiying member mood updates */
  moodUpdates: Scalars['Boolean'];
  /** @deprecated No longer going to implement Circle controling notifications */
  systemGeneratedNotificationLevel?: Maybe<NotificationLevel>;
  /** Expecting values in seconds. If null, fast duration notifications are turned off */
  fastDuration?: Maybe<FastDurationRange>;
  /** Controls whether automatic posts will be generated in a Circle notifiying of new members joining */
  joinCircle: Scalars['Boolean'];
  /** Controls whether automatic posts will be generated in a Circle notifiying of the top 1-3 LIFE Point Users for LX clients */
  weeklyTopLifePointUsers: Scalars['Boolean'];
};

export type LifePointsInfo = {
  __typename: 'LifePointsInfo';
  start: Scalars['String'];
  end: Scalars['String'];
  system: Scalars['String'];
  code: Scalars['String'];
  /** @deprecated Use values field */
  totals: Array<LifePointsValue>;
  values: Array<LifePointsValue>;
};

export type LifePointsInfoConnection = {
  __typename: 'LifePointsInfoConnection';
  edges: Array<LifePointsInfoEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type LifePointsInfoEdge = {
  __typename: 'LifePointsInfoEdge';
  node: LifePointsInfo;
};

export type LifePointsValue = {
  __typename: 'LifePointsValue';
  value: Scalars['Float'];
  target: Scalars['Float'];
  unit: Scalars['String'];
  system: Scalars['String'];
  code: Scalars['String'];
  display: Scalars['String'];
};

export type Like = {
  __typename: 'Like';
  id: Scalars['ID'];
  /** The associated update */
  update: Update;
  /** User ID that posted the comment */
  userId: Scalars['String'];
  user: User;
};

export type ListAppsInput = {
  product: AppStoreProduct;
  /** pagination: number of elements to retrieve */
  first?: Maybe<Scalars['Int']>;
  /** pagination: last page token */
  after?: Maybe<Scalars['String']>;
};

export enum ListBySetting {
  WEEKLY_TOP_LIFE_POINT_USERS = 'WEEKLY_TOP_LIFE_POINT_USERS',
}

export type ListInstalledAppsInput = {
  /** current user to filter by */
  userId: Scalars['String'];
  product: AppStoreProduct;
  /** pagination: number of elements to retrieve */
  first?: Maybe<Scalars['Int']>;
  /** pagination: last page token */
  after?: Maybe<Scalars['String']>;
};

export type Location = {
  __typename: 'Location';
  facility?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type LocationFilter = {
  facility?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Int']>;
  distanceUnit?: Maybe<DistanceUnit>;
};

export type LocationFilterSummary = {
  __typename: 'LocationFilterSummary';
  facility?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Int']>;
  distanceUnit?: Maybe<DistanceUnit>;
};

export type ManagingGroupInvitation = {
  __typename: 'ManagingGroupInvitation';
  id: Scalars['ID'];
  signupOrLoginLink?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  roleName: CircleManagingGroupsUserRole;
};

export type ManagingGroupsInvitationsConnection = {
  __typename: 'ManagingGroupsInvitationsConnection';
  edges: Array<ManagingGroupsInvitationsEdge>;
  pageInfo: PageInfo;
};

export type ManagingGroupsInvitationsEdge = {
  __typename: 'ManagingGroupsInvitationsEdge';
  node: ManagingGroupInvitation;
};

export type ManagingGroupsInvitationsFilterInput = {
  circleId: Scalars['ID'];
  roleName: CircleManagingGroupsUserRole;
};

export type Manifests = {
  __typename: 'Manifests';
  mpdUrl: Scalars['String'];
  m3u8Url: Scalars['String'];
};

export type MarkAsReadInput = {
  conversationId: Scalars['ID'];
};

export type MeasurementData = {
  __typename: 'MeasurementData';
  value: Scalars['Float'];
  unit: Scalars['String'];
};

export type MeasurementPreferences = {
  __typename: 'MeasurementPreferences';
  system?: Maybe<Scalars['String']>;
};

export type MeasurementPreferencesIn = {
  system?: Maybe<Scalars['String']>;
};

export type Meta = {
  __typename: 'Meta';
  versionId?: Maybe<Scalars['String']>;
  lastUpdated?: Maybe<Scalars['String']>;
  profile?: Maybe<Array<Scalars['String']>>;
  security?: Maybe<Array<Coding>>;
  tag?: Maybe<Array<Coding>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type MetaIn = {
  versionId?: Maybe<Scalars['String']>;
  lastUpdated?: Maybe<Scalars['String']>;
  profile?: Maybe<Array<Scalars['String']>>;
  security?: Maybe<Array<Maybe<CodingIn>>>;
  tag?: Maybe<Array<Maybe<CodingIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type MolecularProfileFilter = {
  gene?: Maybe<StringFilter>;
  profileName?: Maybe<StringFilter>;
};

export type Money = {
  __typename: 'Money';
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<MoneyComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export enum MoneyComparator {
  LT = 'LT',
  LTE = 'LTE',
  GTE = 'GTE',
  GT = 'GT',
}

export type MoneyIn = {
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<MoneyComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum Mood {
  GOOD = 'GOOD',
  AWESOME = 'AWESOME',
  EUPHORIC = 'EUPHORIC',
  STRUGGLING = 'STRUGGLING',
  STARVING = 'STARVING',
  CUSTOM = 'CUSTOM',
  CLEAR = 'CLEAR',
}

export type MoodUpdate = Update & {
  __typename: 'MoodUpdate';
  id: Scalars['ID'];
  /** The time of the update. */
  time: Scalars['Date'];
  /**
   * The cannonical ID of the user who posted the update.
   * @deprecated use author
   */
  user: Scalars['String'];
  /** The user who posted the update. */
  author: User;
  /** Human readable text that can be used as a fallback */
  text: Scalars['String'];
  /** Custom user mood content */
  content?: Maybe<Scalars['String']>;
  /** Custom user mood emoji */
  emoji?: Maybe<Scalars['String']>;
  /** The current mood of the user */
  mood: Mood;
  /** Urls to images associated with this update */
  imageUrls: Array<Scalars['URL']>;
  /**
   * Username of users who were tagged in this update
   * @deprecated use taggedFullUsers
   */
  taggedUsers: Array<Scalars['String']>;
  /** Users who were tagged in this update */
  taggedFullUsers: Array<User>;
  /**
   * An "access token" of sorts that can be used to re-fetch the update by
   * ID using the update(id: ID!) query.
   */
  proofOfAccess?: Maybe<Scalars['String']>;
  /** Connection for retrieving comments */
  commentsConnection: UpdateCommentsConnection;
  /** Connection for retrieving likes */
  likesConnection: UpdateLikesConnection;
  liked: Scalars['Boolean'];
};

export type MoodUpdatecommentsConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type MoodUpdatelikesConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type MoodV2 = {
  id: Scalars['ID'];
  createdAt: Scalars['Date'];
};

export type Mutation = {
  __typename: 'Mutation';
  circle: CircleOperations;
  createNewCircle: CircleOperations;
  editCircle: EditCirclePayload;
  deleteCircle: DeleteCirclePayload;
  adminDeleteCircle: DeleteCirclePayload;
  removeFromManagingGroup: RemoveFromManagingGroupUnion;
  removeFromCircle: Scalars['Boolean'];
  joinPublicCircle: Scalars['Boolean'];
  invitation: InvitationOperations;
  createInvitation: Invitation;
  createManagingGroupInvitation: ManagingGroupInvitation;
  deleteManagingGroupInvitation: Scalars['Boolean'];
  acceptInvitation: AcceptInvitationResult;
  rejectInvitation: RejectInvitationResult;
  updateSocialCircleUserPrivacyPreferences: Scalars['Boolean'];
  /**
   * Only needed if the user wants to create paid Circles.
   * The first time this is called it will create a users
   * StripeConnected Account object. The user can onboard
   * by being forwarded to the url.
   */
  createCircleOwnerOnboardingLink: CircleOwnerStripeAccountLink;
  /** @deprecated Use createCircleOwnerOnboardingLink() instead */
  createStripeConnectAccount: StripeConnectAccount;
  createSubscriptionCircleSession?: Maybe<SubscriptionCircleSession>;
  createConversation: Scalars['ID'];
  leaveConversation: Scalars['ID'];
  markAsRead: Scalars['ID'];
  reportInappropriatePost: Scalars['Boolean'];
  blockInappropriatePost: BlockPostPayload;
  /** Register a new piece of content. */
  createEducationContent: EducationContent;
  /** Delete a piece of content. */
  deleteEducationContent?: Maybe<Scalars['Boolean']>;
  /** Update an existing registration for a piece of content. */
  updateEducationContent: EducationContent;
  /** Update the status for a piece of content and its translations */
  updateEducationContentStatus?: Maybe<Scalars['Boolean']>;
  /** Create a new fast record. */
  createFast: Fast;
  /** Delete a fast record. */
  deleteFast?: Maybe<Scalars['Boolean']>;
  /** Update an existing fast record. */
  updateFast: Fast;
  /** Create a new status update for selected circle */
  createStatusUpdateForCircle: StatusUpdate;
  /**
   * Get update by ID along with available mutation operations. Updates
   * retrieved through scoped channels, like feed entries and update
   * connections, can include a proofOfAccess token on the response. This
   * token can be used here to prove that access to the update was previously
   * granted.
   */
  update: UpdateOperations;
  /** Create a new mood update. */
  updateMood?: Maybe<MoodUpdate>;
  /** Upload an image for later consumption in an update */
  imageUploadUrl: ImageUploadUrlResponse;
  /**
   * delete a notification from the user's notification feed
   * returns the ID of the deleted notification
   */
  deleteNotification: Scalars['ID'];
  deleteHomeScreenNotification: Scalars['ID'];
  createWebApp: AppStoreWebApplication;
  deleteApp: Scalars['Boolean'];
  editWebApp: Scalars['Boolean'];
  installWebApp: AppStoreWebApplication;
  installGroupWebApp: AppStoreWebApplication;
  uninstallWebApp: Scalars['Boolean'];
  /** @deprecated use patient with no id */
  createPatient: Patient;
  updatePatient: Patient;
  createObservation: Observation;
  updateObservation: Observation;
  deleteObservation: Scalars['Boolean'];
  createProcedure: Procedure;
  updateProcedure: Procedure;
  deleteProcedure: Scalars['Boolean'];
  createGoal: Goal;
  updateGoal: Goal;
  deleteGoal: Scalars['Boolean'];
  createQuestionnaireResponse: QuestionnaireResponse;
  updateQuestionnaireResponse: QuestionnaireResponse;
  deleteQuestionnaireResponse: Scalars['Boolean'];
  createDiagnosticReport: DiagnosticReport;
  updateDiagnosticReport: DiagnosticReport;
  deleteDiagnosticReport: Scalars['Boolean'];
  createTask: Task;
  updateTask: Task;
  deleteTask: Scalars['Boolean'];
  /** @deprecated use REST API */
  createQuestionnaire: Questionnaire;
  /** Every update is treated like a PATCH, meaning that only provided preferences are updated */
  updatePrivacyPreferences: Scalars['Boolean'];
  updateAccountUserPrivacyPreferences: Scalars['Boolean'];
  updateClientValueCache: ClientValueCache;
  updateUser?: Maybe<User>;
  requestEmailChange: RequestEmailChangeResponse;
  confirmEmailChange: ConfirmEmailChangeResponse;
  addUserToBlocklist: BlockedUser;
  removeUserFromBlocklist: BlockedUser;
  createForumSettings: ForumSettingsPayload;
  /** Update a forum user settings by given entity id and desired user settings updates */
  updateUserSettings: UpdateUserSettingsPayload;
  /** Update a forum notification settings by given entity id and passing desired notification settings updates */
  updateNotificationSettings: UpdateNotificationSettingsPayload;
  /** Update forum user and/or notification settings by given entity id */
  updateForumSettings: UpdateForumSettingsPayload;
  addToSubscribersCircle: Scalars['Boolean'];
  setOfficialMood: SetOfficialMoodPayload;
  setCustomMood: SetCustomMoodPayload;
  reportMood: ReportMoodPayload;
  setFeatureStatusForUser: FeatureForUserResponse;
  createPost: CreatePostPayload;
  deletePost: DeletePostPayload;
  updatePostMessage: UpdatePostPayload;
  createPrivatePost: CreatePostPayload;
  privatePostFileUploadUrl: FileUploadUrlPayload;
  fileUploadUrl: FileUploadUrlPayload;
  createReaction: CreateReactionPayload;
  undoReaction: UndoReactionPayload;
  surveyAttachmentUploadUrl: SurveyAttachmentUploadResults;
  upsertSurveyServiceQuestionnaireResponse: QuestionnaireResponse;
};

export type MutationcircleArgs = {
  id: Scalars['ID'];
};

export type MutationcreateNewCircleArgs = {
  input: CircleCreationInput;
};

export type MutationeditCircleArgs = {
  input: EditCircleInput;
};

export type MutationdeleteCircleArgs = {
  input: DeleteCircleInput;
};

export type MutationadminDeleteCircleArgs = {
  input: AdminDeleteCircleInput;
};

export type MutationremoveFromManagingGroupArgs = {
  input: RemoveFromManagingGroupInput;
};

export type MutationremoveFromCircleArgs = {
  id: Scalars['ID'];
  userId: Scalars['String'];
};

export type MutationjoinPublicCircleArgs = {
  circleId: Scalars['ID'];
};

export type MutationinvitationArgs = {
  id: Scalars['ID'];
  localTimezone?: Maybe<Scalars['String']>;
};

export type MutationcreateInvitationArgs = {
  circleId: Scalars['ID'];
};

export type MutationcreateManagingGroupInvitationArgs = {
  input: CreateManagingGroupInvitationInput;
};

export type MutationdeleteManagingGroupInvitationArgs = {
  input: DeleteManagingGroupInvitationInput;
};

export type MutationacceptInvitationArgs = {
  id: Scalars['ID'];
  localTimezone?: Maybe<Scalars['String']>;
};

export type MutationrejectInvitationArgs = {
  id: Scalars['ID'];
  localTimezone?: Maybe<Scalars['String']>;
};

export type MutationupdateSocialCircleUserPrivacyPreferencesArgs = {
  preferences: SocialCircleServiceUserPrivacyPreferencesIn;
};

export type MutationcreateStripeConnectAccountArgs = {
  input: CreateStripeConnectAccountInput;
};

export type MutationcreateSubscriptionCircleSessionArgs = {
  input: CreateSubscriptionCircleSessionInput;
};

export type MutationcreateConversationArgs = {
  input: CreateConversationInput;
};

export type MutationleaveConversationArgs = {
  input: LeaveConversationInput;
};

export type MutationmarkAsReadArgs = {
  input: MarkAsReadInput;
};

export type MutationreportInappropriatePostArgs = {
  input: ReportInappropriatePostInput;
};

export type MutationblockInappropriatePostArgs = {
  input: BlockInappropriatePostInput;
};

export type MutationcreateEducationContentArgs = {
  content: EducationContentCreateInput;
};

export type MutationdeleteEducationContentArgs = {
  id: Scalars['ID'];
};

export type MutationupdateEducationContentArgs = {
  id: Scalars['ID'];
  updates: EducationContentUpdateInput;
};

export type MutationupdateEducationContentStatusArgs = {
  trid: Scalars['ID'];
  status: EducationContentStatus;
};

export type MutationcreateFastArgs = {
  fast: FastCreationInput;
};

export type MutationdeleteFastArgs = {
  id: Scalars['ID'];
};

export type MutationupdateFastArgs = {
  id: Scalars['ID'];
  updates: FastUpdateInput;
};

export type MutationcreateStatusUpdateForCircleArgs = {
  content: Scalars['String'];
  imageUrls?: Maybe<Array<Scalars['URL']>>;
  taggedUsers?: Maybe<Array<Scalars['String']>>;
  circleId: Scalars['String'];
  headline?: Maybe<Scalars['String']>;
};

export type MutationupdateArgs = {
  id: Scalars['ID'];
  proofOfAccess?: Maybe<Scalars['String']>;
};

export type MutationupdateMoodArgs = {
  mood: Mood;
  imageUrls?: Maybe<Array<Scalars['URL']>>;
  taggedUsers?: Maybe<Array<Scalars['String']>>;
  content?: Maybe<Scalars['String']>;
  emoji?: Maybe<Scalars['String']>;
};

export type MutationimageUploadUrlArgs = {
  imageType: ImageType;
};

export type MutationdeleteNotificationArgs = {
  id: Scalars['ID'];
};

export type MutationdeleteHomeScreenNotificationArgs = {
  id: Scalars['ID'];
};

export type MutationcreateWebAppArgs = {
  input: CreateWebAppInput;
};

export type MutationdeleteAppArgs = {
  id: Scalars['ID'];
};

export type MutationeditWebAppArgs = {
  id: Scalars['ID'];
  edits: EditWebAppInput;
};

export type MutationinstallWebAppArgs = {
  input: InstallWebAppInput;
};

export type MutationinstallGroupWebAppArgs = {
  input: InstallGroupWebAppInput;
};

export type MutationuninstallWebAppArgs = {
  input: UninstallWebAppInput;
};

export type MutationcreatePatientArgs = {
  patient: PatientIn;
};

export type MutationupdatePatientArgs = {
  patient: PatientIn;
};

export type MutationcreateObservationArgs = {
  observation: ObservationIn;
};

export type MutationupdateObservationArgs = {
  observation: ObservationIn;
};

export type MutationdeleteObservationArgs = {
  id: Scalars['String'];
};

export type MutationcreateProcedureArgs = {
  procedure: ProcedureIn;
};

export type MutationupdateProcedureArgs = {
  procedure: ProcedureIn;
};

export type MutationdeleteProcedureArgs = {
  id: Scalars['String'];
};

export type MutationcreateGoalArgs = {
  goal: GoalIn;
};

export type MutationupdateGoalArgs = {
  goal: GoalIn;
};

export type MutationdeleteGoalArgs = {
  id: Scalars['String'];
};

export type MutationcreateQuestionnaireResponseArgs = {
  questionnaireResponse: QuestionnaireResponseIn;
};

export type MutationupdateQuestionnaireResponseArgs = {
  questionnaireResponse: QuestionnaireResponseIn;
};

export type MutationdeleteQuestionnaireResponseArgs = {
  id: Scalars['String'];
};

export type MutationcreateDiagnosticReportArgs = {
  diagnosticReport: DiagnosticReportIn;
};

export type MutationupdateDiagnosticReportArgs = {
  diagnosticReport: DiagnosticReportIn;
};

export type MutationdeleteDiagnosticReportArgs = {
  id: Scalars['String'];
};

export type MutationcreateTaskArgs = {
  task: TaskIn;
};

export type MutationupdateTaskArgs = {
  task: TaskIn;
};

export type MutationdeleteTaskArgs = {
  id: Scalars['String'];
};

export type MutationcreateQuestionnaireArgs = {
  questionnaire: QuestionnaireIn;
};

export type MutationupdatePrivacyPreferencesArgs = {
  patientId: Scalars['String'];
  preferences: PatientPrivacyPreferencesIn;
};

export type MutationupdateAccountUserPrivacyPreferencesArgs = {
  preferences: AccountServiceUserPrivacyPreferencesIn;
};

export type MutationupdateClientValueCacheArgs = {
  userId: Scalars['ID'];
  app: ClientApp;
  valueCache: ClientValueCacheIn;
};

export type MutationupdateUserArgs = {
  userId: Scalars['ID'];
  userIn: UserIn;
};

export type MutationrequestEmailChangeArgs = {
  email: Scalars['String'];
};

export type MutationconfirmEmailChangeArgs = {
  token: Scalars['String'];
};

export type MutationaddUserToBlocklistArgs = {
  user: Scalars['ID'];
  blockedUser: Scalars['ID'];
};

export type MutationremoveUserFromBlocklistArgs = {
  user: Scalars['ID'];
  blockedUser: Scalars['ID'];
};

export type MutationcreateForumSettingsArgs = {
  input: CreateForumSettingsInput;
};

export type MutationupdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};

export type MutationupdateNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};

export type MutationupdateForumSettingsArgs = {
  input: UpdateForumSettingsInput;
};

export type MutationsetOfficialMoodArgs = {
  input: OfficialMoodOptions;
};

export type MutationsetCustomMoodArgs = {
  input: CustomMoodOptions;
};

export type MutationreportMoodArgs = {
  input: ReportMoodOptions;
};

export type MutationsetFeatureStatusForUserArgs = {
  user: Scalars['ID'];
  feature: LifeAppsFeature;
  status: FeatureStatus;
};

export type MutationcreatePostArgs = {
  input: CreatePostInput;
};

export type MutationdeletePostArgs = {
  input: DeletePostInput;
};

export type MutationupdatePostMessageArgs = {
  input: UpdatePostMessageInput;
};

export type MutationcreatePrivatePostArgs = {
  input: CreatePrivatePostInput;
};

export type MutationprivatePostFileUploadUrlArgs = {
  input: PrivatePostFileUploadUrlInput;
};

export type MutationfileUploadUrlArgs = {
  input: FileUploadUrlInput;
};

export type MutationcreateReactionArgs = {
  input: CreateReactionInput;
};

export type MutationundoReactionArgs = {
  input: UndoReactionInput;
};

export type MutationsurveyAttachmentUploadUrlArgs = {
  input: SurveyAttachmentUploadUrlInput;
};

export type MutationupsertSurveyServiceQuestionnaireResponseArgs = {
  projectId: Scalars['ID'];
  questionnaireResponse: QuestionnaireResponseIn;
};

export type Narrative = {
  __typename: 'Narrative';
  status?: Maybe<NarrativeStatus>;
  div?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type NarrativeIn = {
  status?: Maybe<NarrativeStatus>;
  div?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum NarrativeStatus {
  generated = 'generated',
  extensions = 'extensions',
  additional = 'additional',
  empty = 'empty',
}

export type NewAttachment = {
  id?: Maybe<Scalars['ID']>;
  externalId: Scalars['ID'];
  type: AttachmentType;
  subType: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
};

export type NewPost = {
  /** A unique identifier for the post, useful for ensuring idempotency */
  id?: Maybe<Scalars['ID']>;
  message: Scalars['String'];
  parentId: Scalars['ID'];
  parentType: ParentType;
  priority?: Maybe<Priority>;
  attachments?: Maybe<Array<Scalars['ID']>>;
  attachmentsV2?: Maybe<Array<NewAttachment>>;
  metadata?: Maybe<Scalars['String']>;
};

export type NewPrivatePost = {
  id?: Maybe<Scalars['ID']>;
  message: Scalars['String'];
  metadata?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Scalars['ID']>>;
  attachmentsV2?: Maybe<Array<NewAttachment>>;
};

export type NewSystemGeneratedPost = {
  /**  Optional. Use if the client is concerned about creating duplicate posts  */
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  parentId: Scalars['ID'];
  parentType: ParentType;
  /**  Optional. A JSON string. Used for metadata that is product specific (LIFE/LX/SkillSpring etc.)  */
  metadata?: Maybe<Scalars['String']>;
};

export type NoOp = {
  __typename: 'NoOp';
  _?: Maybe<Scalars['Boolean']>;
};

export type Notification = {
  id: Scalars['ID'];
  time: Scalars['Date'];
  /**
   * fallback text to note what action this represents
   * e.g. "commented on your post"
   * @deprecated use fullText
   */
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  /**
   * full text to display unaltered
   * e.g. "Sally Smith commented on your post"
   */
  fullText: Scalars['String'];
};

export type NotificationEdge = {
  __typename: 'NotificationEdge';
  node: Notification;
};

export type NotificationFeedbackAnswerOption = {
  __typename: 'NotificationFeedbackAnswerOption';
  value: Scalars['String'];
  label: Scalars['String'];
};

export enum NotificationFeedbackAnswerType {
  thumbs = 'thumbs',
  yesNo = 'yesNo',
  custom = 'custom',
}

/**
 * NotficationLevel was used with the deprecated field `systemGeneratedNotificationLevel`
 * and can be removed once clients are phased out that are making use of that field
 */
export enum NotificationLevel {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  OFF = 'OFF',
}

export type NotificationLink = {
  __typename: 'NotificationLink';
  /**
   * A string that is an external resource scheme (HTTP/HTTPS) or a React route (with
   * no scheme)
   */
  target: Scalars['String'];
  /** A JSON string of arbitrary route params. Can be used for route params inside Apps */
  params?: Maybe<Scalars['String']>;
  /** An optional label to describe the notificationLink */
  label?: Maybe<Scalars['String']>;
};

export type NotificationsConnection = {
  __typename: 'NotificationsConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
};

export type NotificationSettings = {
  __typename: 'NotificationSettings';
  /** Nullable because not all users of forum-settings service will have `life` settings used by life or lx clients */
  life?: Maybe<LifeNotificationSettings>;
};

export type NotificationSettingsInput = {
  life?: Maybe<LifeNotificationSettingInput>;
};

export type NotificationSettingsUpdateInput = {
  life?: Maybe<UpdateLifeNotificationSettingInput>;
};

export type NotificationsForUserInclude = {
  weeklyWinners: Scalars['Boolean'];
};

export type Observation = {
  __typename: 'Observation';
  resourceType: ObservationResourceType;
  identifier?: Maybe<Array<Identifier>>;
  basedOn?: Maybe<Array<Reference>>;
  status?: Maybe<ObservationStatus>;
  category?: Maybe<Array<CodeableConcept>>;
  code?: Maybe<CodeableConcept>;
  subject?: Maybe<Reference>;
  context?: Maybe<Reference>;
  effectiveDateTime?: Maybe<Scalars['String']>;
  effectivePeriod?: Maybe<Period>;
  issued?: Maybe<Scalars['String']>;
  performer?: Maybe<Array<Reference>>;
  valueQuantity?: Maybe<Quantity>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueString?: Maybe<Scalars['String']>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueRange?: Maybe<Range>;
  valueRatio?: Maybe<Ratio>;
  valueSampledData?: Maybe<SampledData>;
  valueAttachment?: Maybe<Attachment>;
  valueTime?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valuePeriod?: Maybe<Period>;
  dataAbsentReason?: Maybe<CodeableConcept>;
  interpretation?: Maybe<CodeableConcept>;
  comment?: Maybe<Scalars['String']>;
  bodySite?: Maybe<CodeableConcept>;
  method?: Maybe<CodeableConcept>;
  specimen?: Maybe<Reference>;
  device?: Maybe<Reference>;
  referenceRange?: Maybe<Array<ObservationReferenceRange>>;
  related?: Maybe<Array<ObservationRelated>>;
  component?: Maybe<Array<ObservationComponent>>;
  text?: Maybe<Narrative>;
  contained?: Maybe<Array<ResourceList>>;
  extension?: Maybe<Array<Extension>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Meta>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type ObservationComponent = {
  __typename: 'ObservationComponent';
  code?: Maybe<CodeableConcept>;
  valueQuantity?: Maybe<Quantity>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueString?: Maybe<Scalars['String']>;
  valueRange?: Maybe<Range>;
  valueRatio?: Maybe<Ratio>;
  valueSampledData?: Maybe<SampledData>;
  valueAttachment?: Maybe<Attachment>;
  valueTime?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valuePeriod?: Maybe<Period>;
  dataAbsentReason?: Maybe<CodeableConcept>;
  interpretation?: Maybe<CodeableConcept>;
  referenceRange?: Maybe<Array<ObservationReferenceRange>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ObservationComponentIn = {
  code?: Maybe<CodeableConceptIn>;
  valueQuantity?: Maybe<QuantityIn>;
  valueCodeableConcept?: Maybe<CodeableConceptIn>;
  valueString?: Maybe<Scalars['String']>;
  valueRange?: Maybe<RangeIn>;
  valueRatio?: Maybe<RatioIn>;
  valueSampledData?: Maybe<SampledDataIn>;
  valueAttachment?: Maybe<AttachmentIn>;
  valueTime?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valuePeriod?: Maybe<PeriodIn>;
  dataAbsentReason?: Maybe<CodeableConceptIn>;
  interpretation?: Maybe<CodeableConceptIn>;
  referenceRange?: Maybe<Array<Maybe<ObservationReferenceRangeIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type ObservationDateHistogram = {
  __typename: 'ObservationDateHistogram';
  aggregations: Array<DateGraphData>;
};

export type ObservationEdge = {
  __typename: 'ObservationEdge';
  node: Observation;
};

export type ObservationIn = {
  resourceType: ObservationResourceType;
  identifier?: Maybe<Array<Maybe<IdentifierIn>>>;
  basedOn?: Maybe<Array<Maybe<ReferenceIn>>>;
  status?: Maybe<ObservationStatus>;
  category?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  code?: Maybe<CodeableConceptIn>;
  subject?: Maybe<ReferenceIn>;
  context?: Maybe<ReferenceIn>;
  effectiveDateTime?: Maybe<Scalars['String']>;
  effectivePeriod?: Maybe<PeriodIn>;
  issued?: Maybe<Scalars['String']>;
  performer?: Maybe<Array<Maybe<ReferenceIn>>>;
  valueQuantity?: Maybe<QuantityIn>;
  valueCodeableConcept?: Maybe<CodeableConceptIn>;
  valueString?: Maybe<Scalars['String']>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueRange?: Maybe<RangeIn>;
  valueRatio?: Maybe<RatioIn>;
  valueSampledData?: Maybe<SampledDataIn>;
  valueAttachment?: Maybe<AttachmentIn>;
  valueTime?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valuePeriod?: Maybe<PeriodIn>;
  dataAbsentReason?: Maybe<CodeableConceptIn>;
  interpretation?: Maybe<CodeableConceptIn>;
  comment?: Maybe<Scalars['String']>;
  bodySite?: Maybe<CodeableConceptIn>;
  method?: Maybe<CodeableConceptIn>;
  specimen?: Maybe<ReferenceIn>;
  device?: Maybe<ReferenceIn>;
  referenceRange?: Maybe<Array<Maybe<ObservationReferenceRangeIn>>>;
  related?: Maybe<Array<Maybe<ObservationRelatedIn>>>;
  component?: Maybe<Array<Maybe<ObservationComponentIn>>>;
  text?: Maybe<NarrativeIn>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<MetaIn>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type ObservationReferenceRange = {
  __typename: 'ObservationReferenceRange';
  low?: Maybe<Quantity>;
  high?: Maybe<Quantity>;
  type?: Maybe<CodeableConcept>;
  appliesTo?: Maybe<Array<CodeableConcept>>;
  age?: Maybe<Range>;
  text?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ObservationReferenceRangeIn = {
  low?: Maybe<QuantityIn>;
  high?: Maybe<QuantityIn>;
  type?: Maybe<CodeableConceptIn>;
  appliesTo?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  age?: Maybe<RangeIn>;
  text?: Maybe<Scalars['String']>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type ObservationRelated = {
  __typename: 'ObservationRelated';
  type?: Maybe<ObservationRelatedType>;
  target?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ObservationRelatedIn = {
  type?: Maybe<ObservationRelatedType>;
  target?: Maybe<ReferenceIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ObservationRelatedType {
  has_member = 'has_member',
  derived_from = 'derived_from',
  sequel_to = 'sequel_to',
  replaces = 'replaces',
  qualified_by = 'qualified_by',
  interfered_by = 'interfered_by',
}

export enum ObservationResourceType {
  Observation = 'Observation',
}

export type ObservationsConnection = {
  __typename: 'ObservationsConnection';
  edges: Array<ObservationEdge>;
  pageInfo: PageInfo;
};

export enum ObservationStatus {
  registered = 'registered',
  preliminary = 'preliminary',
  final = 'final',
  amended = 'amended',
  corrected = 'corrected',
  cancelled = 'cancelled',
  entered_in_error = 'entered_in_error',
  unknown = 'unknown',
}

export enum Occupation {
  architecture_or_engineering = 'architecture_or_engineering',
  arts_design_entertainment_sports_or_media = 'arts_design_entertainment_sports_or_media',
  building_or_grounds_cleaning_or_maintenance = 'building_or_grounds_cleaning_or_maintenance',
  business_or_financial_operations = 'business_or_financial_operations',
  community_or_social_services = 'community_or_social_services',
  computer_or_mathematical_occupations = 'computer_or_mathematical_occupations',
  construction_or_extraction_occupations = 'construction_or_extraction_occupations',
  education_training_or_library_occupations = 'education_training_or_library_occupations',
  family_management_full_time_caregiver = 'family_management_full_time_caregiver',
  farming_fishing_or_forestry = 'farming_fishing_or_forestry',
  food_preparation_or_serving = 'food_preparation_or_serving',
  healthcare_practitioners_or_technical_healthcare_occupations = 'healthcare_practitioners_or_technical_healthcare_occupations',
  healthcare_support = 'healthcare_support',
  installation_maintenance_or_repair = 'installation_maintenance_or_repair',
  law_or_related_occupations = 'law_or_related_occupations',
  life_physical_or_social_sciences = 'life_physical_or_social_sciences',
  management = 'management',
  military = 'military',
  office_and_administrative_support = 'office_and_administrative_support',
  personal_care_or_service_occupations = 'personal_care_or_service_occupations',
  production_and_manufacturing_occupations = 'production_and_manufacturing_occupations',
  protective_services = 'protective_services',
  sales_or_related_occupations = 'sales_or_related_occupations',
  student = 'student',
  transportation_or_material_moving = 'transportation_or_material_moving',
  other = 'other',
  none = 'none',
}

export type OccupationRestriction = {
  __typename: 'OccupationRestriction';
  allowed: Array<Occupation>;
};

export type OccupationRestrictionInput = {
  allowed?: Maybe<Array<Occupation>>;
};

export type OfficialMood = MoodV2 & {
  __typename: 'OfficialMood';
  id: Scalars['ID'];
  moodType: OfficialMoodType;
  createdAt: Scalars['Date'];
};

export type OfficialMoodInput = {
  moodType: OfficialMoodType;
};

export type OfficialMoodOptions = {
  mood: OfficialMoodInput;
  publish: Scalars['Boolean'];
};

export enum OfficialMoodType {
  GOOD = 'GOOD',
  AWESOME = 'AWESOME',
  EUPHORIC = 'EUPHORIC',
  STRUGGLING = 'STRUGGLING',
  STARVING = 'STARVING',
}

export type OpenPillarNotification = Notification & {
  __typename: 'OpenPillarNotification';
  id: Scalars['ID'];
  pillarType: PillarType;
  notificationBody: Scalars['String'];
  messageId?: Maybe<Scalars['ID']>;
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
};

export type OrgInviteResult = {
  __typename: 'OrgInviteResult';
  _?: Maybe<Scalars['Boolean']>;
  accountId: Scalars['String'];
  account: Account;
};

/** Contains cursor and page information */
export type PagedInfo = {
  __typename: 'PagedInfo';
  /**
   * Cursor refers to nextPageToken for the Clinical Trials API. Cursor is a legacy
   * term that has been maintained for backwards compatibility.
   */
  cursor?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
};

/** Contains pagination information */
export type PagedInfoInput = {
  /**
   * Cursor refers to nextPageToken for the Clinical Trials API. Cursor is a legacy
   * term that has been maintained for backwards compatibility.
   */
  cursor?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  /** The amount of results to be returned */
  pageSize?: Maybe<Scalars['Int']>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

export type ParameterDefinition = {
  __typename: 'ParameterDefinition';
  name?: Maybe<Scalars['String']>;
  use?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['String']>;
  documentation?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  profile?: Maybe<Reference>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ParameterDefinitionIn = {
  name?: Maybe<Scalars['String']>;
  use?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['String']>;
  documentation?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  profile?: Maybe<ReferenceIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ParentType {
  CIRCLE = 'CIRCLE',
  PM_GROUP = 'PM_GROUP',
  POST = 'POST',
  EXPERT = 'EXPERT',
  MARKETPLACE_RESOURCE = 'MARKETPLACE_RESOURCE',
}

export type Patient = {
  __typename: 'Patient';
  resourceType: PatientResourceType;
  identifier?: Maybe<Array<Identifier>>;
  active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Array<HumanName>>;
  telecom?: Maybe<Array<ContactPoint>>;
  gender?: Maybe<PatientGender>;
  birthDate?: Maybe<Scalars['String']>;
  deceasedBoolean?: Maybe<Scalars['Boolean']>;
  deceasedDateTime?: Maybe<Scalars['String']>;
  address?: Maybe<Array<Address>>;
  maritalStatus?: Maybe<CodeableConcept>;
  multipleBirthBoolean?: Maybe<Scalars['Boolean']>;
  multipleBirthInteger?: Maybe<Scalars['Float']>;
  photo?: Maybe<Array<Attachment>>;
  contact?: Maybe<Array<PatientContact>>;
  animal?: Maybe<PatientAnimal>;
  communication?: Maybe<Array<PatientCommunication>>;
  generalPractitioner?: Maybe<Array<Reference>>;
  managingOrganization?: Maybe<Reference>;
  link?: Maybe<Array<PatientLink>>;
  text?: Maybe<Narrative>;
  contained?: Maybe<Array<ResourceList>>;
  extension?: Maybe<Array<Extension>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Meta>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  /** @deprecated use observationsConnection */
  observations?: Maybe<Array<Maybe<Observation>>>;
  /**
   * Provides a limited FHIR search capability for Patient Observations using the GraphQL connections pattern.
   * after provides a next page token when traversing multiple pages of results.
   * first is equivalent to the FHIR _count parameter and sets the page size.
   * All other parameters follow the FHIR search specification.
   * See https://www.hl7.org/fhir/search.html
   */
  observationsConnection: ObservationsConnection;
  proceduresConnection: ProceduresConnection;
  goalsConnection: GoalsConnection;
  questionnaireResponsesConnection: QuestionnaireResponsesConnection;
  diagnosticReportsConnection: DiagnosticReportsConnection;
  /** Returns privacy preferences for a user. Returns default values if preferences are not set for the user. */
  privacyPreferences?: Maybe<PatientPrivacyPreferences>;
  /** a privacy-focused field for mobile apps to display age securely */
  age?: Maybe<Scalars['Int']>;
};

export type PatientobservationsConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codeBelow?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dates?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type PatientproceduresConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codeBelow?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dates?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type PatientgoalsConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  measure?: Maybe<Scalars['String']>;
  measureBelow?: Maybe<Scalars['String']>;
  status?: Maybe<GoalStatus>;
  startDate?: Maybe<Array<Scalars['String']>>;
  targetDate?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type PatientquestionnaireResponsesConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  questionnaire?: Maybe<Scalars['String']>;
  authored?: Maybe<Scalars['String']>;
  authoredDates?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type PatientdiagnosticReportsConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dates?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type PatientAnimal = {
  __typename: 'PatientAnimal';
  species?: Maybe<CodeableConcept>;
  breed?: Maybe<CodeableConcept>;
  genderStatus?: Maybe<CodeableConcept>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type PatientAnimalIn = {
  species?: Maybe<CodeableConceptIn>;
  breed?: Maybe<CodeableConceptIn>;
  genderStatus?: Maybe<CodeableConceptIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type PatientCommunication = {
  __typename: 'PatientCommunication';
  language?: Maybe<CodeableConcept>;
  preferred?: Maybe<Scalars['Boolean']>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type PatientCommunicationIn = {
  language?: Maybe<CodeableConceptIn>;
  preferred?: Maybe<Scalars['Boolean']>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type PatientContact = {
  __typename: 'PatientContact';
  relationship?: Maybe<Array<CodeableConcept>>;
  name?: Maybe<HumanName>;
  telecom?: Maybe<Array<ContactPoint>>;
  address?: Maybe<Address>;
  gender?: Maybe<PatientContactGender>;
  organization?: Maybe<Reference>;
  period?: Maybe<Period>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export enum PatientContactGender {
  male = 'male',
  female = 'female',
  other = 'other',
  unknown = 'unknown',
}

export type PatientContactIn = {
  relationship?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  name?: Maybe<HumanNameIn>;
  telecom?: Maybe<Array<Maybe<ContactPointIn>>>;
  address?: Maybe<AddressIn>;
  gender?: Maybe<PatientContactGender>;
  organization?: Maybe<ReferenceIn>;
  period?: Maybe<PeriodIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum PatientGender {
  male = 'male',
  female = 'female',
  other = 'other',
  unknown = 'unknown',
}

export type PatientIn = {
  resourceType: PatientResourceType;
  identifier?: Maybe<Array<Maybe<IdentifierIn>>>;
  active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Array<Maybe<HumanNameIn>>>;
  telecom?: Maybe<Array<Maybe<ContactPointIn>>>;
  gender?: Maybe<PatientGender>;
  birthDate?: Maybe<Scalars['String']>;
  deceasedBoolean?: Maybe<Scalars['Boolean']>;
  deceasedDateTime?: Maybe<Scalars['String']>;
  address?: Maybe<Array<Maybe<AddressIn>>>;
  maritalStatus?: Maybe<CodeableConceptIn>;
  multipleBirthBoolean?: Maybe<Scalars['Boolean']>;
  multipleBirthInteger?: Maybe<Scalars['Float']>;
  photo?: Maybe<Array<Maybe<AttachmentIn>>>;
  contact?: Maybe<Array<Maybe<PatientContactIn>>>;
  animal?: Maybe<PatientAnimalIn>;
  communication?: Maybe<Array<Maybe<PatientCommunicationIn>>>;
  generalPractitioner?: Maybe<Array<Maybe<ReferenceIn>>>;
  managingOrganization?: Maybe<ReferenceIn>;
  link?: Maybe<Array<Maybe<PatientLinkIn>>>;
  text?: Maybe<NarrativeIn>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<MetaIn>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type PatientLink = {
  __typename: 'PatientLink';
  other?: Maybe<Reference>;
  type?: Maybe<PatientLinkType>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type PatientLinkIn = {
  other?: Maybe<ReferenceIn>;
  type?: Maybe<PatientLinkType>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum PatientLinkType {
  replaced_by = 'replaced_by',
  replaces = 'replaces',
  refer = 'refer',
  seealso = 'seealso',
}

export type PatientMapping = {
  __typename: 'PatientMapping';
  patientId: Scalars['String'];
  datasetId: Scalars['String'];
  sourceAccountId?: Maybe<Scalars['String']>;
};

export type PatientPrivacyPreferences = {
  __typename: 'PatientPrivacyPreferences';
  DEMOGRAPHIC?: Maybe<PrivacyPreferenceSetting>;
  HEALTH_HISTORY?: Maybe<PrivacyPreferenceSetting>;
  LIFESTYLE?: Maybe<PrivacyPreferenceSetting>;
  PILLARS?: Maybe<PrivacyPreferenceSetting>;
  PROGRESS_GRAPHS?: Maybe<PrivacyPreferenceSetting>;
};

export type PatientPrivacyPreferencesIn = {
  DEMOGRAPHIC?: Maybe<PrivacyPreferenceSetting>;
  HEALTH_HISTORY?: Maybe<PrivacyPreferenceSetting>;
  LIFESTYLE?: Maybe<PrivacyPreferenceSetting>;
  PILLARS?: Maybe<PrivacyPreferenceSetting>;
  PROGRESS_GRAPHS?: Maybe<PrivacyPreferenceSetting>;
};

export type PatientProfile = {
  project: Scalars['String'];
  patients: Array<Scalars['String']>;
  filter?: Maybe<ProfileFilter>;
};

export enum PatientResourceType {
  Patient = 'Patient',
}

export type PatientTrialFilter = {
  __typename: 'PatientTrialFilter';
  defaultActive: Scalars['Boolean'];
  field: Scalars['String'];
  value: Scalars['String'];
};

export type PatientTrialFilterCategory = {
  __typename: 'PatientTrialFilterCategory';
  id: Scalars['String'];
  filters: Array<PatientTrialFilter>;
};

export type Period = {
  __typename: 'Period';
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type PeriodIn = {
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum PillarCode {
  ALL = 'ALL',
}

export enum PillarType {
  nutrition = 'nutrition',
  activity = 'activity',
  mindfulness = 'mindfulness',
  sleep = 'sleep',
  fasting = 'fasting',
}

export type Post = {
  id: Scalars['ID'];
  replies: PostConnection;
  parentId: Scalars['ID'];
  parentPost?: Maybe<Post>;
  rootParentId: Scalars['ID'];
  originalPostId: Scalars['ID'];
  originalPost: Post;
  createdAt: Scalars['Date'];
  popularity: Scalars['Int'];
  replyCount: Scalars['Int'];
  systemGenerated: Scalars['Boolean'];
  metadata?: Maybe<Scalars['String']>;
  priority?: Maybe<Priority>;
  status: PostStatus;
};

export type PostrepliesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  order?: Maybe<PostOrder>;
  deletedStatus?: Maybe<DeletedStatus>;
};

export type PostConnection = {
  __typename: 'PostConnection';
  edges: Array<PostEdge>;
  pageInfo: PageInfo;
};

export type PostContent = {
  __typename: 'PostContent';
  type: PostContentType;
  weeklyCircleWinners?: Maybe<WeeklyCircleWinners>;
  challengeId?: Maybe<Scalars['ID']>;
  /** Users associated with this post in some way via metadata */
  users?: Maybe<Array<PostUser>>;
};

export enum PostContentType {
  WeeklyWinners = 'WeeklyWinners',
  ChallengeStarted = 'ChallengeStarted',
  ChallengeEnded = 'ChallengeEnded',
  ChallengeRaffleWinners = 'ChallengeRaffleWinners',
}

export type PostEdge = {
  __typename: 'PostEdge';
  node: Post;
};

export type PostFilter = {
  order?: Maybe<PostOrder>;
  parentId: Scalars['ID'];
  parentType: ParentType;
  priority?: Maybe<Priority>;
  deletedStatus?: Maybe<DeletedStatus>;
};

export enum PostOrder {
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
}

export type PostReplyNotification = Notification & {
  __typename: 'PostReplyNotification';
  post: Post;
  replyPost: Post;
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  notificationUserId: Scalars['ID'];
  parentId: Scalars['ID'];
  rootParentId: Scalars['ID'];
  originalPostId: Scalars['ID'];
  postId: Scalars['ID'];
  replyPostId: Scalars['ID'];
  replyPostUserId: Scalars['ID'];
};

export enum PostStatus {
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  ERROR = 'ERROR',
  DELETED = 'DELETED',
}

export type PostUser = {
  __typename: 'PostUser';
  userId: Scalars['String'];
  user?: Maybe<User>;
};

export enum PrimaryHealthConcerns {
  losing_weight = 'losing_weight',
  healthy_aging = 'healthy_aging',
  increasing_fitness = 'increasing_fitness',
  fighting_cancer = 'fighting_cancer',
  preventing_chronic_diseases = 'preventing_chronic_diseases',
  other = 'other',
}

export type PrimaryHealthConcernsRestriction = {
  __typename: 'PrimaryHealthConcernsRestriction';
  allowed: Array<PrimaryHealthConcerns>;
};

export type PrimaryHealthConcernsRestrictionInput = {
  allowed?: Maybe<Array<PrimaryHealthConcerns>>;
};

export enum Priority {
  STANDARD = 'STANDARD',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
}

export enum PrivacyPreferenceSetting {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export type PrivateCircleCreationInput = {
  id?: Maybe<Scalars['ID']>;
  sourceCircleId?: Maybe<Scalars['ID']>;
  purpose?: Maybe<CirclePurpose>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<CircleType>;
  addUserToAdminGroup?: Maybe<Scalars['Boolean']>;
};

export type PrivatePostFileUploadUrlInput = {
  fileType: FileType;
  userIds: Array<Scalars['ID']>;
};

export type PrivatePostFilter = {
  order?: Maybe<PostOrder>;
};

export type PrivatePostNotification = Notification & {
  __typename: 'PrivatePostNotification';
  post: Post;
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  postId: Scalars['ID'];
};

export type Procedure = {
  __typename: 'Procedure';
  resourceType: ProcedureResourceType;
  identifier?: Maybe<Array<Identifier>>;
  definition?: Maybe<Array<Reference>>;
  basedOn?: Maybe<Array<Reference>>;
  partOf?: Maybe<Array<Reference>>;
  status?: Maybe<Scalars['String']>;
  notDone?: Maybe<Scalars['Boolean']>;
  notDoneReason?: Maybe<CodeableConcept>;
  category?: Maybe<CodeableConcept>;
  code?: Maybe<CodeableConcept>;
  subject?: Maybe<Reference>;
  context?: Maybe<Reference>;
  performedDateTime?: Maybe<Scalars['String']>;
  performedPeriod?: Maybe<Period>;
  performer?: Maybe<Array<ProcedurePerformer>>;
  location?: Maybe<Reference>;
  reasonCode?: Maybe<Array<CodeableConcept>>;
  reasonReference?: Maybe<Array<Reference>>;
  bodySite?: Maybe<Array<CodeableConcept>>;
  outcome?: Maybe<CodeableConcept>;
  report?: Maybe<Array<Reference>>;
  complication?: Maybe<Array<CodeableConcept>>;
  complicationDetail?: Maybe<Array<Reference>>;
  followUp?: Maybe<Array<CodeableConcept>>;
  note?: Maybe<Array<Annotation>>;
  focalDevice?: Maybe<Array<ProcedureFocalDevice>>;
  usedReference?: Maybe<Array<Reference>>;
  usedCode?: Maybe<Array<CodeableConcept>>;
  text?: Maybe<Narrative>;
  contained?: Maybe<Array<ResourceList>>;
  extension?: Maybe<Array<Extension>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Meta>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type ProcedureEdge = {
  __typename: 'ProcedureEdge';
  node: Procedure;
};

export type ProcedureFocalDevice = {
  __typename: 'ProcedureFocalDevice';
  action?: Maybe<CodeableConcept>;
  manipulated?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ProcedureFocalDeviceIn = {
  action?: Maybe<CodeableConceptIn>;
  manipulated?: Maybe<ReferenceIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type ProcedureIn = {
  resourceType: ProcedureResourceType;
  identifier?: Maybe<Array<Maybe<IdentifierIn>>>;
  definition?: Maybe<Array<Maybe<ReferenceIn>>>;
  basedOn?: Maybe<Array<Maybe<ReferenceIn>>>;
  partOf?: Maybe<Array<Maybe<ReferenceIn>>>;
  status?: Maybe<Scalars['String']>;
  notDone?: Maybe<Scalars['Boolean']>;
  notDoneReason?: Maybe<CodeableConceptIn>;
  category?: Maybe<CodeableConceptIn>;
  code?: Maybe<CodeableConceptIn>;
  subject?: Maybe<ReferenceIn>;
  context?: Maybe<ReferenceIn>;
  performedDateTime?: Maybe<Scalars['String']>;
  performedPeriod?: Maybe<PeriodIn>;
  performer?: Maybe<Array<Maybe<ProcedurePerformerIn>>>;
  location?: Maybe<ReferenceIn>;
  reasonCode?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  reasonReference?: Maybe<Array<Maybe<ReferenceIn>>>;
  bodySite?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  outcome?: Maybe<CodeableConceptIn>;
  report?: Maybe<Array<Maybe<ReferenceIn>>>;
  complication?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  complicationDetail?: Maybe<Array<Maybe<ReferenceIn>>>;
  followUp?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  note?: Maybe<Array<Maybe<AnnotationIn>>>;
  focalDevice?: Maybe<Array<Maybe<ProcedureFocalDeviceIn>>>;
  usedReference?: Maybe<Array<Maybe<ReferenceIn>>>;
  usedCode?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  text?: Maybe<NarrativeIn>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<MetaIn>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type ProcedurePerformer = {
  __typename: 'ProcedurePerformer';
  role?: Maybe<CodeableConcept>;
  actor?: Maybe<Reference>;
  onBehalfOf?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ProcedurePerformerIn = {
  role?: Maybe<CodeableConceptIn>;
  actor?: Maybe<ReferenceIn>;
  onBehalfOf?: Maybe<ReferenceIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum ProcedureResourceType {
  Procedure = 'Procedure',
}

export type ProceduresConnection = {
  __typename: 'ProceduresConnection';
  edges: Array<ProcedureEdge>;
  pageInfo: PageInfo;
};

export enum Products {
  PHC = 'PHC',
  LX = 'LX',
  Program = 'Program',
  PrecisionOCR = 'PrecisionOCR',
  PatientML = 'PatientML',
  LR = 'LR',
  JAX = 'JAX',
  AuthClient = 'AuthClient',
  Notebooks = 'Notebooks',
  Automation = 'Automation',
  Reseller = 'Reseller',
  ResellerCustomer = 'ResellerCustomer',
  ContentManagement = 'ContentManagement',
  MedicalDevicePlatform = 'MedicalDevicePlatform',
  MTBNotes = 'MTBNotes',
}

export type ProfileFilter = {
  modules?: Maybe<Array<ProfileModuleFilter>>;
};

export type ProfileModuleFilter = {
  source: Scalars['String'];
  element: Scalars['String'];
};

export enum ProgressTileDataGateField {
  BIRTH_DATE = 'BIRTH_DATE',
  GENDER = 'GENDER',
  HEIGHT = 'HEIGHT',
  PRIMARY_HEALTH_CONCERN = 'PRIMARY_HEALTH_CONCERN',
  WELLNESS_PROFESSIONAL = 'WELLNESS_PROFESSIONAL',
}

export type PublicCirclesConnection = {
  __typename: 'PublicCirclesConnection';
  edges: Array<PublicCirclesEdge>;
  pageInfo: PageInfo;
};

export type PublicCirclesEdge = {
  __typename: 'PublicCirclesEdge';
  node: Circle;
};

export type Quantity = {
  __typename: 'Quantity';
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<QuantityComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export enum QuantityComparator {
  LT = 'LT',
  LTE = 'LTE',
  GTE = 'GTE',
  GT = 'GT',
}

export type QuantityIn = {
  value?: Maybe<Scalars['Float']>;
  comparator?: Maybe<QuantityComparator>;
  unit?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type Query = {
  __typename: 'Query';
  /**
   * Searches for matching codings.
   *
   * Note: At least one of 'code' and 'system' are required. In most cases, both arguments should be declared.
   *
   * In HL7 FHIR a Coding is a representation of a defined concept using a symbol from a defined Code System.
   *
   * @see https://www.hl7.org/fhir/datatypes.html#Coding
   */
  searchCodings?: Maybe<RelationshipEntriesConnection>;
  socialCircleUser?: Maybe<User>;
  circle?: Maybe<Circle>;
  circlesByOwningAccount: CirclesByOwningAccountConnection;
  publicCircles: PublicCirclesConnection;
  canUserJoinCircle: Scalars['Boolean'];
  managingGroupsInvitations: ManagingGroupsInvitationsConnection;
  userInvitations: UserInvitationsConnection;
  socialCircleUserPrivacyPreferences?: Maybe<SocialCircleServiceUserPrivacyPreferences>;
  circleOwnerConnectAccount?: Maybe<StripeConnectAccount>;
  getStripeConnectAccounts: StripeConnectAccountConnection;
  conversations: ConversationsConnection;
  postsByAuthor: PostConnection;
  /** Get a piece of content by ID. */
  educationContent?: Maybe<EducationContent>;
  educationContentForCode?: Maybe<EducationContent>;
  educationContentForTrid: Array<EducationContent>;
  recentEducationContent: Array<EducationContent>;
  paginatedRecentEducationContent: EducationContentConnection;
  /** Get the current ongoing fast for the authenticated user. */
  currentFast?: Maybe<Fast>;
  /** Get a fast by ID. */
  fast?: Maybe<Fast>;
  /**
   * The fastHistory query returns a list of FastWindow objects. The
   * resulting windows (and the fasts within them) are sorted in reverse
   * chronological order. `until` sets the end boundary for the history.
   * `windowSize` determines the size of the windows that will be returned
   * in seconds. If `windowSize` is not provided the entire history will be
   * returned in a single window. Empty windows are never returned (the
   * history is sparse).
   */
  fastHistory: Array<FastWindow>;
  /**
   * Creates a fast window of all fasts that have an end date after the since
   * value. This includes ongoing fasts.
   */
  fastWindow: FastWindow;
  /** Get fast augmented circle data by circle ID. */
  fastingCircle?: Maybe<FastingCircle>;
  /**
   * The introductory course that should be shown to the current user. If
   * the result is `null`, then the server does not have an opinion about
   * what to show. The value is a URL of a Lifeology course.
   */
  introductoryCourse?: Maybe<Scalars['String']>;
  /**
   * Look up update by id. Updates retrieved through scoped channels, like
   * feed entries and update connections, can include a proofOfAccess token
   * on the response. This token can be used here to prove that access to the
   * update was previously granted.
   */
  update?: Maybe<Update>;
  currentMood?: Maybe<MoodUpdate>;
  feedEntriesForCircle: FeedEntriesConnection;
  feedEntriesForCircleAnnouncements: FeedEntriesConnection;
  feedEntriesForUser: FeedEntriesConnection;
  feedEntriesForUserRelatedUpdates: FeedEntriesConnection;
  feedEntriesForUserAnnouncements: FeedEntriesConnection;
  feedEntriesForUserAnnouncementsByAuthor: FeedEntriesConnection;
  feedEntriesForPrivatePosts: FeedEntriesConnection;
  feedEntriesForPrivatePostsByAuthor: FeedEntriesConnection;
  feedEntriesForPrivatePostsByCircle: FeedEntriesConnection;
  homeScreenNotificationsForUser: NotificationsConnection;
  notificationsForUser: NotificationsConnection;
  lifepointsForUser: LifePointsInfoConnection;
  weeklyLifepointsForUser: LifePointsInfoConnection;
  rollingAverageLifepointsForUser: RollingAverageResponse;
  totalLifepointsForUser: TotalLifepointsResponse;
  /** @deprecated Use lifespanForPatient instead. */
  lifespanForUser: Scalars['Float'];
  lifespanForPatient?: Maybe<Scalars['Float']>;
  /** @deprecated Use biologicalAgeForPatient instead. */
  biologicalAgeForUser: Scalars['Float'];
  biologicalAgeForPatient?: Maybe<Scalars['Float']>;
  app?: Maybe<AppStoreApplication>;
  apps: AppStoreApplicationConnection;
  generateWebAppFromManifest: WebAppFromManifest;
  installedApps: AppStoreApplicationConnection;
  installedTiles: TileConnection;
  /** @deprecated use patient with no id */
  getPatientId: Scalars['String'];
  patient?: Maybe<Patient>;
  goal?: Maybe<Goal>;
  observation?: Maybe<Observation>;
  procedure?: Maybe<Procedure>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireResponse?: Maybe<QuestionnaireResponse>;
  diagnosticReport?: Maybe<DiagnosticReport>;
  task?: Maybe<Task>;
  accounts?: Maybe<Array<Account>>;
  accountUserPrivacyPreferences?: Maybe<AccountServiceUserPrivacyPreferences>;
  user?: Maybe<User>;
  clientValueCache: Array<Maybe<ClientValueCache>>;
  group?: Maybe<Group>;
  usersForAccount?: Maybe<AccountUsersConnection>;
  blockedUsers: BlockedUserConnection;
  isUserBlocked: Scalars['Boolean'];
  isUserBlocking: Scalars['Boolean'];
  areUsersBlockedOrBlocking: Scalars['Boolean'];
  forumSettings: ForumSettings;
  isLifePlusSubscriber: Scalars['Boolean'];
  lifePlusSubscriptionDate?: Maybe<Scalars['Date']>;
  subscriptionStatus: SubscriptionStatus;
  entitlements: Array<EntitlementInfo>;
  observationDateHistogram: ObservationDateHistogram;
  missingProgressTileDataGateFields: Array<ProgressTileDataGateField>;
  currentMoodV2?: Maybe<MoodV2>;
  isFeatureDisabledForUser: Scalars['Boolean'];
  isFeatureDisabledForUsers: Array<Maybe<Scalars['ID']>>;
  getTrial: Trial;
  getTrialSearch: TrialSearch;
  getTrialMatch: TrialMatch;
  getPatientTrialFilters: Array<PatientTrialFilterCategory>;
  getAllTrialDrugs: Array<Maybe<Scalars['String']>>;
  getTagTrials: TagTrials;
  listVideos: VideoConnection;
  getVideo?: Maybe<Video>;
  tagsValues?: Maybe<TagsValuesResult>;
  post: Post;
  posts: PostConnection;
  postsV2: PostConnection;
  privatePosts: PostConnection;
  userPosts: PostConnection;
  reactions: ReactionConnection;
  surveyAttachmentDownloadUrl: Array<SurveyAttachmentDownloadResults>;
  activeSkillSpringCoupons: SkillSpringCouponConnection;
  wellnessSkillSpringCoupons: Array<SkillSpringCoupon>;
};

export type QuerysearchCodingsArgs = {
  project: Scalars['String'];
  system?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  relationship: RelationshipType;
  sort?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QuerysocialCircleUserArgs = {
  userId: Scalars['ID'];
};

export type QuerycircleArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QuerycirclesByOwningAccountArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QuerypublicCirclesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QuerycanUserJoinCircleArgs = {
  circleId: Scalars['ID'];
};

export type QuerymanagingGroupsInvitationsArgs = {
  filterBy: ManagingGroupsInvitationsFilterInput;
};

export type QueryuserInvitationsArgs = {
  filterBy: UserInvitationsFilterInput;
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
};

export type QuerycircleOwnerConnectAccountArgs = {
  id: Scalars['ID'];
};

export type QuerygetStripeConnectAccountsArgs = {
  userId: Scalars['ID'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type QueryconversationsArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type QuerypostsByAuthorArgs = {
  author: Scalars['ID'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type QueryeducationContentArgs = {
  id: Scalars['ID'];
};

export type QueryeducationContentForCodeArgs = {
  code: EducationContentCodeInput;
  useLanguageHeader?: Maybe<Scalars['Boolean']>;
};

export type QueryeducationContentForTridArgs = {
  trid?: Maybe<Scalars['String']>;
};

export type QueryrecentEducationContentArgs = {
  type?: Maybe<EducationContentFilterTypes>;
  statuses?: Maybe<Array<EducationContentStatus>>;
  excludeContentWithCoding?: Maybe<Scalars['Boolean']>;
  useLanguageHeader?: Maybe<Scalars['Boolean']>;
  materialType?: Maybe<Scalars['String']>;
};

export type QuerypaginatedRecentEducationContentArgs = {
  type?: Maybe<EducationContentFilterTypes>;
  statuses?: Maybe<Array<EducationContentStatus>>;
  excludeContentWithCoding?: Maybe<Scalars['Boolean']>;
  useLanguageHeader?: Maybe<Scalars['Boolean']>;
  materialType?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QuerycurrentFastArgs = {
  userId?: Maybe<Scalars['ID']>;
};

export type QueryfastArgs = {
  id: Scalars['ID'];
};

export type QueryfastHistoryArgs = {
  user: Scalars['String'];
  from?: Maybe<Scalars['Date']>;
  until?: Maybe<Scalars['Date']>;
  windowSize?: Maybe<Scalars['Float']>;
};

export type QueryfastWindowArgs = {
  user: Scalars['String'];
  since: Scalars['Date'];
};

export type QueryfastingCircleArgs = {
  id: Scalars['ID'];
};

export type QueryupdateArgs = {
  id: Scalars['ID'];
  proofOfAccess?: Maybe<Scalars['String']>;
};

export type QuerycurrentMoodArgs = {
  userId: Scalars['ID'];
};

export type QueryfeedEntriesForCircleArgs = {
  id: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryfeedEntriesForCircleAnnouncementsArgs = {
  id: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryfeedEntriesForUserArgs = {
  user: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryfeedEntriesForUserRelatedUpdatesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryfeedEntriesForUserAnnouncementsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryfeedEntriesForUserAnnouncementsByAuthorArgs = {
  author: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryfeedEntriesForPrivatePostsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryfeedEntriesForPrivatePostsByAuthorArgs = {
  author: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryfeedEntriesForPrivatePostsByCircleArgs = {
  circle: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryhomeScreenNotificationsForUserArgs = {
  user: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QuerynotificationsForUserArgs = {
  user?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  include?: Maybe<NotificationsForUserInclude>;
};

export type QuerylifepointsForUserArgs = {
  userId: Scalars['String'];
  date?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  pillarCodes?: Maybe<Array<PillarCode>>;
  includeResources?: Maybe<LifeAggregatesFHIRResources>;
  excludeResources?: Maybe<ExcludeFHIRResources>;
};

export type QueryweeklyLifepointsForUserArgs = {
  userId: Scalars['String'];
  date: Scalars['String'];
};

export type QueryrollingAverageLifepointsForUserArgs = {
  userId: Scalars['String'];
  date: Scalars['String'];
  days: Scalars['Int'];
};

export type QuerytotalLifepointsForUserArgs = {
  userId: Scalars['String'];
  date: Scalars['String'];
};

export type QuerylifespanForUserArgs = {
  userId: Scalars['String'];
  currentDate: Scalars['String'];
};

export type QuerylifespanForPatientArgs = {
  currentDate: Scalars['String'];
};

export type QuerybiologicalAgeForUserArgs = {
  userId: Scalars['String'];
  currentDate: Scalars['String'];
};

export type QuerybiologicalAgeForPatientArgs = {
  currentDate: Scalars['String'];
};

export type QueryappArgs = {
  id: Scalars['ID'];
};

export type QueryappsArgs = {
  input: ListAppsInput;
};

export type QuerygenerateWebAppFromManifestArgs = {
  input?: Maybe<GenerateWebAppFromManifestInput>;
};

export type QueryinstalledAppsArgs = {
  input: ListInstalledAppsInput;
};

export type QueryinstalledTilesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QuerygetPatientIdArgs = {
  dataset: Scalars['String'];
};

export type QuerypatientArgs = {
  id?: Maybe<Scalars['String']>;
};

export type QuerygoalArgs = {
  id: Scalars['String'];
};

export type QueryobservationArgs = {
  id: Scalars['String'];
};

export type QueryprocedureArgs = {
  id: Scalars['String'];
};

export type QueryquestionnaireArgs = {
  id: Scalars['String'];
};

export type QueryquestionnaireResponseArgs = {
  id: Scalars['String'];
};

export type QuerydiagnosticReportArgs = {
  id: Scalars['String'];
};

export type QuerytaskArgs = {
  id: Scalars['String'];
};

export type QueryaccountsArgs = {
  userId?: Maybe<Scalars['String']>;
};

export type QueryuserArgs = {
  userId: Scalars['ID'];
};

export type QueryclientValueCacheArgs = {
  userId: Scalars['ID'];
  apps: Array<ClientApp>;
};

export type QuerygroupArgs = {
  groupId: Scalars['ID'];
};

export type QueryusersForAccountArgs = {
  accountId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryblockedUsersArgs = {
  user: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type QueryisUserBlockedArgs = {
  user: Scalars['ID'];
  blockedUser: Scalars['ID'];
};

export type QueryisUserBlockingArgs = {
  user: Scalars['ID'];
  blockingUser: Scalars['ID'];
};

export type QueryareUsersBlockedOrBlockingArgs = {
  user: Scalars['ID'];
  blockedOrBlockingUsers: Array<Scalars['ID']>;
};

export type QueryforumSettingsArgs = {
  entityId: Scalars['ID'];
  entityType?: Maybe<EntityType>;
};

export type QueryisLifePlusSubscriberArgs = {
  user: Scalars['String'];
};

export type QuerylifePlusSubscriptionDateArgs = {
  user: Scalars['String'];
};

export type QuerysubscriptionStatusArgs = {
  createSubscriberIdIfNeeded?: Maybe<Scalars['Boolean']>;
};

export type QueryobservationDateHistogramArgs = {
  coding: Scalars['String'];
  timeZone: Scalars['String'];
  interval?: Maybe<CalendarInterval>;
};

export type QuerycurrentMoodV2Args = {
  input: CurrentMoodInput;
};

export type QueryisFeatureDisabledForUserArgs = {
  user: Scalars['ID'];
  feature: LifeAppsFeature;
};

export type QueryisFeatureDisabledForUsersArgs = {
  users: Array<Scalars['ID']>;
  feature: LifeAppsFeature;
};

export type QuerygetTrialArgs = {
  trialId: Scalars['String'];
  source?: Maybe<Source>;
  tag?: Maybe<Tag>;
};

export type QuerygetTrialSearchArgs = {
  filter: TrialFilter;
  tag?: Maybe<Tag>;
  pagedInfo?: Maybe<PagedInfoInput>;
};

export type QuerygetTrialMatchArgs = {
  profile: PatientProfile;
  filter?: Maybe<TrialFilter>;
};

export type QuerygetPatientTrialFiltersArgs = {
  profile: PatientProfile;
};

export type QuerygetAllTrialDrugsArgs = {
  startsWith: Scalars['String'];
};

export type QuerygetTagTrialsArgs = {
  tag: Tag;
};

export type QuerylistVideosArgs = {
  filter?: Maybe<VideoFilter>;
  searchFilter?: Maybe<VideoSearchFilter>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type QuerygetVideoArgs = {
  id: Scalars['ID'];
  version?: Maybe<Scalars['ID']>;
};

export type QuerypostArgs = {
  id: Scalars['ID'];
};

export type QuerypostsArgs = {
  filter: PostFilter;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type QuerypostsV2Args = {
  filter: PostFilter;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type QueryprivatePostsArgs = {
  userIds: Array<Scalars['ID']>;
  filter: PrivatePostFilter;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type QueryuserPostsArgs = {
  userIds: Array<Scalars['ID']>;
  projectId: Scalars['ID'];
  cohortId?: Maybe<Scalars['ID']>;
  filter: PrivatePostFilter;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type QueryreactionsArgs = {
  postId: Scalars['ID'];
  type: Scalars['Emoji'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};

export type QuerysurveyAttachmentDownloadUrlArgs = {
  inputs: Array<SurveyAttachmentDownloadUrlInput>;
};

export type QueryOptions = {
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Questionnaire = {
  __typename: 'Questionnaire';
  resourceType: QuestionnaireResourceType;
  url?: Maybe<Scalars['String']>;
  identifier?: Maybe<Array<Identifier>>;
  version?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  status?: Maybe<QuestionnaireStatus>;
  experimental?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  approvalDate?: Maybe<Scalars['String']>;
  lastReviewDate?: Maybe<Scalars['String']>;
  effectivePeriod?: Maybe<Period>;
  useContext?: Maybe<Array<UsageContext>>;
  jurisdiction?: Maybe<Array<CodeableConcept>>;
  contact?: Maybe<Array<ContactDetail>>;
  copyright?: Maybe<Scalars['String']>;
  code?: Maybe<Array<Coding>>;
  subjectType?: Maybe<Array<Scalars['String']>>;
  item?: Maybe<Array<QuestionnaireItem>>;
  text?: Maybe<Narrative>;
  contained?: Maybe<Array<ResourceList>>;
  extension?: Maybe<Array<Extension>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Meta>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type QuestionnaireEnableWhen = {
  __typename: 'QuestionnaireEnableWhen';
  question?: Maybe<Scalars['String']>;
  hasAnswer?: Maybe<Scalars['Boolean']>;
  answerBoolean?: Maybe<Scalars['Boolean']>;
  answerDecimal?: Maybe<Scalars['Float']>;
  answerInteger?: Maybe<Scalars['Float']>;
  answerDate?: Maybe<Scalars['String']>;
  answerDateTime?: Maybe<Scalars['String']>;
  answerTime?: Maybe<Scalars['String']>;
  answerString?: Maybe<Scalars['String']>;
  answerUri?: Maybe<Scalars['String']>;
  answerAttachment?: Maybe<Attachment>;
  answerCoding?: Maybe<Coding>;
  answerQuantity?: Maybe<Quantity>;
  answerReference?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type QuestionnaireEnableWhenIn = {
  question?: Maybe<Scalars['String']>;
  hasAnswer?: Maybe<Scalars['Boolean']>;
  answerBoolean?: Maybe<Scalars['Boolean']>;
  answerDecimal?: Maybe<Scalars['Float']>;
  answerInteger?: Maybe<Scalars['Float']>;
  answerDate?: Maybe<Scalars['String']>;
  answerDateTime?: Maybe<Scalars['String']>;
  answerTime?: Maybe<Scalars['String']>;
  answerString?: Maybe<Scalars['String']>;
  answerUri?: Maybe<Scalars['String']>;
  answerAttachment?: Maybe<AttachmentIn>;
  answerCoding?: Maybe<CodingIn>;
  answerQuantity?: Maybe<QuantityIn>;
  answerReference?: Maybe<ReferenceIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type QuestionnaireIn = {
  resourceType: QuestionnaireResourceType;
  url?: Maybe<Scalars['String']>;
  identifier?: Maybe<Array<Maybe<IdentifierIn>>>;
  version?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  status?: Maybe<QuestionnaireStatus>;
  experimental?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  approvalDate?: Maybe<Scalars['String']>;
  lastReviewDate?: Maybe<Scalars['String']>;
  effectivePeriod?: Maybe<PeriodIn>;
  useContext?: Maybe<Array<Maybe<UsageContextIn>>>;
  jurisdiction?: Maybe<Array<Maybe<CodeableConceptIn>>>;
  contact?: Maybe<Array<Maybe<ContactDetailIn>>>;
  copyright?: Maybe<Scalars['String']>;
  code?: Maybe<Array<Maybe<CodingIn>>>;
  subjectType?: Maybe<Array<Scalars['String']>>;
  item?: Maybe<Array<Maybe<QuestionnaireItemIn>>>;
  text?: Maybe<NarrativeIn>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<MetaIn>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type QuestionnaireItem = {
  __typename: 'QuestionnaireItem';
  linkId?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['String']>;
  code?: Maybe<Array<Coding>>;
  prefix?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<QuestionnaireItemType>;
  enableWhen?: Maybe<Array<QuestionnaireEnableWhen>>;
  required?: Maybe<Scalars['Boolean']>;
  repeats?: Maybe<Scalars['Boolean']>;
  readOnly?: Maybe<Scalars['Boolean']>;
  maxLength?: Maybe<Scalars['Float']>;
  options?: Maybe<Reference>;
  option?: Maybe<Array<QuestionnaireOption>>;
  initialBoolean?: Maybe<Scalars['Boolean']>;
  initialDecimal?: Maybe<Scalars['Float']>;
  initialInteger?: Maybe<Scalars['Float']>;
  initialDate?: Maybe<Scalars['String']>;
  initialDateTime?: Maybe<Scalars['String']>;
  initialTime?: Maybe<Scalars['String']>;
  initialString?: Maybe<Scalars['String']>;
  initialUri?: Maybe<Scalars['String']>;
  initialAttachment?: Maybe<Attachment>;
  initialCoding?: Maybe<Coding>;
  initialQuantity?: Maybe<Quantity>;
  initialReference?: Maybe<Reference>;
  item?: Maybe<Array<QuestionnaireItem>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type QuestionnaireItemIn = {
  linkId?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['String']>;
  code?: Maybe<Array<Maybe<CodingIn>>>;
  prefix?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<QuestionnaireItemType>;
  enableWhen?: Maybe<Array<Maybe<QuestionnaireEnableWhenIn>>>;
  required?: Maybe<Scalars['Boolean']>;
  repeats?: Maybe<Scalars['Boolean']>;
  readOnly?: Maybe<Scalars['Boolean']>;
  maxLength?: Maybe<Scalars['Float']>;
  options?: Maybe<ReferenceIn>;
  option?: Maybe<Array<Maybe<QuestionnaireOptionIn>>>;
  initialBoolean?: Maybe<Scalars['Boolean']>;
  initialDecimal?: Maybe<Scalars['Float']>;
  initialInteger?: Maybe<Scalars['Float']>;
  initialDate?: Maybe<Scalars['String']>;
  initialDateTime?: Maybe<Scalars['String']>;
  initialTime?: Maybe<Scalars['String']>;
  initialString?: Maybe<Scalars['String']>;
  initialUri?: Maybe<Scalars['String']>;
  initialAttachment?: Maybe<AttachmentIn>;
  initialCoding?: Maybe<CodingIn>;
  initialQuantity?: Maybe<QuantityIn>;
  initialReference?: Maybe<ReferenceIn>;
  item?: Maybe<Array<Maybe<QuestionnaireItemIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum QuestionnaireItemType {
  group = 'group',
  display = 'display',
  boolean = 'boolean',
  decimal = 'decimal',
  integer = 'integer',
  date = 'date',
  dateTime = 'dateTime',
  time = 'time',
  string = 'string',
  text = 'text',
  url = 'url',
  choice = 'choice',
  open_choice = 'open_choice',
  attachment = 'attachment',
  reference = 'reference',
  quantity = 'quantity',
}

export type QuestionnaireOption = {
  __typename: 'QuestionnaireOption';
  valueInteger?: Maybe<Scalars['Float']>;
  valueDate?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueCoding?: Maybe<Coding>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type QuestionnaireOptionIn = {
  valueInteger?: Maybe<Scalars['Float']>;
  valueDate?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueCoding?: Maybe<CodingIn>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum QuestionnaireResourceType {
  Questionnaire = 'Questionnaire',
}

export type QuestionnaireResponse = {
  __typename: 'QuestionnaireResponse';
  resourceType: QuestionnaireResponseResourceType;
  identifier?: Maybe<Identifier>;
  basedOn?: Maybe<Array<Reference>>;
  parent?: Maybe<Array<Reference>>;
  questionnaire?: Maybe<Reference>;
  status?: Maybe<QuestionnaireResponseStatus>;
  subject?: Maybe<Reference>;
  context?: Maybe<Reference>;
  authored?: Maybe<Scalars['String']>;
  author?: Maybe<Reference>;
  source?: Maybe<Reference>;
  item?: Maybe<Array<QuestionnaireResponseItem>>;
  text?: Maybe<Narrative>;
  contained?: Maybe<Array<ResourceList>>;
  extension?: Maybe<Array<Extension>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Meta>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type QuestionnaireResponseAnswer = {
  __typename: 'QuestionnaireResponseAnswer';
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueAttachment?: Maybe<Attachment>;
  valueCoding?: Maybe<Coding>;
  valueQuantity?: Maybe<Quantity>;
  valueReference?: Maybe<Reference>;
  item?: Maybe<Array<QuestionnaireResponseItem>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type QuestionnaireResponseAnswerIn = {
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueAttachment?: Maybe<AttachmentIn>;
  valueCoding?: Maybe<CodingIn>;
  valueQuantity?: Maybe<QuantityIn>;
  valueReference?: Maybe<ReferenceIn>;
  item?: Maybe<Array<Maybe<QuestionnaireResponseItemIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type QuestionnaireResponseEdge = {
  __typename: 'QuestionnaireResponseEdge';
  node: QuestionnaireResponse;
};

export type QuestionnaireResponseIn = {
  resourceType: QuestionnaireResponseResourceType;
  identifier?: Maybe<IdentifierIn>;
  basedOn?: Maybe<Array<Maybe<ReferenceIn>>>;
  parent?: Maybe<Array<Maybe<ReferenceIn>>>;
  questionnaire?: Maybe<ReferenceIn>;
  status?: Maybe<QuestionnaireResponseStatus>;
  subject?: Maybe<ReferenceIn>;
  context?: Maybe<ReferenceIn>;
  authored?: Maybe<Scalars['String']>;
  author?: Maybe<ReferenceIn>;
  source?: Maybe<ReferenceIn>;
  item?: Maybe<Array<Maybe<QuestionnaireResponseItemIn>>>;
  text?: Maybe<NarrativeIn>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<MetaIn>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type QuestionnaireResponseItem = {
  __typename: 'QuestionnaireResponseItem';
  linkId?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  subject?: Maybe<Reference>;
  answer?: Maybe<Array<QuestionnaireResponseAnswer>>;
  item?: Maybe<Array<QuestionnaireResponseItem>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type QuestionnaireResponseItemIn = {
  linkId?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  subject?: Maybe<ReferenceIn>;
  answer?: Maybe<Array<Maybe<QuestionnaireResponseAnswerIn>>>;
  item?: Maybe<Array<Maybe<QuestionnaireResponseItemIn>>>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum QuestionnaireResponseResourceType {
  QuestionnaireResponse = 'QuestionnaireResponse',
}

export type QuestionnaireResponsesConnection = {
  __typename: 'QuestionnaireResponsesConnection';
  edges: Array<QuestionnaireResponseEdge>;
  pageInfo: PageInfo;
};

export enum QuestionnaireResponseStatus {
  in_progress = 'in_progress',
  completed = 'completed',
  amended = 'amended',
  entered_in_error = 'entered_in_error',
  stopped = 'stopped',
}

export enum QuestionnaireStatus {
  draft = 'draft',
  active = 'active',
  retired = 'retired',
  unknown = 'unknown',
}

export enum Race {
  asian = 'asian',
  black = 'black',
  nativeAmerican = 'nativeAmerican',
  pacificIslander = 'pacificIslander',
  white = 'white',
  other = 'other',
}

export type RaceRestriction = {
  __typename: 'RaceRestriction';
  allowed: Array<Race>;
};

export type RaceRestrictionInput = {
  allowed?: Maybe<Array<Race>>;
};

export type Range = {
  __typename: 'Range';
  low?: Maybe<Quantity>;
  high?: Maybe<Quantity>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type RangeIn = {
  low?: Maybe<QuantityIn>;
  high?: Maybe<QuantityIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type Ratio = {
  __typename: 'Ratio';
  numerator?: Maybe<Quantity>;
  denominator?: Maybe<Quantity>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type RatioIn = {
  numerator?: Maybe<QuantityIn>;
  denominator?: Maybe<QuantityIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type Reaction = {
  __typename: 'Reaction';
  id: Scalars['ID'];
  postId: Scalars['ID'];
  userId: Scalars['String'];
  type: Scalars['Emoji'];
  /**
   * a comment that the user has left with the reaction, useful for detailed reactions to a post that do not
   * belong as a discrete post. For example, a user might react to a system generated post with a thumbs down
   * and a comment "This is wrong because...". This comment is not a post, but a reaction to the post.
   */
  comment?: Maybe<Scalars['String']>;
  author?: Maybe<User>;
};

export type ReactionConnection = {
  __typename: 'ReactionConnection';
  edges: Array<ReactionEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type ReactionEdge = {
  __typename: 'ReactionEdge';
  node: Reaction;
};

export type ReactionNotification = Notification & {
  __typename: 'ReactionNotification';
  post: Post;
  parentPost: Post;
  originalPost: Post;
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  notificationUserId: Scalars['ID'];
  postId: Scalars['ID'];
  parentId?: Maybe<Scalars['ID']>;
  originalPostId?: Maybe<Scalars['ID']>;
  batchId: Scalars['ID'];
  lastNotificationSent: Scalars['Date'];
  reactionCount: Scalars['Int'];
};

export type ReactionTotal = {
  __typename: 'ReactionTotal';
  type: Scalars['Emoji'];
  url?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  userHasReacted?: Maybe<Scalars['Boolean']>;
};

export enum Recruiting {
  pending = 'pending',
  recruiting = 'recruiting',
  enrolling = 'enrolling',
  active = 'active',
  suspended = 'suspended',
  terminated = 'terminated',
  completed = 'completed',
  withdrawn = 'withdrawn',
  unknown = 'unknown',
}

export type Reference = {
  __typename: 'Reference';
  reference?: Maybe<Scalars['String']>;
  identifier?: Maybe<Identifier>;
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type ReferenceIn = {
  reference?: Maybe<Scalars['String']>;
  identifier?: Maybe<IdentifierIn>;
  display?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type RejectInvitationResult = RejectResult | InviteDoesNotExist;

export type RejectResult = {
  __typename: 'RejectResult';
  result: Scalars['Boolean'];
};

export type RelatedArtifact = {
  __typename: 'RelatedArtifact';
  type?: Maybe<RelatedArtifactType>;
  display?: Maybe<Scalars['String']>;
  citation?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  document?: Maybe<Attachment>;
  resource?: Maybe<Reference>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type RelatedArtifactIn = {
  type?: Maybe<RelatedArtifactType>;
  display?: Maybe<Scalars['String']>;
  citation?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  document?: Maybe<AttachmentIn>;
  resource?: Maybe<ReferenceIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum RelatedArtifactType {
  documentation = 'documentation',
  justification = 'justification',
  citation = 'citation',
  predecessor = 'predecessor',
  successor = 'successor',
  derived_from = 'derived_from',
  depends_on = 'depends_on',
  composed_of = 'composed_of',
}

export type RelationshipEntriesConnection = {
  __typename: 'RelationshipEntriesConnection';
  edges: Array<RelationshipEntryEdge>;
  pageInfo: PageInfo;
};

export type RelationshipEntryEdge = {
  __typename: 'RelationshipEntryEdge';
  node: Coding;
};

export enum RelationshipType {
  RELATEDTO = 'RELATEDTO',
  EQUIVALENT = 'EQUIVALENT',
  EQUAL = 'EQUAL',
  WIDER = 'WIDER',
  SUBSUMES = 'SUBSUMES',
  NARROWER = 'NARROWER',
  SPECIALIZES = 'SPECIALIZES',
  INEXACT = 'INEXACT',
  UNMATCHED = 'UNMATCHED',
  DISJOINT = 'DISJOINT',
  BELOW = 'BELOW',
  ABOVE = 'ABOVE',
}

export type RemoveFromManagingGroupInput = {
  circleId: Scalars['ID'];
  userId: Scalars['String'];
  roleName: Scalars['String'];
};

export type RemoveFromManagingGroupResult = {
  __typename: 'RemoveFromManagingGroupResult';
  _: Scalars['Boolean'];
};

export type RemoveFromManagingGroupUnion =
  | RemoveFromManagingGroupResult
  | RemovingOnlyAdminNotAllowed;

export type RemovingOnlyAdminNotAllowed = {
  __typename: 'RemovingOnlyAdminNotAllowed';
  message?: Maybe<Scalars['String']>;
};

export type ReportInappropriatePostInput = {
  postId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
};

export type ReportMoodOptions = {
  moodId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type ReportMoodPayload = {
  __typename: 'ReportMoodPayload';
  success: Scalars['Boolean'];
};

export type RequestEmailChangeResponse =
  | RequestEmailChangeSuccess
  | EmailAlreadySetError
  | UserTypeNotAllowedError;

export type RequestEmailChangeSuccess = {
  __typename: 'RequestEmailChangeSuccess';
  success: Scalars['Boolean'];
};

export type ResourceList =
  | Observation
  | Patient
  | Procedure
  | Questionnaire
  | QuestionnaireResponse;

export type RollingAverageResponse = {
  __typename: 'RollingAverageResponse';
  average: Scalars['Float'];
};

export type SampledData = {
  __typename: 'SampledData';
  origin?: Maybe<Quantity>;
  period?: Maybe<Scalars['Float']>;
  factor?: Maybe<Scalars['Float']>;
  lowerLimit?: Maybe<Scalars['Float']>;
  upperLimit?: Maybe<Scalars['Float']>;
  dimensions?: Maybe<Scalars['Float']>;
  data?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type SampledDataIn = {
  origin?: Maybe<QuantityIn>;
  period?: Maybe<Scalars['Float']>;
  factor?: Maybe<Scalars['Float']>;
  lowerLimit?: Maybe<Scalars['Float']>;
  upperLimit?: Maybe<Scalars['Float']>;
  dimensions?: Maybe<Scalars['Float']>;
  data?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type SentPrivateUpdateNotification = Notification & {
  __typename: 'SentPrivateUpdateNotification';
  id: Scalars['ID'];
  update: Update;
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
};

export type SetCustomMoodPayload = {
  __typename: 'SetCustomMoodPayload';
  mood: CustomMood;
};

export type SetOfficialMoodPayload = {
  __typename: 'SetOfficialMoodPayload';
  mood: OfficialMood;
};

export type Signature = {
  __typename: 'Signature';
  type?: Maybe<Array<Coding>>;
  when?: Maybe<Scalars['String']>;
  whoUri?: Maybe<Scalars['String']>;
  whoReference?: Maybe<Reference>;
  onBehalfOfUri?: Maybe<Scalars['String']>;
  onBehalfOfReference?: Maybe<Reference>;
  contentType?: Maybe<Scalars['String']>;
  blob?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type SignatureIn = {
  type?: Maybe<Array<Maybe<CodingIn>>>;
  when?: Maybe<Scalars['String']>;
  whoUri?: Maybe<Scalars['String']>;
  whoReference?: Maybe<ReferenceIn>;
  onBehalfOfUri?: Maybe<Scalars['String']>;
  onBehalfOfReference?: Maybe<ReferenceIn>;
  contentType?: Maybe<Scalars['String']>;
  blob?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type SkillSpringCircleConfig = {
  __typename: 'SkillSpringCircleConfig';
  account?: Maybe<Scalars['String']>;
  expertId?: Maybe<Scalars['String']>;
  /** An ExpertiseSource resolved according to the saved configuration */
  expert?: Maybe<ExpertiseSource>;
};

export type SkillSpringCoachingConfig = {
  __typename: 'SkillSpringCoachingConfig';
  account: Scalars['String'];
  directory?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<SkillSpringImage>;
};

/**
 * Currently SkillSpringCoupon is strictly a subtype
 * of Coupon (from @lifeomic/connect-schema).  This keeps
 * the schema stitching very simple but allows for easier
 * additions/modifications to this schema in the future
 */
export type SkillSpringCoupon = {
  __typename: 'SkillSpringCoupon';
  /** The coupon's unique identifier. */
  id: Scalars['String'];
  /** The date the coupon was created. */
  creationDate: Scalars['Date'];
  /** The coupon's expiration date. */
  expirationDate: Scalars['Date'];
  /** The maximum value of the coupon in pennies. */
  maximumValue: Scalars['Int'];
  /** The portion of the cost of conversations that the coupon will cover. A number between 0 and 1. */
  percentDiscount: Scalars['Float'];
  /** The coupon's description. */
  description: Scalars['String'];
};

export type SkillSpringCouponConnection = {
  __typename: 'SkillSpringCouponConnection';
  edges: Array<SkillSpringCouponEdge>;
};

export type SkillSpringCouponEdge = {
  __typename: 'SkillSpringCouponEdge';
  node: SkillSpringCoupon;
};

export type SkillSpringImage = {
  __typename: 'SkillSpringImage';
  url: Scalars['URL'];
};

export type SkillSpringTileBehavior = {
  __typename: 'SkillSpringTileBehavior';
  /** The SkillSpring account of the coaching service provider. */
  skillSpringAccount: Scalars['String'];
  /**
   * A SkillSpring directory to narrow down the available coaching experts for
   * this tile.
   */
  directory?: Maybe<Scalars['String']>;
};

export type SocialCircleServiceUserPrivacyPreferences = {
  __typename: 'SocialCircleServiceUserPrivacyPreferences';
  PUBLIC_CIRCLES?: Maybe<PrivacyPreferenceSetting>;
};

export type SocialCircleServiceUserPrivacyPreferencesIn = {
  PUBLIC_CIRCLES?: Maybe<PrivacyPreferenceSetting>;
};

export enum Source {
  CT = 'CT',
  JAX = 'JAX',
}

export type Status = {
  __typename: 'Status';
  state: Recruiting;
  phases?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type StatusFilter = {
  states?: Maybe<Array<Recruiting>>;
  phases?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type StatusFilterSummary = {
  __typename: 'StatusFilterSummary';
  states?: Maybe<Array<Recruiting>>;
  phases?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type StatusUpdate = Update & {
  __typename: 'StatusUpdate';
  id: Scalars['ID'];
  /** The time of the update. */
  time: Scalars['Date'];
  /**
   * When the update content was last edited. A null value indicates that the
   * update has never been modified after the original creation.
   */
  lastEdited?: Maybe<Scalars['Date']>;
  /**
   * The cannonical ID of the user who posted the update.
   * @deprecated use author
   */
  user: Scalars['String'];
  /** The user who posted the update. */
  author: User;
  /** Human readable text that can be used as a fallback */
  text: Scalars['String'];
  /** The post content */
  content: Scalars['String'];
  /** Urls to images associated with this update */
  imageUrls: Array<Scalars['URL']>;
  /**
   * Username of users who were tagged in this update
   * @deprecated use taggedFullUsers
   */
  taggedUsers: Array<Scalars['String']>;
  /** Users who were tagged in this update */
  taggedFullUsers: Array<User>;
  /**
   * Optional headline
   * @deprecated not actively used, considered for future removal
   */
  headline?: Maybe<Scalars['String']>;
  /** Recipient user of a private status update */
  recipientUser?: Maybe<Scalars['String']>;
  /**
   * An "access token" of sorts that can be used to re-fetch the update by
   * ID using the update(id: ID!) query.
   */
  proofOfAccess?: Maybe<Scalars['String']>;
  /** Connection for retrieving comments */
  commentsConnection: UpdateCommentsConnection;
  /** Connection for retrieving likes */
  likesConnection: UpdateLikesConnection;
  liked: Scalars['Boolean'];
  recipientFullUser?: Maybe<User>;
};

export type StatusUpdatecommentsConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type StatusUpdatelikesConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  eq?: Maybe<Scalars['String']>;
  and?: Maybe<Array<Scalars['String']>>;
  or?: Maybe<Array<Scalars['String']>>;
};

export type StringFilterSummary = {
  __typename: 'StringFilterSummary';
  eq?: Maybe<Scalars['String']>;
  and?: Maybe<Array<Maybe<Scalars['String']>>>;
  or?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StripeConnectAccount = {
  __typename: 'StripeConnectAccount';
  /** Internal entity id used to map to external Stripe Account */
  id: Scalars['ID'];
  userId: Scalars['ID'];
  /** Indicates if this account is ready to accept charges or not */
  chargesEnabled: Scalars['Boolean'];
  /** Last four digits of default bank or card where account receives payouts */
  lastFour?: Maybe<Scalars['String']>;
  /** Time at which the account was created */
  createdAt: Scalars['Date'];
  /** Status of the account based on users information provided (e,g. all info provided, info needed, etc.) */
  status: StripeConnectAccountStatusEnum;
};

export type StripeConnectAccountConnection = {
  __typename: 'StripeConnectAccountConnection';
  edges: Array<StripeConnectAccountEdge>;
  pageInfo: PageInfo;
};

export type StripeConnectAccountEdge = {
  __typename: 'StripeConnectAccountEdge';
  node: StripeConnectAccount;
};

/** Based on the status Stripe provides in Connected Accounts section of dashboard */
export enum StripeConnectAccountStatusEnum {
  /** No info is currently or eventually due */
  COMPLETE = 'COMPLETE',
  /** Some info is being proccessed and verified by Stripe */
  PENDING = 'PENDING',
  /** Some info needs to be updated soon */
  RESTRICTED_SOON = 'RESTRICTED_SOON',
  /** Some info needs to be updated */
  RESTRICTED = 'RESTRICTED',
}

export type SubscribedToCircleNotification = Notification & {
  __typename: 'SubscribedToCircleNotification';
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  circleId: Scalars['ID'];
  fullText: Scalars['String'];
  circle?: Maybe<Circle>;
};

export type SubscriptionCircleSession = {
  __typename: 'SubscriptionCircleSession';
  /** The session id used on the client to forward user to Stripe Checkout session */
  sessionId?: Maybe<Scalars['ID']>;
};

export type SubscriptionStatus = {
  __typename: 'SubscriptionStatus';
  subscriberId?: Maybe<Scalars['String']>;
  lifeAppsSubscriptionTier: LifeAppsSubscriptionTier;
  subscribersCircleId: Scalars['ID'];
  subscribersCircle?: Maybe<Circle>;
};

export type Subsidy = {
  __typename: 'Subsidy';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  title: Scalars['String'];
  status: SubsidyStatus;
};

export type SubsidyStatus = {
  __typename: 'SubsidyStatus';
  maxSpend: Scalars['Int'];
  totalSpent: Scalars['Int'];
  before: Scalars['String'];
  after: Scalars['String'];
};

export type Summary = {
  __typename: 'Summary';
  trialId?: Maybe<StringFilterSummary>;
  title?: Maybe<StringFilterSummary>;
  organization?: Maybe<StringFilterSummary>;
  summary?: Maybe<StringFilterSummary>;
  description?: Maybe<StringFilterSummary>;
  eligibility?: Maybe<EligibilityFilterSummary>;
  locations?: Maybe<Array<LocationFilterSummary>>;
  status?: Maybe<StatusFilterSummary>;
  intervention?: Maybe<InterventionFilterSummary>;
};

export type SurveyAssignedNotification = Notification & {
  __typename: 'SurveyAssignedNotification';
  id: Scalars['ID'];
  account: Scalars['String'];
  projectId: Scalars['ID'];
  questionnaireResponseId: Scalars['ID'];
  surveyName: Scalars['String'];
  organizationName: Scalars['String'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
};

export type SurveyAttachmentDownloadResults = {
  __typename: 'SurveyAttachmentDownloadResults';
  id: Scalars['ID'];
  name: Scalars['String'];
  datasetId: Scalars['ID'];
  size: Scalars['Int'];
  contentType: Scalars['String'];
  lastModified: Scalars['Date'];
  userId: Scalars['String'];
  lrn: Scalars['String'];
  downloadUrl: Scalars['String'];
};

export type SurveyAttachmentDownloadUrlInput = {
  projectId: Scalars['ID'];
  linkId: Scalars['ID'];
  questionnaireId: Scalars['ID'];
  photoId: Scalars['ID'];
};

export type SurveyAttachmentUploadResults = {
  __typename: 'SurveyAttachmentUploadResults';
  id: Scalars['ID'];
  name: Scalars['String'];
  datasetId: Scalars['ID'];
  contentType: Scalars['String'];
  uploadId: Scalars['String'];
  userId: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type SurveyAttachmentUploadUrlInput = {
  projectId: Scalars['ID'];
  questionnaireId: Scalars['ID'];
  linkId: Scalars['ID'];
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};

export type Tag = {
  id: Scalars['String'];
  project: Scalars['String'];
};

export type TagInUpdateNotification = Notification & {
  __typename: 'TagInUpdateNotification';
  id: Scalars['ID'];
  update: Update;
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
};

export type Tags = {
  __typename: 'Tags';
  intensity: Array<Scalars['String']>;
  equipment: Array<Scalars['String']>;
  level: Array<Scalars['String']>;
  category: Array<Scalars['String']>;
  instructor: Array<Scalars['String']>;
  language: Array<Scalars['String']>;
};

export type TagsFilter = {
  category?: Maybe<Array<Scalars['String']>>;
  equipment?: Maybe<Array<Scalars['String']>>;
  instructor?: Maybe<Array<Scalars['String']>>;
  intensity?: Maybe<Array<Scalars['String']>>;
  language?: Maybe<Array<Scalars['String']>>;
  level?: Maybe<Array<Scalars['String']>>;
};

export type TagsValuesResult = {
  __typename: 'TagsValuesResult';
  category: Array<Scalars['String']>;
  equipment: Array<Scalars['String']>;
  instructor: Array<Scalars['String']>;
  intensity: Array<Scalars['String']>;
  language: Array<Scalars['String']>;
  level: Array<Scalars['String']>;
};

export type TagTrials = {
  __typename: 'TagTrials';
  trials?: Maybe<Array<Maybe<Trial>>>;
  hits: Scalars['Int'];
};

export type Task = {
  __typename: 'Task';
  resourceType: TaskResourceType;
  identifier?: Maybe<Array<Identifier>>;
  definitionUri?: Maybe<Scalars['String']>;
  definitionReference?: Maybe<Reference>;
  basedOn?: Maybe<Array<Reference>>;
  groupIdentifier?: Maybe<Identifier>;
  partOf?: Maybe<Array<Reference>>;
  status: TaskStatus;
  statusReason?: Maybe<CodeableConcept>;
  businessStatus?: Maybe<CodeableConcept>;
  intent: Scalars['String'];
  priority?: Maybe<Scalars['String']>;
  code?: Maybe<CodeableConcept>;
  description?: Maybe<Scalars['String']>;
  focus?: Maybe<Reference>;
  for?: Maybe<Reference>;
  context?: Maybe<Reference>;
  executionPeriod?: Maybe<Period>;
  authoredOn?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['String']>;
  requester?: Maybe<TaskRequester>;
  performerType?: Maybe<Array<CodeableConcept>>;
  owner?: Maybe<Reference>;
  reason?: Maybe<CodeableConcept>;
  note?: Maybe<Array<Annotation>>;
  relevantHistory?: Maybe<Array<Reference>>;
  restriction?: Maybe<TaskRestriction>;
  input?: Maybe<Array<TaskInput>>;
  output?: Maybe<Array<TaskOutput>>;
  text?: Maybe<Narrative>;
  contained?: Maybe<Array<ResourceList>>;
  extension?: Maybe<Array<Extension>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<Meta>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type TaskIn = {
  resourceType: TaskResourceType;
  identifier?: Maybe<Array<IdentifierIn>>;
  definitionUri?: Maybe<Scalars['String']>;
  definitionReference?: Maybe<ReferenceIn>;
  basedOn?: Maybe<Array<ReferenceIn>>;
  groupIdentifier?: Maybe<IdentifierIn>;
  partOf?: Maybe<Array<ReferenceIn>>;
  status?: Maybe<TaskStatus>;
  statusReason?: Maybe<CodeableConceptIn>;
  businessStatus?: Maybe<CodeableConceptIn>;
  intent?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  code?: Maybe<CodeableConceptIn>;
  description?: Maybe<Scalars['String']>;
  focus?: Maybe<ReferenceIn>;
  for?: Maybe<ReferenceIn>;
  context?: Maybe<ReferenceIn>;
  executionPeriod?: Maybe<PeriodIn>;
  authoredOn?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['String']>;
  requester?: Maybe<TaskRequesterIn>;
  performerType?: Maybe<Array<CodeableConceptIn>>;
  owner?: Maybe<ReferenceIn>;
  reason?: Maybe<CodeableConceptIn>;
  note?: Maybe<Array<AnnotationIn>>;
  relevantHistory?: Maybe<Array<ReferenceIn>>;
  restriction?: Maybe<TaskRestrictionIn>;
  input?: Maybe<Array<TaskInputIn>>;
  output?: Maybe<Array<TaskOutputIn>>;
  text?: Maybe<NarrativeIn>;
  extension?: Maybe<Array<ExtensionIn>>;
  modifierExtension?: Maybe<Array<ExtensionIn>>;
  id?: Maybe<Scalars['String']>;
  meta?: Maybe<MetaIn>;
  implicitRules?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type TaskInput = {
  __typename: 'TaskInput';
  type: CodeableConcept;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueBase64Binary?: Maybe<Scalars['String']>;
  valueInstant?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueCode?: Maybe<Scalars['String']>;
  valueOid?: Maybe<Scalars['String']>;
  valueUuid?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['String']>;
  valueUnsignedInt?: Maybe<Scalars['Float']>;
  valuePositiveInt?: Maybe<Scalars['Float']>;
  valueMarkdown?: Maybe<Scalars['String']>;
  valueElement?: Maybe<Element>;
  valueExtension?: Maybe<Extension>;
  valueBackboneElement?: Maybe<BackboneElement>;
  valueNarrative?: Maybe<Narrative>;
  valueAnnotation?: Maybe<Annotation>;
  valueAttachment?: Maybe<Attachment>;
  valueIdentifier?: Maybe<Identifier>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueCoding?: Maybe<Coding>;
  valueQuantity?: Maybe<Quantity>;
  valueDuration?: Maybe<Duration>;
  valueSimpleQuantity?: Maybe<Quantity>;
  valueDistance?: Maybe<Distance>;
  valueCount?: Maybe<Count>;
  valueMoney?: Maybe<Money>;
  valueAge?: Maybe<Age>;
  valueRange?: Maybe<Range>;
  valuePeriod?: Maybe<Period>;
  valueRatio?: Maybe<Ratio>;
  valueReference?: Maybe<Reference>;
  valueSampledData?: Maybe<SampledData>;
  valueSignature?: Maybe<Signature>;
  valueHumanName?: Maybe<HumanName>;
  valueAddress?: Maybe<Address>;
  valueContactPoint?: Maybe<ContactPoint>;
  valueTiming?: Maybe<Timing>;
  valueMeta?: Maybe<Meta>;
  valueElementDefinition?: Maybe<ElementDefinition>;
  valueContactDetail?: Maybe<ContactDetail>;
  valueContributor?: Maybe<Contributor>;
  valueDosage?: Maybe<Dosage>;
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  valueUsageContext?: Maybe<UsageContext>;
  valueDataRequirement?: Maybe<DataRequirement>;
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type TaskInputIn = {
  type: CodeableConceptIn;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueBase64Binary?: Maybe<Scalars['String']>;
  valueInstant?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueCode?: Maybe<Scalars['String']>;
  valueOid?: Maybe<Scalars['String']>;
  valueUuid?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['String']>;
  valueUnsignedInt?: Maybe<Scalars['Float']>;
  valuePositiveInt?: Maybe<Scalars['Float']>;
  valueMarkdown?: Maybe<Scalars['String']>;
  valueElement?: Maybe<ElementIn>;
  valueExtension?: Maybe<ExtensionIn>;
  valueBackboneElement?: Maybe<BackboneElementIn>;
  valueNarrative?: Maybe<NarrativeIn>;
  valueAnnotation?: Maybe<AnnotationIn>;
  valueAttachment?: Maybe<AttachmentIn>;
  valueIdentifier?: Maybe<IdentifierIn>;
  valueCodeableConcept?: Maybe<CodeableConceptIn>;
  valueCoding?: Maybe<CodingIn>;
  valueQuantity?: Maybe<QuantityIn>;
  valueDuration?: Maybe<DurationIn>;
  valueSimpleQuantity?: Maybe<QuantityIn>;
  valueDistance?: Maybe<DistanceIn>;
  valueCount?: Maybe<CountIn>;
  valueMoney?: Maybe<MoneyIn>;
  valueAge?: Maybe<AgeIn>;
  valueRange?: Maybe<RangeIn>;
  valuePeriod?: Maybe<PeriodIn>;
  valueRatio?: Maybe<RatioIn>;
  valueReference?: Maybe<ReferenceIn>;
  valueSampledData?: Maybe<SampledDataIn>;
  valueSignature?: Maybe<SignatureIn>;
  valueHumanName?: Maybe<HumanNameIn>;
  valueAddress?: Maybe<AddressIn>;
  valueContactPoint?: Maybe<ContactPointIn>;
  valueTiming?: Maybe<TimingIn>;
  valueMeta?: Maybe<MetaIn>;
  valueElementDefinition?: Maybe<ElementDefinitionIn>;
  valueContactDetail?: Maybe<ContactDetailIn>;
  valueContributor?: Maybe<ContributorIn>;
  valueDosage?: Maybe<DosageIn>;
  valueRelatedArtifact?: Maybe<RelatedArtifactIn>;
  valueUsageContext?: Maybe<UsageContextIn>;
  valueDataRequirement?: Maybe<DataRequirementIn>;
  valueParameterDefinition?: Maybe<ParameterDefinitionIn>;
  valueTriggerDefinition?: Maybe<TriggerDefinitionIn>;
  modifierExtension?: Maybe<Array<ExtensionIn>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ExtensionIn>>;
};

export type TaskOutput = {
  __typename: 'TaskOutput';
  type: CodeableConcept;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueBase64Binary?: Maybe<Scalars['String']>;
  valueInstant?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueCode?: Maybe<Scalars['String']>;
  valueOid?: Maybe<Scalars['String']>;
  valueUuid?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['String']>;
  valueUnsignedInt?: Maybe<Scalars['Float']>;
  valuePositiveInt?: Maybe<Scalars['Float']>;
  valueMarkdown?: Maybe<Scalars['String']>;
  valueElement?: Maybe<Element>;
  valueExtension?: Maybe<Extension>;
  valueBackboneElement?: Maybe<BackboneElement>;
  valueNarrative?: Maybe<Narrative>;
  valueAnnotation?: Maybe<Annotation>;
  valueAttachment?: Maybe<Attachment>;
  valueIdentifier?: Maybe<Identifier>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueCoding?: Maybe<Coding>;
  valueQuantity?: Maybe<Quantity>;
  valueDuration?: Maybe<Duration>;
  valueSimpleQuantity?: Maybe<Quantity>;
  valueDistance?: Maybe<Distance>;
  valueCount?: Maybe<Count>;
  valueMoney?: Maybe<Money>;
  valueAge?: Maybe<Age>;
  valueRange?: Maybe<Range>;
  valuePeriod?: Maybe<Period>;
  valueRatio?: Maybe<Ratio>;
  valueReference?: Maybe<Reference>;
  valueSampledData?: Maybe<SampledData>;
  valueSignature?: Maybe<Signature>;
  valueHumanName?: Maybe<HumanName>;
  valueAddress?: Maybe<Address>;
  valueContactPoint?: Maybe<ContactPoint>;
  valueTiming?: Maybe<Timing>;
  valueMeta?: Maybe<Meta>;
  valueElementDefinition?: Maybe<ElementDefinition>;
  valueContactDetail?: Maybe<ContactDetail>;
  valueContributor?: Maybe<Contributor>;
  valueDosage?: Maybe<Dosage>;
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  valueUsageContext?: Maybe<UsageContext>;
  valueDataRequirement?: Maybe<DataRequirement>;
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type TaskOutputIn = {
  type: CodeableConceptIn;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueInteger?: Maybe<Scalars['Float']>;
  valueDecimal?: Maybe<Scalars['Float']>;
  valueBase64Binary?: Maybe<Scalars['String']>;
  valueInstant?: Maybe<Scalars['String']>;
  valueString?: Maybe<Scalars['String']>;
  valueUri?: Maybe<Scalars['String']>;
  valueDate?: Maybe<Scalars['String']>;
  valueDateTime?: Maybe<Scalars['String']>;
  valueTime?: Maybe<Scalars['String']>;
  valueCode?: Maybe<Scalars['String']>;
  valueOid?: Maybe<Scalars['String']>;
  valueUuid?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['String']>;
  valueUnsignedInt?: Maybe<Scalars['Float']>;
  valuePositiveInt?: Maybe<Scalars['Float']>;
  valueMarkdown?: Maybe<Scalars['String']>;
  valueElement?: Maybe<ElementIn>;
  valueExtension?: Maybe<ExtensionIn>;
  valueBackboneElement?: Maybe<BackboneElementIn>;
  valueNarrative?: Maybe<NarrativeIn>;
  valueAnnotation?: Maybe<AnnotationIn>;
  valueAttachment?: Maybe<AttachmentIn>;
  valueIdentifier?: Maybe<IdentifierIn>;
  valueCodeableConcept?: Maybe<CodeableConceptIn>;
  valueCoding?: Maybe<CodingIn>;
  valueQuantity?: Maybe<QuantityIn>;
  valueDuration?: Maybe<DurationIn>;
  valueSimpleQuantity?: Maybe<QuantityIn>;
  valueDistance?: Maybe<DistanceIn>;
  valueCount?: Maybe<CountIn>;
  valueMoney?: Maybe<MoneyIn>;
  valueAge?: Maybe<AgeIn>;
  valueRange?: Maybe<RangeIn>;
  valuePeriod?: Maybe<PeriodIn>;
  valueRatio?: Maybe<RatioIn>;
  valueReference?: Maybe<ReferenceIn>;
  valueSampledData?: Maybe<SampledDataIn>;
  valueSignature?: Maybe<SignatureIn>;
  valueHumanName?: Maybe<HumanNameIn>;
  valueAddress?: Maybe<AddressIn>;
  valueContactPoint?: Maybe<ContactPointIn>;
  valueTiming?: Maybe<TimingIn>;
  valueMeta?: Maybe<MetaIn>;
  valueElementDefinition?: Maybe<ElementDefinitionIn>;
  valueContactDetail?: Maybe<ContactDetailIn>;
  valueContributor?: Maybe<ContributorIn>;
  valueDosage?: Maybe<DosageIn>;
  valueRelatedArtifact?: Maybe<RelatedArtifactIn>;
  valueUsageContext?: Maybe<UsageContextIn>;
  valueDataRequirement?: Maybe<DataRequirementIn>;
  valueParameterDefinition?: Maybe<ParameterDefinitionIn>;
  valueTriggerDefinition?: Maybe<TriggerDefinitionIn>;
  modifierExtension?: Maybe<Array<ExtensionIn>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ExtensionIn>>;
};

export type TaskRequester = {
  __typename: 'TaskRequester';
  agent: Reference;
  onBehalfOf?: Maybe<Reference>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type TaskRequesterIn = {
  agent: ReferenceIn;
  onBehalfOf?: Maybe<ReferenceIn>;
  modifierExtension?: Maybe<Array<ExtensionIn>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ExtensionIn>>;
};

export enum TaskResourceType {
  Task = 'Task',
}

export type TaskRestriction = {
  __typename: 'TaskRestriction';
  repetitions?: Maybe<Scalars['Float']>;
  period?: Maybe<Period>;
  recipient?: Maybe<Array<Reference>>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type TaskRestrictionIn = {
  repetitions?: Maybe<Scalars['Float']>;
  period?: Maybe<PeriodIn>;
  recipient?: Maybe<Array<ReferenceIn>>;
  modifierExtension?: Maybe<Array<ExtensionIn>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ExtensionIn>>;
};

export enum TaskStatus {
  draft = 'draft',
  requested = 'requested',
  received = 'received',
  accepted = 'accepted',
  rejected = 'rejected',
  ready = 'ready',
  cancelled = 'cancelled',
  in_progress = 'in_progress',
  on_hold = 'on_hold',
  failed = 'failed',
  completed = 'completed',
  entered_in_error = 'entered_in_error',
}

export type Thumbnail = {
  __typename: 'Thumbnail';
  xsmall: Scalars['String'];
  small: Scalars['String'];
  medium: Scalars['String'];
  large: Scalars['String'];
  orig: Scalars['String'];
};

/**
 * The idea is to gradually move from AppStoreApplication to Tile, where each
 * type of tile can have a different behavior.
 */
export type Tile = {
  __typename: 'Tile';
  id: Scalars['ID'];
  name: Scalars['String'];
  image: Scalars['URL'];
  /**
   * Determines how the tile will behave client side. For example, it could open
   * a URL with some auth data, or it could open the SkillSpring widget pointing
   * to a specific directory.
   */
  behavior: TileBehavior;
};

export type TileBehavior =
  | LaunchUrlTileBehavior
  | WebAppletTileBehavior
  | SkillSpringTileBehavior;

export type TileConnection = {
  __typename: 'TileConnection';
  edges: Array<TileEdge>;
  pageInfo: PageInfo;
};

export type TileEdge = {
  __typename: 'TileEdge';
  node: Tile;
};

export type Timing = {
  __typename: 'Timing';
  event?: Maybe<Array<Scalars['String']>>;
  repeat?: Maybe<TimingRepeat>;
  code?: Maybe<CodeableConcept>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type TimingIn = {
  event?: Maybe<Array<Scalars['String']>>;
  repeat?: Maybe<TimingRepeatIn>;
  code?: Maybe<CodeableConceptIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type TimingRepeat = {
  __typename: 'TimingRepeat';
  boundsDuration?: Maybe<Duration>;
  boundsRange?: Maybe<Range>;
  boundsPeriod?: Maybe<Period>;
  count?: Maybe<Scalars['Float']>;
  countMax?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  durationMax?: Maybe<Scalars['Float']>;
  durationUnit?: Maybe<TimingRepeatDurationUnit>;
  frequency?: Maybe<Scalars['Float']>;
  frequencyMax?: Maybe<Scalars['Float']>;
  period?: Maybe<Scalars['Float']>;
  periodMax?: Maybe<Scalars['Float']>;
  periodUnit?: Maybe<TimingRepeatPeriodUnit>;
  dayOfWeek?: Maybe<Array<Scalars['String']>>;
  timeOfDay?: Maybe<Array<Scalars['String']>>;
  when?: Maybe<Array<TimingRepeatWhen>>;
  offset?: Maybe<Scalars['Float']>;
  modifierExtension?: Maybe<Array<Extension>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export enum TimingRepeatDurationUnit {
  s = 's',
  min = 'min',
  h = 'h',
  d = 'd',
  wk = 'wk',
  mo = 'mo',
  a = 'a',
}

export type TimingRepeatIn = {
  boundsDuration?: Maybe<DurationIn>;
  boundsRange?: Maybe<RangeIn>;
  boundsPeriod?: Maybe<PeriodIn>;
  count?: Maybe<Scalars['Float']>;
  countMax?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  durationMax?: Maybe<Scalars['Float']>;
  durationUnit?: Maybe<TimingRepeatDurationUnit>;
  frequency?: Maybe<Scalars['Float']>;
  frequencyMax?: Maybe<Scalars['Float']>;
  period?: Maybe<Scalars['Float']>;
  periodMax?: Maybe<Scalars['Float']>;
  periodUnit?: Maybe<TimingRepeatPeriodUnit>;
  dayOfWeek?: Maybe<Array<Scalars['String']>>;
  timeOfDay?: Maybe<Array<Scalars['String']>>;
  when?: Maybe<Array<TimingRepeatWhen>>;
  offset?: Maybe<Scalars['Float']>;
  modifierExtension?: Maybe<Array<Maybe<ExtensionIn>>>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum TimingRepeatPeriodUnit {
  s = 's',
  min = 'min',
  h = 'h',
  d = 'd',
  wk = 'wk',
  mo = 'mo',
  a = 'a',
}

export enum TimingRepeatWhen {
  MORN = 'MORN',
  AFT = 'AFT',
  EVE = 'EVE',
  NIGHT = 'NIGHT',
  PHS = 'PHS',
  HS = 'HS',
  WAKE = 'WAKE',
  C = 'C',
  CM = 'CM',
  CD = 'CD',
  CV = 'CV',
  AC = 'AC',
  ACM = 'ACM',
  ACD = 'ACD',
  ACV = 'ACV',
  PC = 'PC',
  PCM = 'PCM',
  PCD = 'PCD',
  PCV = 'PCV',
}

export type TotalLifepointsResponse = {
  __typename: 'TotalLifepointsResponse';
  total: Scalars['Float'];
};

/** All info related to paging */
export type TotalPagedInfo = {
  __typename: 'TotalPagedInfo';
  /** Contains the current PagedInfo */
  current: PagedInfo;
  /** PagedInfo to be used to get the next set of data */
  next?: Maybe<PagedInfo>;
  /** Currently not viable. Would need to track the nextPageToken for the two previous result sets */
  previous?: Maybe<PagedInfo>;
};

export type Trial = {
  __typename: 'Trial';
  source: Array<Source>;
  trialId: Scalars['String'];
  acronym?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  fields: Array<Maybe<Field>>;
  organization?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eligibility?: Maybe<Eligibility>;
  locations?: Maybe<Array<Location>>;
  status?: Maybe<Status>;
  intervention?: Maybe<Intervention>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  isTagged?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
};

export type TrialFilter = {
  trialId?: Maybe<StringFilter>;
  basicSearch?: Maybe<Scalars['String']>;
  medicalSearch?: Maybe<StringFilter>;
  title?: Maybe<StringFilter>;
  organization?: Maybe<StringFilter>;
  summary?: Maybe<StringFilter>;
  description?: Maybe<StringFilter>;
  eligibility?: Maybe<EligibilityFilter>;
  locations?: Maybe<Array<LocationFilter>>;
  status?: Maybe<StatusFilter>;
  intervention?: Maybe<InterventionFilter>;
  condition?: Maybe<ConditionFilter>;
  molecularProfile?: Maybe<MolecularProfileFilter>;
};

export type TrialMatch = {
  __typename: 'TrialMatch';
  trials?: Maybe<Array<Maybe<Trial>>>;
  summary?: Maybe<Summary>;
  hits: Scalars['Int'];
  misses?: Maybe<Scalars['Int']>;
};

export type TrialSearch = {
  __typename: 'TrialSearch';
  trials?: Maybe<Array<Maybe<Trial>>>;
  hits: Scalars['Int'];
  misses?: Maybe<Scalars['Int']>;
  totalPagedInfo: TotalPagedInfo;
};

export type TriggerDefinition = {
  __typename: 'TriggerDefinition';
  type?: Maybe<TriggerDefinitionType>;
  eventName?: Maybe<Scalars['String']>;
  eventTimingTiming?: Maybe<Timing>;
  eventTimingReference?: Maybe<Reference>;
  eventTimingDate?: Maybe<Scalars['String']>;
  eventTimingDateTime?: Maybe<Scalars['String']>;
  eventData?: Maybe<DataRequirement>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type TriggerDefinitionIn = {
  type?: Maybe<TriggerDefinitionType>;
  eventName?: Maybe<Scalars['String']>;
  eventTimingTiming?: Maybe<TimingIn>;
  eventTimingReference?: Maybe<ReferenceIn>;
  eventTimingDate?: Maybe<Scalars['String']>;
  eventTimingDateTime?: Maybe<Scalars['String']>;
  eventData?: Maybe<DataRequirementIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export enum TriggerDefinitionType {
  named_event = 'named_event',
  periodic = 'periodic',
  data_added = 'data_added',
  data_modified = 'data_modified',
  data_removed = 'data_removed',
  data_accessed = 'data_accessed',
  data_access_ended = 'data_access_ended',
}

export type UndoReactionInput = {
  postId: Scalars['ID'];
  userId: Scalars['String'];
  type: Scalars['Emoji'];
};

export type UndoReactionPayload = {
  __typename: 'UndoReactionPayload';
  reaction?: Maybe<Reaction>;
};

export type UninstallWebAppInput = {
  appId: Scalars['ID'];
  userId: Scalars['String'];
};

/**
 * The return type that will be used when an update is found
 * for the user that has an unknown type
 */
export type UnknownUpdate = Update & {
  __typename: 'UnknownUpdate';
  id: Scalars['ID'];
  /** The time of the update. */
  time: Scalars['Date'];
  /**
   * The cannonical ID of the user who posted the update.
   * @deprecated use author
   */
  user: Scalars['String'];
  /** The user who posted the update. */
  author: User;
  /** Human readable text that can be used as a fallback */
  text: Scalars['String'];
  /** Urls to images associated with this update */
  imageUrls: Array<Scalars['URL']>;
  /**
   * Username of users who were tagged in this update
   * @deprecated use taggedFullUsers
   */
  taggedUsers: Array<Scalars['String']>;
  /** Users who were tagged in this update */
  taggedFullUsers: Array<User>;
  /**
   * An "access token" of sorts that can be used to re-fetch the update by
   * ID using the update(id: ID!) query.
   */
  proofOfAccess?: Maybe<Scalars['String']>;
  /** Connection for retrieving comments */
  commentsConnection: UpdateCommentsConnection;
  /** Connection for retrieving likes */
  likesConnection: UpdateLikesConnection;
  liked: Scalars['Boolean'];
};

/**
 * The return type that will be used when an update is found
 * for the user that has an unknown type
 */
export type UnknownUpdatecommentsConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

/**
 * The return type that will be used when an update is found
 * for the user that has an unknown type
 */
export type UnknownUpdatelikesConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type Update = {
  id: Scalars['ID'];
  /** The time of the update. */
  time: Scalars['Date'];
  /**
   * The cannonical ID of the user who posted the update.
   * @deprecated use author
   */
  user: Scalars['String'];
  /** The user who posted the update. */
  author: User;
  /** Human readable text that can be used as a fallback */
  text: Scalars['String'];
  /** Urls to images associated with this update */
  imageUrls: Array<Scalars['URL']>;
  /**
   * Username of users who were tagged in this update
   * @deprecated use taggedFullUsers
   */
  taggedUsers: Array<Scalars['String']>;
  /** Users who were tagged in this update */
  taggedFullUsers: Array<User>;
  /**
   * An "access token" of sorts that can be used to re-fetch the update by
   * ID using the update(id: ID!) query.
   */
  proofOfAccess?: Maybe<Scalars['String']>;
  commentsConnection: UpdateCommentsConnection;
  likesConnection: UpdateLikesConnection;
  /** true if the current user has liked the update */
  liked: Scalars['Boolean'];
};

export type UpdatecommentsConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type UpdatelikesConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type UpdateCommentNotification = Notification & {
  __typename: 'UpdateCommentNotification';
  id: Scalars['ID'];
  update: Update;
  comment: Comment;
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
};

export type UpdateCommentsConnection = {
  __typename: 'UpdateCommentsConnection';
  edges: Array<UpdateCommentsEdge>;
  pageInfo: PageInfo;
};

export type UpdateCommentsEdge = {
  __typename: 'UpdateCommentsEdge';
  node: Comment;
};

export type UpdateConversationMessageInput = {
  conversationId: Scalars['ID'];
  latestMessageText: Scalars['String'];
  latestMessageTime: Scalars['Date'];
  latestMessageUserId: Scalars['ID'];
};

export type UpdateFastDurationRangeInput = {
  minimum?: Maybe<Scalars['Int']>;
  maximum?: Maybe<Scalars['Int']>;
};

export type UpdateForumSettingsInput = {
  entityId: Scalars['ID'];
  entityType?: Maybe<EntityType>;
  userSettings?: Maybe<UserSettingsUpdateInput>;
  notificationSettings?: Maybe<NotificationSettingsUpdateInput>;
};

export type UpdateForumSettingsPayload = {
  __typename: 'UpdateForumSettingsPayload';
  entityId: Scalars['ID'];
  entityType: EntityType;
  forumSettings: ForumSettings;
};

export type UpdateLifeNotificationSettingInput = {
  /**
   * The field `systemGeneratedNotificationLevel` is deprecated.
   * Do not implement further use when updating Circle or forum settings
   * for future removal.
   */
  systemGeneratedNotificationLevel?: Maybe<NotificationLevel>;
  moodUpdates?: Maybe<Scalars['Boolean']>;
  /** Expecting values in seconds. If null, fast duration notifications are turned off */
  fastDuration?: Maybe<UpdateFastDurationRangeInput>;
  joinCircle?: Maybe<Scalars['Boolean']>;
  weeklyTopLifePointUsers?: Maybe<Scalars['Boolean']>;
};

export type UpdateLikeNotification = Notification & {
  __typename: 'UpdateLikeNotification';
  id: Scalars['ID'];
  update: Update;
  like: Like;
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
};

export type UpdateLikesConnection = {
  __typename: 'UpdateLikesConnection';
  edges: Array<UpdateLikesEdge>;
  pageInfo: PageInfo;
};

export type UpdateLikesEdge = {
  __typename: 'UpdateLikesEdge';
  node: Like;
};

export type UpdateNotificationSettingsInput = {
  entityId: Scalars['ID'];
  entityType?: Maybe<EntityType>;
  notificationSettings: NotificationSettingsUpdateInput;
};

export type UpdateNotificationSettingsPayload = {
  __typename: 'UpdateNotificationSettingsPayload';
  entityId: Scalars['ID'];
  entityType: EntityType;
  forumSettings: ForumSettings;
};

export type UpdateOperations = {
  __typename: 'UpdateOperations';
  update: Update;
  reportInappropriateUpdate?: Maybe<Scalars['Boolean']>;
};

export type UpdateOperationsreportInappropriateUpdateArgs = {
  description?: Maybe<Scalars['String']>;
};

export type UpdatePostMessageInput = {
  id: Scalars['ID'];
  newMessage: Scalars['String'];
};

export type UpdatePostPayload = {
  __typename: 'UpdatePostPayload';
  post: ActivePost;
};

export type UpdatesForSingleCircleConnection = {
  __typename: 'UpdatesForSingleCircleConnection';
  edges: Array<UpdatesForSingleCircleEdge>;
  pageInfo: PageInfo;
};

export type UpdatesForSingleCircleEdge = {
  __typename: 'UpdatesForSingleCircleEdge';
  updateId: Scalars['ID'];
  node: Update;
};

export type UpdateUserSettingsInput = {
  entityId: Scalars['ID'];
  entityType?: Maybe<EntityType>;
  userSettings: UserSettingsUpdateInput;
};

export type UpdateUserSettingsPayload = {
  __typename: 'UpdateUserSettingsPayload';
  entityId: Scalars['ID'];
  entityType: EntityType;
  forumSettings: ForumSettings;
};

export type UsageContext = {
  __typename: 'UsageContext';
  code?: Maybe<Coding>;
  valueCodeableConcept?: Maybe<CodeableConcept>;
  valueQuantity?: Maybe<Quantity>;
  valueRange?: Maybe<Range>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Extension>>;
};

export type UsageContextIn = {
  code?: Maybe<CodingIn>;
  valueCodeableConcept?: Maybe<CodeableConceptIn>;
  valueQuantity?: Maybe<QuantityIn>;
  valueRange?: Maybe<RangeIn>;
  id?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<Maybe<ExtensionIn>>>;
};

export type User = {
  __typename: 'User';
  userId: Scalars['String'];
  /** UTC Date formatted as ISO string */
  userCreateDate?: Maybe<Scalars['String']>;
  lastLoginDate?: Maybe<Scalars['String']>;
  profile: UserProfile;
  localTimezone?: Maybe<Scalars['String']>;
  circlesConnection: UserCirclesConnection;
  ownedCirclesConnection: UserCirclesConnection;
  publicCirclesConnection: PublicCirclesConnection;
  fast?: Maybe<Fast>;
  lifepoints: LifePointsInfoConnection;
  averageLifepoints?: Maybe<RollingAverageResponse>;
  totalLifepoints?: Maybe<TotalLifepointsResponse>;
  weeklyLifepoints?: Maybe<LifePointsInfoConnection>;
  patient?: Maybe<Patient>;
  isBlocked: Scalars['Boolean'];
  isBlocking: Scalars['Boolean'];
  mood?: Maybe<MoodUpdate>;
  moodV2?: Maybe<MoodV2>;
  isLifePlusSubscriber: Scalars['Boolean'];
  subscriptionStatus: SubscriptionStatus;
  lifePlusSubscriptionDate?: Maybe<Scalars['Date']>;
};

export type UsercirclesConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type UserpublicCirclesConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type UserlifepointsArgs = {
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  pillarCodes?: Maybe<Array<PillarCode>>;
};

export type UseraverageLifepointsArgs = {
  date?: Maybe<Scalars['String']>;
  days?: Maybe<Scalars['Int']>;
};

export type UsertotalLifepointsArgs = {
  date?: Maybe<Scalars['String']>;
};

export type UserweeklyLifepointsArgs = {
  date?: Maybe<Scalars['String']>;
};

export type UsermoodV2Args = {
  newerThan?: Maybe<Scalars['Date']>;
};

export type UsersubscriptionStatusArgs = {
  createSubscriberIdIfNeeded?: Maybe<Scalars['Boolean']>;
};

export type UserCirclesConnection = {
  __typename: 'UserCirclesConnection';
  edges: Array<UserCirclesEdge>;
  pageInfo: PageInfo;
};

export type UserCirclesEdge = {
  __typename: 'UserCirclesEdge';
  node: Circle;
};

export type UserIn = {
  profile?: Maybe<UserProfileIn>;
};

export type UserInvitation = {
  __typename: 'UserInvitation';
  id: Scalars['ID'];
  account: Scalars['String'];
  groupId: Scalars['String'];
  signupOrLoginLink: Scalars['String'];
  purpose: Scalars['String'];
};

export type UserInvitationEdge = {
  __typename: 'UserInvitationEdge';
  node: UserInvitation;
};

export type UserInvitationsConnection = {
  __typename: 'UserInvitationsConnection';
  edges: Array<UserInvitationEdge>;
  pageInfo: PageInfo;
};

export type UserInvitationsFilterInput = {
  purpose?: Maybe<Scalars['String']>;
};

export type UserProfile = {
  __typename: 'UserProfile';
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  picture?: Maybe<Scalars['String']>;
  /** UTC Date formatted as ISO string */
  userDeletionDate?: Maybe<Scalars['String']>;
  userSummary?: Maybe<Scalars['String']>;
  identities?: Maybe<Array<Identity>>;
};

export type UserProfileIn = {
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userSummary?: Maybe<Scalars['String']>;
};

export type UserSettings = {
  __typename: 'UserSettings';
  topLevelPost: Scalars['Boolean'];
  includeLinks: Scalars['Boolean'];
  includeImages: Scalars['Boolean'];
  comment: Scalars['Boolean'];
};

export type UserSettingsInput = {
  topLevelPost?: Maybe<Scalars['Boolean']>;
  includeLinks?: Maybe<Scalars['Boolean']>;
  includeImages?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['Boolean']>;
};

export type UserSettingsUpdateInput = {
  topLevelPost?: Maybe<Scalars['Boolean']>;
  includeLinks?: Maybe<Scalars['Boolean']>;
  includeImages?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['Boolean']>;
};

export type UserTypeNotAllowedError = {
  __typename: 'UserTypeNotAllowedError';
  message: Scalars['String'];
};

export type Video = {
  id: Scalars['ID'];
};

export type VideoConnection = {
  __typename: 'VideoConnection';
  totalResults: Scalars['Int'];
  edges: Array<VideoEdge>;
  pageInfo: PageInfo;
};

export type VideoEdge = {
  __typename: 'VideoEdge';
  node: Video;
};

export type VideoFilter = {
  tags: Array<Scalars['String']>;
};

export type VideoSearchFilter = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionShort?: Maybe<Scalars['String']>;
  tags?: Maybe<TagsFilter>;
};

export type WebAppFromManifest = {
  __typename: 'WebAppFromManifest';
  /** Generated from the manifest.name property */
  name: Scalars['String'];
  /** Generated from the manifest.description property */
  description?: Maybe<Scalars['String']>;
  /** Generated from the input url and the manifest.icons['240'] property */
  image?: Maybe<Scalars['URL']>;
  /** Generated from the input URL */
  url: Scalars['URL'];
};

/** Meant to replace AppStoreWebApplication. */
export type WebAppletTileBehavior = {
  __typename: 'WebAppletTileBehavior';
  url: Scalars['URL'];
  description?: Maybe<Scalars['String']>;
  /** Optional display string - used to display the author if not LifeOmic */
  authorDisplay?: Maybe<Scalars['String']>;
};

export type WeeklyCircleWinner = {
  __typename: 'WeeklyCircleWinner';
  userId: Scalars['String'];
  user?: Maybe<User>;
  place: Scalars['Int'];
  weeklyLxp: Scalars['Float'];
};

export type WeeklyCircleWinners = {
  __typename: 'WeeklyCircleWinners';
  date?: Maybe<Scalars['String']>;
  winners: Array<WeeklyCircleWinner>;
  /**
   * Supported codes are: TooManyWinnersPlace1, TooManyWinnersPlace2, TooManyWinnersPlace3 which
   * indicate if winner couldn't be determined for one of the places. TooManyWinnersPlace1 also means
   * winner couldn't be determined for places 2 and 3. TooManyWinnersPlace2 also means winner couldn't be
   * determined for place 3.
   */
  infoCodes?: Maybe<Array<InfoCodeType>>;
};

export type WeeklyWinnersPostNotification = Notification & {
  __typename: 'WeeklyWinnersPostNotification';
  id: Scalars['ID'];
  time: Scalars['Date'];
  text: Scalars['String'];
  proofOfAccess: Scalars['String'];
  fullText: Scalars['String'];
  circleId: Scalars['ID'];
  postId: Scalars['ID'];
};

export type WeightRestriction = {
  __typename: 'WeightRestriction';
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  unit: WeightUnit;
};

export type WeightRestrictionInput = {
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  unit: WeightUnit;
};

export enum WeightUnit {
  kg = 'kg',
  lb = 'lb',
}

export const namedOperations = {
  Query: {
    PrivatePosts: 'PrivatePosts',
    UserPosts: 'UserPosts',
  },
  Mutation: {
    CreatePrivatePost: 'CreatePrivatePost',
    CreatePostReaction: 'CreatePostReaction',
  },
  Fragment: {
    PostDetails: 'PostDetails',
  },
};
export const PostDetailsFragmentDoc = gql`
  fragment PostDetails on Post {
    id
    createdAt
    parentId
    ... on ActivePost {
      message
      metadata
      author {
        userId
        profile {
          displayName
          picture
        }
      }
      attachmentsV2 {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            externalId
            url
            originalUrl
            type
            subType
            thumbnails
            status
            fileName
          }
        }
      }
    }
  }
`;
export const CreatePrivatePostDocument = gql`
  mutation CreatePrivatePost($input: CreatePrivatePostInput!) {
    createPrivatePost(input: $input) {
      post {
        ...PostDetails
      }
      conversationId
    }
  }
  ${PostDetailsFragmentDoc}
`;
export type CreatePrivatePostMutationFn = ApolloReactCommon.MutationFunction<
  CreatePrivatePostMutationResponse,
  CreatePrivatePostMutationVariables
>;

/**
 * __useCreatePrivatePostMutation__
 *
 * To run a mutation, you first call `useCreatePrivatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrivatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrivatePostMutation, { data, loading, error }] = useCreatePrivatePostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrivatePostMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePrivatePostMutationResponse,
    CreatePrivatePostMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreatePrivatePostMutationResponse,
    CreatePrivatePostMutationVariables
  >(CreatePrivatePostDocument, baseOptions);
}
export type CreatePrivatePostMutationHookResult = ReturnType<
  typeof useCreatePrivatePostMutation
>;
export type CreatePrivatePostMutationResult =
  ApolloReactCommon.MutationResult<CreatePrivatePostMutationResponse>;
export type CreatePrivatePostMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreatePrivatePostMutationResponse,
    CreatePrivatePostMutationVariables
  >;
export const CreatePostReactionDocument = gql`
  mutation CreatePostReaction($input: CreateReactionInput!) {
    createReaction(input: $input) {
      reaction {
        postId
        type
        comment
      }
    }
  }
`;
export type CreatePostReactionMutationFn = ApolloReactCommon.MutationFunction<
  CreatePostReactionMutationResponse,
  CreatePostReactionMutationVariables
>;

/**
 * __useCreatePostReactionMutation__
 *
 * To run a mutation, you first call `useCreatePostReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostReactionMutation, { data, loading, error }] = useCreatePostReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePostReactionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePostReactionMutationResponse,
    CreatePostReactionMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreatePostReactionMutationResponse,
    CreatePostReactionMutationVariables
  >(CreatePostReactionDocument, baseOptions);
}
export type CreatePostReactionMutationHookResult = ReturnType<
  typeof useCreatePostReactionMutation
>;
export type CreatePostReactionMutationResult =
  ApolloReactCommon.MutationResult<CreatePostReactionMutationResponse>;
export type CreatePostReactionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreatePostReactionMutationResponse,
    CreatePostReactionMutationVariables
  >;
export const PrivatePostsDocument = gql`
  query PrivatePosts(
    $userIds: [ID!]!
    $filter: PrivatePostFilter!
    $after: String
  ) {
    privatePosts(userIds: $userIds, filter: $filter, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...PostDetails
        }
      }
    }
  }
  ${PostDetailsFragmentDoc}
`;

/**
 * __usePrivatePostsQuery__
 *
 * To run a query within a React component, call `usePrivatePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivatePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivatePostsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePrivatePostsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PrivatePostsQueryResponse,
    PrivatePostsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    PrivatePostsQueryResponse,
    PrivatePostsQueryVariables
  >(PrivatePostsDocument, baseOptions);
}
export function usePrivatePostsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PrivatePostsQueryResponse,
    PrivatePostsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    PrivatePostsQueryResponse,
    PrivatePostsQueryVariables
  >(PrivatePostsDocument, baseOptions);
}
export type PrivatePostsQueryHookResult = ReturnType<
  typeof usePrivatePostsQuery
>;
export type PrivatePostsLazyQueryHookResult = ReturnType<
  typeof usePrivatePostsLazyQuery
>;
export type PrivatePostsQueryResult = ApolloReactCommon.QueryResult<
  PrivatePostsQueryResponse,
  PrivatePostsQueryVariables
>;
export const UserPostsDocument = gql`
  query UserPosts(
    $userIds: [ID!]!
    $projectId: ID!
    $cohortId: ID
    $filter: PrivatePostFilter!
    $after: String
  ) {
    userPosts(
      userIds: $userIds
      projectId: $projectId
      cohortId: $cohortId
      filter: $filter
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...PostDetails
        }
      }
    }
  }
  ${PostDetailsFragmentDoc}
`;

/**
 * __useUserPostsQuery__
 *
 * To run a query within a React component, call `useUserPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPostsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      projectId: // value for 'projectId'
 *      cohortId: // value for 'cohortId'
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUserPostsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserPostsQueryResponse,
    UserPostsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    UserPostsQueryResponse,
    UserPostsQueryVariables
  >(UserPostsDocument, baseOptions);
}
export function useUserPostsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserPostsQueryResponse,
    UserPostsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    UserPostsQueryResponse,
    UserPostsQueryVariables
  >(UserPostsDocument, baseOptions);
}
export type UserPostsQueryHookResult = ReturnType<typeof useUserPostsQuery>;
export type UserPostsLazyQueryHookResult = ReturnType<
  typeof useUserPostsLazyQuery
>;
export type UserPostsQueryResult = ApolloReactCommon.QueryResult<
  UserPostsQueryResponse,
  UserPostsQueryVariables
>;
export type PostDetails_ActivePost_Fragment = {
  __typename: 'ActivePost';
  message?: Maybe<string>;
  metadata?: Maybe<string>;
  id: string;
  createdAt: string;
  parentId: string;
  author?: Maybe<{
    __typename: 'User';
    userId: string;
    profile: {
      __typename: 'UserProfile';
      displayName: string;
      picture?: Maybe<string>;
    };
  }>;
  attachmentsV2: {
    __typename: 'AttachmentConnection';
    pageInfo: {
      __typename: 'PageInfo';
      endCursor?: Maybe<string>;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename: 'AttachmentEdge';
      node: {
        __typename: 'Attachment';
        id: string;
        externalId: string;
        url?: Maybe<string>;
        originalUrl?: Maybe<string>;
        type: AttachmentType;
        subType: string;
        thumbnails: Array<string>;
        status: AttachmentStatus;
        fileName?: Maybe<string>;
      };
    }>;
  };
};

export type PostDetails_DeletedPost_Fragment = {
  __typename: 'DeletedPost';
  id: string;
  createdAt: string;
  parentId: string;
};

export type PostDetailsFragment =
  | PostDetails_ActivePost_Fragment
  | PostDetails_DeletedPost_Fragment;

export type CreatePrivatePostMutationVariables = Exact<{
  input: CreatePrivatePostInput;
}>;

export type CreatePrivatePostMutationResponse = {
  __typename: 'Mutation';
  createPrivatePost: {
    __typename: 'CreatePostPayload';
    conversationId?: Maybe<string>;
    post: { __typename: 'ActivePost' } & PostDetails_ActivePost_Fragment;
  };
};

export type CreatePostReactionMutationVariables = Exact<{
  input: CreateReactionInput;
}>;

export type CreatePostReactionMutationResponse = {
  __typename: 'Mutation';
  createReaction: {
    __typename: 'CreateReactionPayload';
    reaction: {
      __typename: 'Reaction';
      postId: string;
      type: any;
      comment?: Maybe<string>;
    };
  };
};

export type PrivatePostsQueryVariables = Exact<{
  userIds: Array<Scalars['ID']>;
  filter: PrivatePostFilter;
  after?: Maybe<Scalars['String']>;
}>;

export type PrivatePostsQueryResponse = {
  __typename: 'Query';
  privatePosts: {
    __typename: 'PostConnection';
    pageInfo: {
      __typename: 'PageInfo';
      endCursor?: Maybe<string>;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename: 'PostEdge';
      node:
        | ({ __typename: 'ActivePost' } & PostDetails_ActivePost_Fragment)
        | ({ __typename: 'DeletedPost' } & PostDetails_DeletedPost_Fragment);
    }>;
  };
};

export type UserPostsQueryVariables = Exact<{
  userIds: Array<Scalars['ID']>;
  projectId: Scalars['ID'];
  cohortId?: Maybe<Scalars['ID']>;
  filter: PrivatePostFilter;
  after?: Maybe<Scalars['String']>;
}>;

export type UserPostsQueryResponse = {
  __typename: 'Query';
  userPosts: {
    __typename: 'PostConnection';
    pageInfo: {
      __typename: 'PageInfo';
      endCursor?: Maybe<string>;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename: 'PostEdge';
      node:
        | ({ __typename: 'ActivePost' } & PostDetails_ActivePost_Fragment)
        | ({ __typename: 'DeletedPost' } & PostDetails_DeletedPost_Fragment);
    }>;
  };
};
